'use strict';

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};
    var ownKeys = Object.keys(source);

    if (typeof Object.getOwnPropertySymbols === 'function') {
      ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) {
        return Object.getOwnPropertyDescriptor(source, sym).enumerable;
      }));
    }

    ownKeys.forEach(function (key) {
      _defineProperty(target, key, source[key]);
    });
  }

  return target;
}

function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _nonIterableRest();
}

function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}

function _iterableToArrayLimit(arr, i) {
  var _arr = [];
  var _n = true;
  var _d = false;
  var _e = undefined;

  try {
    for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);

      if (i && _arr.length === i) break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null) _i["return"]();
    } finally {
      if (_d) throw _e;
    }
  }

  return _arr;
}

function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance");
}

function unwrapExports (x) {
	return x && x.__esModule && Object.prototype.hasOwnProperty.call(x, 'default') ? x['default'] : x;
}

function createCommonjsModule(fn, module) {
	return module = { exports: {} }, fn(module, module.exports), module.exports;
}

// ::- Persistent data structure representing an ordered mapping from
// strings to values, with some convenient update methods.
function OrderedMap(content) {
  this.content = content;
}

OrderedMap.prototype = {
  constructor: OrderedMap,
  find: function (key) {
    for (var i = 0; i < this.content.length; i += 2) if (this.content[i] === key) return i;

    return -1;
  },
  // :: (string) → ?any
  // Retrieve the value stored under `key`, or return undefined when
  // no such key exists.
  get: function (key) {
    var found = this.find(key);
    return found == -1 ? undefined : this.content[found + 1];
  },
  // :: (string, any, ?string) → OrderedMap
  // Create a new map by replacing the value of `key` with a new
  // value, or adding a binding to the end of the map. If `newKey` is
  // given, the key of the binding will be replaced with that key.
  update: function (key, value, newKey) {
    var self = newKey && newKey != key ? this.remove(newKey) : this;
    var found = self.find(key),
        content = self.content.slice();

    if (found == -1) {
      content.push(newKey || key, value);
    } else {
      content[found + 1] = value;
      if (newKey) content[found] = newKey;
    }

    return new OrderedMap(content);
  },
  // :: (string) → OrderedMap
  // Return a map with the given key removed, if it existed.
  remove: function (key) {
    var found = this.find(key);
    if (found == -1) return this;
    var content = this.content.slice();
    content.splice(found, 2);
    return new OrderedMap(content);
  },
  // :: (string, any) → OrderedMap
  // Add a new key to the start of the map.
  addToStart: function (key, value) {
    return new OrderedMap([key, value].concat(this.remove(key).content));
  },
  // :: (string, any) → OrderedMap
  // Add a new key to the end of the map.
  addToEnd: function (key, value) {
    var content = this.remove(key).content.slice();
    content.push(key, value);
    return new OrderedMap(content);
  },
  // :: (string, string, any) → OrderedMap
  // Add a key after the given key. If `place` is not found, the new
  // key is added to the end.
  addBefore: function (place, key, value) {
    var without = this.remove(key),
        content = without.content.slice();
    var found = without.find(place);
    content.splice(found == -1 ? content.length : found, 0, key, value);
    return new OrderedMap(content);
  },
  // :: ((key: string, value: any))
  // Call the given function for each key/value pair in the map, in
  // order.
  forEach: function (f) {
    for (var i = 0; i < this.content.length; i += 2) f(this.content[i], this.content[i + 1]);
  },
  // :: (union<Object, OrderedMap>) → OrderedMap
  // Create a new map by prepending the keys in this map that don't
  // appear in `map` before the keys in `map`.
  prepend: function (map) {
    map = OrderedMap.from(map);
    if (!map.size) return this;
    return new OrderedMap(map.content.concat(this.subtract(map).content));
  },
  // :: (union<Object, OrderedMap>) → OrderedMap
  // Create a new map by appending the keys in this map that don't
  // appear in `map` after the keys in `map`.
  append: function (map) {
    map = OrderedMap.from(map);
    if (!map.size) return this;
    return new OrderedMap(this.subtract(map).content.concat(map.content));
  },
  // :: (union<Object, OrderedMap>) → OrderedMap
  // Create a map containing all the keys in this map that don't
  // appear in `map`.
  subtract: function (map) {
    var result = this;
    map = OrderedMap.from(map);

    for (var i = 0; i < map.content.length; i += 2) result = result.remove(map.content[i]);

    return result;
  },

  // :: number
  // The amount of keys in this map.
  get size() {
    return this.content.length >> 1;
  }

}; // :: (?union<Object, OrderedMap>) → OrderedMap
// Return a map with the given content. If null, create an empty
// map. If given an ordered map, return that map itself. If given an
// object, create a map from the object's properties.

OrderedMap.from = function (value) {
  if (value instanceof OrderedMap) return value;
  var content = [];
  if (value) for (var prop in value) content.push(prop, value[prop]);
  return new OrderedMap(content);
};

var orderedmap = OrderedMap;

var dist = createCommonjsModule(function (module, exports) {

  Object.defineProperty(exports, '__esModule', {
    value: true
  });

  function _interopDefault(ex) {
    return ex && typeof ex === 'object' && 'default' in ex ? ex['default'] : ex;
  }

  var OrderedMap = _interopDefault(orderedmap);

  function findDiffStart(a, b, pos) {
    for (var i = 0;; i++) {
      if (i == a.childCount || i == b.childCount) {
        return a.childCount == b.childCount ? null : pos;
      }

      var childA = a.child(i),
          childB = b.child(i);

      if (childA == childB) {
        pos += childA.nodeSize;
        continue;
      }

      if (!childA.sameMarkup(childB)) {
        return pos;
      }

      if (childA.isText && childA.text != childB.text) {
        for (var j = 0; childA.text[j] == childB.text[j]; j++) {
          pos++;
        }

        return pos;
      }

      if (childA.content.size || childB.content.size) {
        var inner = findDiffStart(childA.content, childB.content, pos + 1);

        if (inner != null) {
          return inner;
        }
      }

      pos += childA.nodeSize;
    }
  }

  function findDiffEnd(a, b, posA, posB) {
    for (var iA = a.childCount, iB = b.childCount;;) {
      if (iA == 0 || iB == 0) {
        return iA == iB ? null : {
          a: posA,
          b: posB
        };
      }

      var childA = a.child(--iA),
          childB = b.child(--iB),
          size = childA.nodeSize;

      if (childA == childB) {
        posA -= size;
        posB -= size;
        continue;
      }

      if (!childA.sameMarkup(childB)) {
        return {
          a: posA,
          b: posB
        };
      }

      if (childA.isText && childA.text != childB.text) {
        var same = 0,
            minSize = Math.min(childA.text.length, childB.text.length);

        while (same < minSize && childA.text[childA.text.length - same - 1] == childB.text[childB.text.length - same - 1]) {
          same++;
          posA--;
          posB--;
        }

        return {
          a: posA,
          b: posB
        };
      }

      if (childA.content.size || childB.content.size) {
        var inner = findDiffEnd(childA.content, childB.content, posA - 1, posB - 1);

        if (inner) {
          return inner;
        }
      }

      posA -= size;
      posB -= size;
    }
  } // ::- A fragment represents a node's collection of child nodes.
  //
  // Like nodes, fragments are persistent data structures, and you
  // should not mutate them or their content. Rather, you create new
  // instances whenever needed. The API tries to make this easy.


  var Fragment = function Fragment(content, size) {
    var this$1 = this;
    this.content = content; // :: number
    // The size of the fragment, which is the total of the size of its
    // content nodes.

    this.size = size || 0;

    if (size == null) {
      for (var i = 0; i < content.length; i++) {
        this$1.size += content[i].nodeSize;
      }
    }
  };

  var prototypeAccessors$1 = {
    firstChild: {},
    lastChild: {},
    childCount: {}
  }; // :: (number, number, (node: Node, start: number, parent: Node, index: number) → ?bool, ?number)
  // Invoke a callback for all descendant nodes between the given two
  // positions (relative to start of this fragment). Doesn't descend
  // into a node when the callback returns `false`.

  Fragment.prototype.nodesBetween = function nodesBetween(from, to, f, nodeStart, parent) {
    var this$1 = this;
    if (nodeStart === void 0) nodeStart = 0;

    for (var i = 0, pos = 0; pos < to; i++) {
      var child = this$1.content[i],
          end = pos + child.nodeSize;

      if (end > from && f(child, nodeStart + pos, parent, i) !== false && child.content.size) {
        var start = pos + 1;
        child.nodesBetween(Math.max(0, from - start), Math.min(child.content.size, to - start), f, nodeStart + start);
      }

      pos = end;
    }
  }; // :: ((node: Node, pos: number, parent: Node) → ?bool)
  // Call the given callback for every descendant node. The callback
  // may return `false` to prevent traversal of a given node's children.


  Fragment.prototype.descendants = function descendants(f) {
    this.nodesBetween(0, this.size, f);
  }; // : (number, number, ?string, ?string) → string


  Fragment.prototype.textBetween = function textBetween(from, to, blockSeparator, leafText) {
    var text = "",
        separated = true;
    this.nodesBetween(from, to, function (node, pos) {
      if (node.isText) {
        text += node.text.slice(Math.max(from, pos) - pos, to - pos);
        separated = !blockSeparator;
      } else if (node.isLeaf && leafText) {
        text += leafText;
        separated = !blockSeparator;
      } else if (!separated && node.isBlock) {
        text += blockSeparator;
        separated = true;
      }
    }, 0);
    return text;
  }; // :: (Fragment) → Fragment
  // Create a new fragment containing the combined content of this
  // fragment and the other.


  Fragment.prototype.append = function append(other) {
    if (!other.size) {
      return this;
    }

    if (!this.size) {
      return other;
    }

    var last = this.lastChild,
        first = other.firstChild,
        content = this.content.slice(),
        i = 0;

    if (last.isText && last.sameMarkup(first)) {
      content[content.length - 1] = last.withText(last.text + first.text);
      i = 1;
    }

    for (; i < other.content.length; i++) {
      content.push(other.content[i]);
    }

    return new Fragment(content, this.size + other.size);
  }; // :: (number, ?number) → Fragment
  // Cut out the sub-fragment between the two given positions.


  Fragment.prototype.cut = function cut(from, to) {
    var this$1 = this;

    if (to == null) {
      to = this.size;
    }

    if (from == 0 && to == this.size) {
      return this;
    }

    var result = [],
        size = 0;

    if (to > from) {
      for (var i = 0, pos = 0; pos < to; i++) {
        var child = this$1.content[i],
            end = pos + child.nodeSize;

        if (end > from) {
          if (pos < from || end > to) {
            if (child.isText) {
              child = child.cut(Math.max(0, from - pos), Math.min(child.text.length, to - pos));
            } else {
              child = child.cut(Math.max(0, from - pos - 1), Math.min(child.content.size, to - pos - 1));
            }
          }

          result.push(child);
          size += child.nodeSize;
        }

        pos = end;
      }
    }

    return new Fragment(result, size);
  };

  Fragment.prototype.cutByIndex = function cutByIndex(from, to) {
    if (from == to) {
      return Fragment.empty;
    }

    if (from == 0 && to == this.content.length) {
      return this;
    }

    return new Fragment(this.content.slice(from, to));
  }; // :: (number, Node) → Fragment
  // Create a new fragment in which the node at the given index is
  // replaced by the given node.


  Fragment.prototype.replaceChild = function replaceChild(index, node) {
    var current = this.content[index];

    if (current == node) {
      return this;
    }

    var copy = this.content.slice();
    var size = this.size + node.nodeSize - current.nodeSize;
    copy[index] = node;
    return new Fragment(copy, size);
  }; // : (Node) → Fragment
  // Create a new fragment by prepending the given node to this
  // fragment.


  Fragment.prototype.addToStart = function addToStart(node) {
    return new Fragment([node].concat(this.content), this.size + node.nodeSize);
  }; // : (Node) → Fragment
  // Create a new fragment by appending the given node to this
  // fragment.


  Fragment.prototype.addToEnd = function addToEnd(node) {
    return new Fragment(this.content.concat(node), this.size + node.nodeSize);
  }; // :: (Fragment) → bool
  // Compare this fragment to another one.


  Fragment.prototype.eq = function eq(other) {
    var this$1 = this;

    if (this.content.length != other.content.length) {
      return false;
    }

    for (var i = 0; i < this.content.length; i++) {
      if (!this$1.content[i].eq(other.content[i])) {
        return false;
      }
    }

    return true;
  }; // :: ?Node
  // The first child of the fragment, or `null` if it is empty.


  prototypeAccessors$1.firstChild.get = function () {
    return this.content.length ? this.content[0] : null;
  }; // :: ?Node
  // The last child of the fragment, or `null` if it is empty.


  prototypeAccessors$1.lastChild.get = function () {
    return this.content.length ? this.content[this.content.length - 1] : null;
  }; // :: number
  // The number of child nodes in this fragment.


  prototypeAccessors$1.childCount.get = function () {
    return this.content.length;
  }; // :: (number) → Node
  // Get the child node at the given index. Raise an error when the
  // index is out of range.


  Fragment.prototype.child = function child(index) {
    var found = this.content[index];

    if (!found) {
      throw new RangeError("Index " + index + " out of range for " + this);
    }

    return found;
  }; // :: (number) → ?Node
  // Get the child node at the given index, if it exists.


  Fragment.prototype.maybeChild = function maybeChild(index) {
    return this.content[index];
  }; // :: ((node: Node, offset: number, index: number))
  // Call `f` for every child node, passing the node, its offset
  // into this parent node, and its index.


  Fragment.prototype.forEach = function forEach(f) {
    var this$1 = this;

    for (var i = 0, p = 0; i < this.content.length; i++) {
      var child = this$1.content[i];
      f(child, p, i);
      p += child.nodeSize;
    }
  }; // :: (Fragment) → ?number
  // Find the first position at which this fragment and another
  // fragment differ, or `null` if they are the same.


  Fragment.prototype.findDiffStart = function findDiffStart$1(other, pos) {
    if (pos === void 0) pos = 0;
    return findDiffStart(this, other, pos);
  }; // :: (Fragment) → ?{a: number, b: number}
  // Find the first position, searching from the end, at which this
  // fragment and the given fragment differ, or `null` if they are the
  // same. Since this position will not be the same in both nodes, an
  // object with two separate positions is returned.


  Fragment.prototype.findDiffEnd = function findDiffEnd$1(other, pos, otherPos) {
    if (pos === void 0) pos = this.size;
    if (otherPos === void 0) otherPos = other.size;
    return findDiffEnd(this, other, pos, otherPos);
  }; // : (number, ?number) → {index: number, offset: number}
  // Find the index and inner offset corresponding to a given relative
  // position in this fragment. The result object will be reused
  // (overwritten) the next time the function is called. (Not public.)


  Fragment.prototype.findIndex = function findIndex(pos, round) {
    var this$1 = this;
    if (round === void 0) round = -1;

    if (pos == 0) {
      return retIndex(0, pos);
    }

    if (pos == this.size) {
      return retIndex(this.content.length, pos);
    }

    if (pos > this.size || pos < 0) {
      throw new RangeError("Position " + pos + " outside of fragment (" + this + ")");
    }

    for (var i = 0, curPos = 0;; i++) {
      var cur = this$1.child(i),
          end = curPos + cur.nodeSize;

      if (end >= pos) {
        if (end == pos || round > 0) {
          return retIndex(i + 1, end);
        }

        return retIndex(i, curPos);
      }

      curPos = end;
    }
  }; // :: () → string
  // Return a debugging string that describes this fragment.


  Fragment.prototype.toString = function toString() {
    return "<" + this.toStringInner() + ">";
  };

  Fragment.prototype.toStringInner = function toStringInner() {
    return this.content.join(", ");
  }; // :: () → ?Object
  // Create a JSON-serializeable representation of this fragment.


  Fragment.prototype.toJSON = function toJSON() {
    return this.content.length ? this.content.map(function (n) {
      return n.toJSON();
    }) : null;
  }; // :: (Schema, ?Object) → Fragment
  // Deserialize a fragment from its JSON representation.


  Fragment.fromJSON = function fromJSON(schema, value) {
    if (!value) {
      return Fragment.empty;
    }

    if (!Array.isArray(value)) {
      throw new RangeError("Invalid input for Fragment.fromJSON");
    }

    return new Fragment(value.map(schema.nodeFromJSON));
  }; // :: ([Node]) → Fragment
  // Build a fragment from an array of nodes. Ensures that adjacent
  // text nodes with the same marks are joined together.


  Fragment.fromArray = function fromArray(array) {
    if (!array.length) {
      return Fragment.empty;
    }

    var joined,
        size = 0;

    for (var i = 0; i < array.length; i++) {
      var node = array[i];
      size += node.nodeSize;

      if (i && node.isText && array[i - 1].sameMarkup(node)) {
        if (!joined) {
          joined = array.slice(0, i);
        }

        joined[joined.length - 1] = node.withText(joined[joined.length - 1].text + node.text);
      } else if (joined) {
        joined.push(node);
      }
    }

    return new Fragment(joined || array, size);
  }; // :: (?union<Fragment, Node, [Node]>) → Fragment
  // Create a fragment from something that can be interpreted as a set
  // of nodes. For `null`, it returns the empty fragment. For a
  // fragment, the fragment itself. For a node or array of nodes, a
  // fragment containing those nodes.


  Fragment.from = function from(nodes) {
    if (!nodes) {
      return Fragment.empty;
    }

    if (nodes instanceof Fragment) {
      return nodes;
    }

    if (Array.isArray(nodes)) {
      return this.fromArray(nodes);
    }

    return new Fragment([nodes], nodes.nodeSize);
  };

  Object.defineProperties(Fragment.prototype, prototypeAccessors$1);
  var found = {
    index: 0,
    offset: 0
  };

  function retIndex(index, offset) {
    found.index = index;
    found.offset = offset;
    return found;
  } // :: Fragment
  // An empty fragment. Intended to be reused whenever a node doesn't
  // contain anything (rather than allocating a new empty fragment for
  // each leaf node).


  Fragment.empty = new Fragment([], 0);

  function compareDeep(a, b) {
    if (a === b) {
      return true;
    }

    if (!(a && typeof a == "object") || !(b && typeof b == "object")) {
      return false;
    }

    var array = Array.isArray(a);

    if (Array.isArray(b) != array) {
      return false;
    }

    if (array) {
      if (a.length != b.length) {
        return false;
      }

      for (var i = 0; i < a.length; i++) {
        if (!compareDeep(a[i], b[i])) {
          return false;
        }
      }
    } else {
      for (var p in a) {
        if (!(p in b) || !compareDeep(a[p], b[p])) {
          return false;
        }
      }

      for (var p$1 in b) {
        if (!(p$1 in a)) {
          return false;
        }
      }
    }

    return true;
  } // ::- A mark is a piece of information that can be attached to a node,
  // such as it being emphasized, in code font, or a link. It has a type
  // and optionally a set of attributes that provide further information
  // (such as the target of the link). Marks are created through a
  // `Schema`, which controls which types exist and which
  // attributes they have.


  var Mark = function Mark(type, attrs) {
    // :: MarkType
    // The type of this mark.
    this.type = type; // :: Object
    // The attributes associated with this mark.

    this.attrs = attrs;
  }; // :: ([Mark]) → [Mark]
  // Given a set of marks, create a new set which contains this one as
  // well, in the right position. If this mark is already in the set,
  // the set itself is returned. If any marks that are set to be
  // [exclusive](#model.MarkSpec.excludes) with this mark are present,
  // those are replaced by this one.


  Mark.prototype.addToSet = function addToSet(set) {
    var this$1 = this;
    var copy,
        placed = false;

    for (var i = 0; i < set.length; i++) {
      var other = set[i];

      if (this$1.eq(other)) {
        return set;
      }

      if (this$1.type.excludes(other.type)) {
        if (!copy) {
          copy = set.slice(0, i);
        }
      } else if (other.type.excludes(this$1.type)) {
        return set;
      } else {
        if (!placed && other.type.rank > this$1.type.rank) {
          if (!copy) {
            copy = set.slice(0, i);
          }

          copy.push(this$1);
          placed = true;
        }

        if (copy) {
          copy.push(other);
        }
      }
    }

    if (!copy) {
      copy = set.slice();
    }

    if (!placed) {
      copy.push(this);
    }

    return copy;
  }; // :: ([Mark]) → [Mark]
  // Remove this mark from the given set, returning a new set. If this
  // mark is not in the set, the set itself is returned.


  Mark.prototype.removeFromSet = function removeFromSet(set) {
    var this$1 = this;

    for (var i = 0; i < set.length; i++) {
      if (this$1.eq(set[i])) {
        return set.slice(0, i).concat(set.slice(i + 1));
      }
    }

    return set;
  }; // :: ([Mark]) → bool
  // Test whether this mark is in the given set of marks.


  Mark.prototype.isInSet = function isInSet(set) {
    var this$1 = this;

    for (var i = 0; i < set.length; i++) {
      if (this$1.eq(set[i])) {
        return true;
      }
    }

    return false;
  }; // :: (Mark) → bool
  // Test whether this mark has the same type and attributes as
  // another mark.


  Mark.prototype.eq = function eq(other) {
    return this == other || this.type == other.type && compareDeep(this.attrs, other.attrs);
  }; // :: () → Object
  // Convert this mark to a JSON-serializeable representation.


  Mark.prototype.toJSON = function toJSON() {
    var this$1 = this;
    var obj = {
      type: this.type.name
    };

    for (var _ in this$1.attrs) {
      obj.attrs = this$1.attrs;
      break;
    }

    return obj;
  }; // :: (Schema, Object) → Mark


  Mark.fromJSON = function fromJSON(schema, json) {
    if (!json) {
      throw new RangeError("Invalid input for Mark.fromJSON");
    }

    var type = schema.marks[json.type];

    if (!type) {
      throw new RangeError("There is no mark type " + json.type + " in this schema");
    }

    return type.create(json.attrs);
  }; // :: ([Mark], [Mark]) → bool
  // Test whether two sets of marks are identical.


  Mark.sameSet = function sameSet(a, b) {
    if (a == b) {
      return true;
    }

    if (a.length != b.length) {
      return false;
    }

    for (var i = 0; i < a.length; i++) {
      if (!a[i].eq(b[i])) {
        return false;
      }
    }

    return true;
  }; // :: (?union<Mark, [Mark]>) → [Mark]
  // Create a properly sorted mark set from null, a single mark, or an
  // unsorted array of marks.


  Mark.setFrom = function setFrom(marks) {
    if (!marks || marks.length == 0) {
      return Mark.none;
    }

    if (marks instanceof Mark) {
      return [marks];
    }

    var copy = marks.slice();
    copy.sort(function (a, b) {
      return a.type.rank - b.type.rank;
    });
    return copy;
  }; // :: [Mark] The empty set of marks.


  Mark.none = []; // ReplaceError:: class extends Error
  // Error type raised by [`Node.replace`](#model.Node.replace) when
  // given an invalid replacement.

  function ReplaceError(message) {
    var err = Error.call(this, message);
    err.__proto__ = ReplaceError.prototype;
    return err;
  }

  ReplaceError.prototype = Object.create(Error.prototype);
  ReplaceError.prototype.constructor = ReplaceError;
  ReplaceError.prototype.name = "ReplaceError"; // ::- A slice represents a piece cut out of a larger document. It
  // stores not only a fragment, but also the depth up to which nodes on
  // both side are ‘open’ (cut through).

  var Slice = function Slice(content, openStart, openEnd) {
    // :: Fragment The slice's content.
    this.content = content; // :: number The open depth at the start.

    this.openStart = openStart; // :: number The open depth at the end.

    this.openEnd = openEnd;
  };

  var prototypeAccessors$2 = {
    size: {}
  }; // :: number
  // The size this slice would add when inserted into a document.

  prototypeAccessors$2.size.get = function () {
    return this.content.size - this.openStart - this.openEnd;
  };

  Slice.prototype.insertAt = function insertAt(pos, fragment) {
    var content = insertInto(this.content, pos + this.openStart, fragment, null);
    return content && new Slice(content, this.openStart, this.openEnd);
  };

  Slice.prototype.removeBetween = function removeBetween(from, to) {
    return new Slice(removeRange(this.content, from + this.openStart, to + this.openStart), this.openStart, this.openEnd);
  }; // :: (Slice) → bool
  // Tests whether this slice is equal to another slice.


  Slice.prototype.eq = function eq(other) {
    return this.content.eq(other.content) && this.openStart == other.openStart && this.openEnd == other.openEnd;
  };

  Slice.prototype.toString = function toString() {
    return this.content + "(" + this.openStart + "," + this.openEnd + ")";
  }; // :: () → ?Object
  // Convert a slice to a JSON-serializable representation.


  Slice.prototype.toJSON = function toJSON() {
    if (!this.content.size) {
      return null;
    }

    var json = {
      content: this.content.toJSON()
    };

    if (this.openStart > 0) {
      json.openStart = this.openStart;
    }

    if (this.openEnd > 0) {
      json.openEnd = this.openEnd;
    }

    return json;
  }; // :: (Schema, ?Object) → Slice
  // Deserialize a slice from its JSON representation.


  Slice.fromJSON = function fromJSON(schema, json) {
    if (!json) {
      return Slice.empty;
    }

    var openStart = json.openStart || 0,
        openEnd = json.openEnd || 0;

    if (typeof openStart != "number" || typeof openEnd != "number") {
      throw new RangeError("Invalid input for Slice.fromJSON");
    }

    return new Slice(Fragment.fromJSON(schema, json.content), json.openStart || 0, json.openEnd || 0);
  }; // :: (Fragment, ?bool) → Slice
  // Create a slice from a fragment by taking the maximum possible
  // open value on both side of the fragment.


  Slice.maxOpen = function maxOpen(fragment, openIsolating) {
    if (openIsolating === void 0) openIsolating = true;
    var openStart = 0,
        openEnd = 0;

    for (var n = fragment.firstChild; n && !n.isLeaf && (openIsolating || !n.type.spec.isolating); n = n.firstChild) {
      openStart++;
    }

    for (var n$1 = fragment.lastChild; n$1 && !n$1.isLeaf && (openIsolating || !n$1.type.spec.isolating); n$1 = n$1.lastChild) {
      openEnd++;
    }

    return new Slice(fragment, openStart, openEnd);
  };

  Object.defineProperties(Slice.prototype, prototypeAccessors$2);

  function removeRange(content, from, to) {
    var ref = content.findIndex(from);
    var index = ref.index;
    var offset = ref.offset;
    var child = content.maybeChild(index);
    var ref$1 = content.findIndex(to);
    var indexTo = ref$1.index;
    var offsetTo = ref$1.offset;

    if (offset == from || child.isText) {
      if (offsetTo != to && !content.child(indexTo).isText) {
        throw new RangeError("Removing non-flat range");
      }

      return content.cut(0, from).append(content.cut(to));
    }

    if (index != indexTo) {
      throw new RangeError("Removing non-flat range");
    }

    return content.replaceChild(index, child.copy(removeRange(child.content, from - offset - 1, to - offset - 1)));
  }

  function insertInto(content, dist, insert, parent) {
    var ref = content.findIndex(dist);
    var index = ref.index;
    var offset = ref.offset;
    var child = content.maybeChild(index);

    if (offset == dist || child.isText) {
      if (parent && !parent.canReplace(index, index, insert)) {
        return null;
      }

      return content.cut(0, dist).append(insert).append(content.cut(dist));
    }

    var inner = insertInto(child.content, dist - offset - 1, insert);
    return inner && content.replaceChild(index, child.copy(inner));
  } // :: Slice
  // The empty slice.


  Slice.empty = new Slice(Fragment.empty, 0, 0);

  function replace($from, $to, slice) {
    if (slice.openStart > $from.depth) {
      throw new ReplaceError("Inserted content deeper than insertion position");
    }

    if ($from.depth - slice.openStart != $to.depth - slice.openEnd) {
      throw new ReplaceError("Inconsistent open depths");
    }

    return replaceOuter($from, $to, slice, 0);
  }

  function replaceOuter($from, $to, slice, depth) {
    var index = $from.index(depth),
        node = $from.node(depth);

    if (index == $to.index(depth) && depth < $from.depth - slice.openStart) {
      var inner = replaceOuter($from, $to, slice, depth + 1);
      return node.copy(node.content.replaceChild(index, inner));
    } else if (!slice.content.size) {
      return close(node, replaceTwoWay($from, $to, depth));
    } else if (!slice.openStart && !slice.openEnd && $from.depth == depth && $to.depth == depth) {
      // Simple, flat case
      var parent = $from.parent,
          content = parent.content;
      return close(parent, content.cut(0, $from.parentOffset).append(slice.content).append(content.cut($to.parentOffset)));
    } else {
      var ref = prepareSliceForReplace(slice, $from);
      var start = ref.start;
      var end = ref.end;
      return close(node, replaceThreeWay($from, start, end, $to, depth));
    }
  }

  function checkJoin(main, sub) {
    if (!sub.type.compatibleContent(main.type)) {
      throw new ReplaceError("Cannot join " + sub.type.name + " onto " + main.type.name);
    }
  }

  function joinable($before, $after, depth) {
    var node = $before.node(depth);
    checkJoin(node, $after.node(depth));
    return node;
  }

  function addNode(child, target) {
    var last = target.length - 1;

    if (last >= 0 && child.isText && child.sameMarkup(target[last])) {
      target[last] = child.withText(target[last].text + child.text);
    } else {
      target.push(child);
    }
  }

  function addRange($start, $end, depth, target) {
    var node = ($end || $start).node(depth);
    var startIndex = 0,
        endIndex = $end ? $end.index(depth) : node.childCount;

    if ($start) {
      startIndex = $start.index(depth);

      if ($start.depth > depth) {
        startIndex++;
      } else if ($start.textOffset) {
        addNode($start.nodeAfter, target);
        startIndex++;
      }
    }

    for (var i = startIndex; i < endIndex; i++) {
      addNode(node.child(i), target);
    }

    if ($end && $end.depth == depth && $end.textOffset) {
      addNode($end.nodeBefore, target);
    }
  }

  function close(node, content) {
    if (!node.type.validContent(content)) {
      throw new ReplaceError("Invalid content for node " + node.type.name);
    }

    return node.copy(content);
  }

  function replaceThreeWay($from, $start, $end, $to, depth) {
    var openStart = $from.depth > depth && joinable($from, $start, depth + 1);
    var openEnd = $to.depth > depth && joinable($end, $to, depth + 1);
    var content = [];
    addRange(null, $from, depth, content);

    if (openStart && openEnd && $start.index(depth) == $end.index(depth)) {
      checkJoin(openStart, openEnd);
      addNode(close(openStart, replaceThreeWay($from, $start, $end, $to, depth + 1)), content);
    } else {
      if (openStart) {
        addNode(close(openStart, replaceTwoWay($from, $start, depth + 1)), content);
      }

      addRange($start, $end, depth, content);

      if (openEnd) {
        addNode(close(openEnd, replaceTwoWay($end, $to, depth + 1)), content);
      }
    }

    addRange($to, null, depth, content);
    return new Fragment(content);
  }

  function replaceTwoWay($from, $to, depth) {
    var content = [];
    addRange(null, $from, depth, content);

    if ($from.depth > depth) {
      var type = joinable($from, $to, depth + 1);
      addNode(close(type, replaceTwoWay($from, $to, depth + 1)), content);
    }

    addRange($to, null, depth, content);
    return new Fragment(content);
  }

  function prepareSliceForReplace(slice, $along) {
    var extra = $along.depth - slice.openStart,
        parent = $along.node(extra);
    var node = parent.copy(slice.content);

    for (var i = extra - 1; i >= 0; i--) {
      node = $along.node(i).copy(Fragment.from(node));
    }

    return {
      start: node.resolveNoCache(slice.openStart + extra),
      end: node.resolveNoCache(node.content.size - slice.openEnd - extra)
    };
  } // ::- You can [_resolve_](#model.Node.resolve) a position to get more
  // information about it. Objects of this class represent such a
  // resolved position, providing various pieces of context information,
  // and some helper methods.
  //
  // Throughout this interface, methods that take an optional `depth`
  // parameter will interpret undefined as `this.depth` and negative
  // numbers as `this.depth + value`.


  var ResolvedPos = function ResolvedPos(pos, path, parentOffset) {
    // :: number The position that was resolved.
    this.pos = pos;
    this.path = path; // :: number
    // The number of levels the parent node is from the root. If this
    // position points directly into the root node, it is 0. If it
    // points into a top-level paragraph, 1, and so on.

    this.depth = path.length / 3 - 1; // :: number The offset this position has into its parent node.

    this.parentOffset = parentOffset;
  };

  var prototypeAccessors$3 = {
    parent: {},
    doc: {},
    textOffset: {},
    nodeAfter: {},
    nodeBefore: {}
  };

  ResolvedPos.prototype.resolveDepth = function resolveDepth(val) {
    if (val == null) {
      return this.depth;
    }

    if (val < 0) {
      return this.depth + val;
    }

    return val;
  }; // :: Node
  // The parent node that the position points into. Note that even if
  // a position points into a text node, that node is not considered
  // the parent—text nodes are ‘flat’ in this model, and have no content.


  prototypeAccessors$3.parent.get = function () {
    return this.node(this.depth);
  }; // :: Node
  // The root node in which the position was resolved.


  prototypeAccessors$3.doc.get = function () {
    return this.node(0);
  }; // :: (?number) → Node
  // The ancestor node at the given level. `p.node(p.depth)` is the
  // same as `p.parent`.


  ResolvedPos.prototype.node = function node(depth) {
    return this.path[this.resolveDepth(depth) * 3];
  }; // :: (?number) → number
  // The index into the ancestor at the given level. If this points at
  // the 3rd node in the 2nd paragraph on the top level, for example,
  // `p.index(0)` is 2 and `p.index(1)` is 3.


  ResolvedPos.prototype.index = function index(depth) {
    return this.path[this.resolveDepth(depth) * 3 + 1];
  }; // :: (?number) → number
  // The index pointing after this position into the ancestor at the
  // given level.


  ResolvedPos.prototype.indexAfter = function indexAfter(depth) {
    depth = this.resolveDepth(depth);
    return this.index(depth) + (depth == this.depth && !this.textOffset ? 0 : 1);
  }; // :: (?number) → number
  // The (absolute) position at the start of the node at the given
  // level.


  ResolvedPos.prototype.start = function start(depth) {
    depth = this.resolveDepth(depth);
    return depth == 0 ? 0 : this.path[depth * 3 - 1] + 1;
  }; // :: (?number) → number
  // The (absolute) position at the end of the node at the given
  // level.


  ResolvedPos.prototype.end = function end(depth) {
    depth = this.resolveDepth(depth);
    return this.start(depth) + this.node(depth).content.size;
  }; // :: (?number) → number
  // The (absolute) position directly before the wrapping node at the
  // given level, or, when `level` is `this.depth + 1`, the original
  // position.


  ResolvedPos.prototype.before = function before(depth) {
    depth = this.resolveDepth(depth);

    if (!depth) {
      throw new RangeError("There is no position before the top-level node");
    }

    return depth == this.depth + 1 ? this.pos : this.path[depth * 3 - 1];
  }; // :: (?number) → number
  // The (absolute) position directly after the wrapping node at the
  // given level, or the original position when `level` is `this.depth + 1`.


  ResolvedPos.prototype.after = function after(depth) {
    depth = this.resolveDepth(depth);

    if (!depth) {
      throw new RangeError("There is no position after the top-level node");
    }

    return depth == this.depth + 1 ? this.pos : this.path[depth * 3 - 1] + this.path[depth * 3].nodeSize;
  }; // :: number
  // When this position points into a text node, this returns the
  // distance between the position and the start of the text node.
  // Will be zero for positions that point between nodes.


  prototypeAccessors$3.textOffset.get = function () {
    return this.pos - this.path[this.path.length - 1];
  }; // :: ?Node
  // Get the node directly after the position, if any. If the position
  // points into a text node, only the part of that node after the
  // position is returned.


  prototypeAccessors$3.nodeAfter.get = function () {
    var parent = this.parent,
        index = this.index(this.depth);

    if (index == parent.childCount) {
      return null;
    }

    var dOff = this.pos - this.path[this.path.length - 1],
        child = parent.child(index);
    return dOff ? parent.child(index).cut(dOff) : child;
  }; // :: ?Node
  // Get the node directly before the position, if any. If the
  // position points into a text node, only the part of that node
  // before the position is returned.


  prototypeAccessors$3.nodeBefore.get = function () {
    var index = this.index(this.depth);
    var dOff = this.pos - this.path[this.path.length - 1];

    if (dOff) {
      return this.parent.child(index).cut(0, dOff);
    }

    return index == 0 ? null : this.parent.child(index - 1);
  }; // :: () → [Mark]
  // Get the marks at this position, factoring in the surrounding
  // marks' [`inclusive`](#model.MarkSpec.inclusive) property. If the
  // position is at the start of a non-empty node, the marks of the
  // node after it (if any) are returned.


  ResolvedPos.prototype.marks = function marks() {
    var parent = this.parent,
        index = this.index(); // In an empty parent, return the empty array

    if (parent.content.size == 0) {
      return Mark.none;
    } // When inside a text node, just return the text node's marks


    if (this.textOffset) {
      return parent.child(index).marks;
    }

    var main = parent.maybeChild(index - 1),
        other = parent.maybeChild(index); // If the `after` flag is true of there is no node before, make
    // the node after this position the main reference.

    if (!main) {
      var tmp = main;
      main = other;
      other = tmp;
    } // Use all marks in the main node, except those that have
    // `inclusive` set to false and are not present in the other node.


    var marks = main.marks;

    for (var i = 0; i < marks.length; i++) {
      if (marks[i].type.spec.inclusive === false && (!other || !marks[i].isInSet(other.marks))) {
        marks = marks[i--].removeFromSet(marks);
      }
    }

    return marks;
  }; // :: (ResolvedPos) → ?[Mark]
  // Get the marks after the current position, if any, except those
  // that are non-inclusive and not present at position `$end`. This
  // is mostly useful for getting the set of marks to preserve after a
  // deletion. Will return `null` if this position is at the end of
  // its parent node or its parent node isn't a textblock (in which
  // case no marks should be preserved).


  ResolvedPos.prototype.marksAcross = function marksAcross($end) {
    var after = this.parent.maybeChild(this.index());

    if (!after || !after.isInline) {
      return null;
    }

    var marks = after.marks,
        next = $end.parent.maybeChild($end.index());

    for (var i = 0; i < marks.length; i++) {
      if (marks[i].type.spec.inclusive === false && (!next || !marks[i].isInSet(next.marks))) {
        marks = marks[i--].removeFromSet(marks);
      }
    }

    return marks;
  }; // :: (number) → number
  // The depth up to which this position and the given (non-resolved)
  // position share the same parent nodes.


  ResolvedPos.prototype.sharedDepth = function sharedDepth(pos) {
    var this$1 = this;

    for (var depth = this.depth; depth > 0; depth--) {
      if (this$1.start(depth) <= pos && this$1.end(depth) >= pos) {
        return depth;
      }
    }

    return 0;
  }; // :: (?ResolvedPos, ?(Node) → bool) → ?NodeRange
  // Returns a range based on the place where this position and the
  // given position diverge around block content. If both point into
  // the same textblock, for example, a range around that textblock
  // will be returned. If they point into different blocks, the range
  // around those blocks in their shared ancestor is returned. You can
  // pass in an optional predicate that will be called with a parent
  // node to see if a range into that parent is acceptable.


  ResolvedPos.prototype.blockRange = function blockRange(other, pred) {
    var this$1 = this;
    if (other === void 0) other = this;

    if (other.pos < this.pos) {
      return other.blockRange(this);
    }

    for (var d = this.depth - (this.parent.inlineContent || this.pos == other.pos ? 1 : 0); d >= 0; d--) {
      if (other.pos <= this$1.end(d) && (!pred || pred(this$1.node(d)))) {
        return new NodeRange(this$1, other, d);
      }
    }
  }; // :: (ResolvedPos) → bool
  // Query whether the given position shares the same parent node.


  ResolvedPos.prototype.sameParent = function sameParent(other) {
    return this.pos - this.parentOffset == other.pos - other.parentOffset;
  }; // :: (ResolvedPos) → ResolvedPos
  // Return the greater of this and the given position.


  ResolvedPos.prototype.max = function max(other) {
    return other.pos > this.pos ? other : this;
  }; // :: (ResolvedPos) → ResolvedPos
  // Return the smaller of this and the given position.


  ResolvedPos.prototype.min = function min(other) {
    return other.pos < this.pos ? other : this;
  };

  ResolvedPos.prototype.toString = function toString() {
    var this$1 = this;
    var str = "";

    for (var i = 1; i <= this.depth; i++) {
      str += (str ? "/" : "") + this$1.node(i).type.name + "_" + this$1.index(i - 1);
    }

    return str + ":" + this.parentOffset;
  };

  ResolvedPos.resolve = function resolve(doc, pos) {
    if (!(pos >= 0 && pos <= doc.content.size)) {
      throw new RangeError("Position " + pos + " out of range");
    }

    var path = [];
    var start = 0,
        parentOffset = pos;

    for (var node = doc;;) {
      var ref = node.content.findIndex(parentOffset);
      var index = ref.index;
      var offset = ref.offset;
      var rem = parentOffset - offset;
      path.push(node, index, start + offset);

      if (!rem) {
        break;
      }

      node = node.child(index);

      if (node.isText) {
        break;
      }

      parentOffset = rem - 1;
      start += offset + 1;
    }

    return new ResolvedPos(pos, path, parentOffset);
  };

  ResolvedPos.resolveCached = function resolveCached(doc, pos) {
    for (var i = 0; i < resolveCache.length; i++) {
      var cached = resolveCache[i];

      if (cached.pos == pos && cached.doc == doc) {
        return cached;
      }
    }

    var result = resolveCache[resolveCachePos] = ResolvedPos.resolve(doc, pos);
    resolveCachePos = (resolveCachePos + 1) % resolveCacheSize;
    return result;
  };

  Object.defineProperties(ResolvedPos.prototype, prototypeAccessors$3);
  var resolveCache = [];
  var resolveCachePos = 0;
  var resolveCacheSize = 12; // ::- Represents a flat range of content, i.e. one that starts and
  // ends in the same node.

  var NodeRange = function NodeRange($from, $to, depth) {
    // :: ResolvedPos A resolved position along the start of the
    // content. May have a `depth` greater than this object's `depth`
    // property, since these are the positions that were used to
    // compute the range, not re-resolved positions directly at its
    // boundaries.
    this.$from = $from; // :: ResolvedPos A position along the end of the content. See
    // caveat for [`$from`](#model.NodeRange.$from).

    this.$to = $to; // :: number The depth of the node that this range points into.

    this.depth = depth;
  };

  var prototypeAccessors$1$1 = {
    start: {},
    end: {},
    parent: {},
    startIndex: {},
    endIndex: {}
  }; // :: number The position at the start of the range.

  prototypeAccessors$1$1.start.get = function () {
    return this.$from.before(this.depth + 1);
  }; // :: number The position at the end of the range.


  prototypeAccessors$1$1.end.get = function () {
    return this.$to.after(this.depth + 1);
  }; // :: Node The parent node that the range points into.


  prototypeAccessors$1$1.parent.get = function () {
    return this.$from.node(this.depth);
  }; // :: number The start index of the range in the parent node.


  prototypeAccessors$1$1.startIndex.get = function () {
    return this.$from.index(this.depth);
  }; // :: number The end index of the range in the parent node.


  prototypeAccessors$1$1.endIndex.get = function () {
    return this.$to.indexAfter(this.depth);
  };

  Object.defineProperties(NodeRange.prototype, prototypeAccessors$1$1);
  var emptyAttrs = Object.create(null); // ::- This class represents a node in the tree that makes up a
  // ProseMirror document. So a document is an instance of `Node`, with
  // children that are also instances of `Node`.
  //
  // Nodes are persistent data structures. Instead of changing them, you
  // create new ones with the content you want. Old ones keep pointing
  // at the old document shape. This is made cheaper by sharing
  // structure between the old and new data as much as possible, which a
  // tree shape like this (without back pointers) makes easy.
  //
  // **Do not** directly mutate the properties of a `Node` object. See
  // [the guide](/docs/guide/#doc) for more information.

  var Node = function Node(type, attrs, content, marks) {
    // :: NodeType
    // The type of node that this is.
    this.type = type; // :: Object
    // An object mapping attribute names to values. The kind of
    // attributes allowed and required are
    // [determined](#model.NodeSpec.attrs) by the node type.

    this.attrs = attrs; // :: Fragment
    // A container holding the node's children.

    this.content = content || Fragment.empty; // :: [Mark]
    // The marks (things like whether it is emphasized or part of a
    // link) applied to this node.

    this.marks = marks || Mark.none;
  };

  var prototypeAccessors = {
    nodeSize: {},
    childCount: {},
    textContent: {},
    firstChild: {},
    lastChild: {},
    isBlock: {},
    isTextblock: {},
    inlineContent: {},
    isInline: {},
    isText: {},
    isLeaf: {},
    isAtom: {}
  }; // text:: ?string
  // For text nodes, this contains the node's text content.
  // :: number
  // The size of this node, as defined by the integer-based [indexing
  // scheme](/docs/guide/#doc.indexing). For text nodes, this is the
  // amount of characters. For other leaf nodes, it is one. For
  // non-leaf nodes, it is the size of the content plus two (the start
  // and end token).

  prototypeAccessors.nodeSize.get = function () {
    return this.isLeaf ? 1 : 2 + this.content.size;
  }; // :: number
  // The number of children that the node has.


  prototypeAccessors.childCount.get = function () {
    return this.content.childCount;
  }; // :: (number) → Node
  // Get the child node at the given index. Raises an error when the
  // index is out of range.


  Node.prototype.child = function child(index) {
    return this.content.child(index);
  }; // :: (number) → ?Node
  // Get the child node at the given index, if it exists.


  Node.prototype.maybeChild = function maybeChild(index) {
    return this.content.maybeChild(index);
  }; // :: ((node: Node, offset: number, index: number))
  // Call `f` for every child node, passing the node, its offset
  // into this parent node, and its index.


  Node.prototype.forEach = function forEach(f) {
    this.content.forEach(f);
  }; // :: (number, number, (node: Node, pos: number, parent: Node, index: number) → ?bool, ?number)
  // Invoke a callback for all descendant nodes recursively between
  // the given two positions that are relative to start of this node's
  // content. The callback is invoked with the node, its
  // parent-relative position, its parent node, and its child index.
  // When the callback returns false for a given node, that node's
  // children will not be recursed over. The last parameter can be
  // used to specify a starting position to count from.


  Node.prototype.nodesBetween = function nodesBetween(from, to, f, startPos) {
    if (startPos === void 0) startPos = 0;
    this.content.nodesBetween(from, to, f, startPos, this);
  }; // :: ((node: Node, pos: number, parent: Node) → ?bool)
  // Call the given callback for every descendant node. Doesn't
  // descend into a node when the callback returns `false`.


  Node.prototype.descendants = function descendants(f) {
    this.nodesBetween(0, this.content.size, f);
  }; // :: string
  // Concatenates all the text nodes found in this fragment and its
  // children.


  prototypeAccessors.textContent.get = function () {
    return this.textBetween(0, this.content.size, "");
  }; // :: (number, number, ?string, ?string) → string
  // Get all text between positions `from` and `to`. When
  // `blockSeparator` is given, it will be inserted whenever a new
  // block node is started. When `leafText` is given, it'll be
  // inserted for every non-text leaf node encountered.


  Node.prototype.textBetween = function textBetween(from, to, blockSeparator, leafText) {
    return this.content.textBetween(from, to, blockSeparator, leafText);
  }; // :: ?Node
  // Returns this node's first child, or `null` if there are no
  // children.


  prototypeAccessors.firstChild.get = function () {
    return this.content.firstChild;
  }; // :: ?Node
  // Returns this node's last child, or `null` if there are no
  // children.


  prototypeAccessors.lastChild.get = function () {
    return this.content.lastChild;
  }; // :: (Node) → bool
  // Test whether two nodes represent the same piece of document.


  Node.prototype.eq = function eq(other) {
    return this == other || this.sameMarkup(other) && this.content.eq(other.content);
  }; // :: (Node) → bool
  // Compare the markup (type, attributes, and marks) of this node to
  // those of another. Returns `true` if both have the same markup.


  Node.prototype.sameMarkup = function sameMarkup(other) {
    return this.hasMarkup(other.type, other.attrs, other.marks);
  }; // :: (NodeType, ?Object, ?[Mark]) → bool
  // Check whether this node's markup correspond to the given type,
  // attributes, and marks.


  Node.prototype.hasMarkup = function hasMarkup(type, attrs, marks) {
    return this.type == type && compareDeep(this.attrs, attrs || type.defaultAttrs || emptyAttrs) && Mark.sameSet(this.marks, marks || Mark.none);
  }; // :: (?Fragment) → Node
  // Create a new node with the same markup as this node, containing
  // the given content (or empty, if no content is given).


  Node.prototype.copy = function copy(content) {
    if (content === void 0) content = null;

    if (content == this.content) {
      return this;
    }

    return new this.constructor(this.type, this.attrs, content, this.marks);
  }; // :: ([Mark]) → Node
  // Create a copy of this node, with the given set of marks instead
  // of the node's own marks.


  Node.prototype.mark = function mark(marks) {
    return marks == this.marks ? this : new this.constructor(this.type, this.attrs, this.content, marks);
  }; // :: (number, ?number) → Node
  // Create a copy of this node with only the content between the
  // given positions. If `to` is not given, it defaults to the end of
  // the node.


  Node.prototype.cut = function cut(from, to) {
    if (from == 0 && to == this.content.size) {
      return this;
    }

    return this.copy(this.content.cut(from, to));
  }; // :: (number, ?number) → Slice
  // Cut out the part of the document between the given positions, and
  // return it as a `Slice` object.


  Node.prototype.slice = function slice(from, to, includeParents) {
    if (to === void 0) to = this.content.size;
    if (includeParents === void 0) includeParents = false;

    if (from == to) {
      return Slice.empty;
    }

    var $from = this.resolve(from),
        $to = this.resolve(to);
    var depth = includeParents ? 0 : $from.sharedDepth(to);
    var start = $from.start(depth),
        node = $from.node(depth);
    var content = node.content.cut($from.pos - start, $to.pos - start);
    return new Slice(content, $from.depth - depth, $to.depth - depth);
  }; // :: (number, number, Slice) → Node
  // Replace the part of the document between the given positions with
  // the given slice. The slice must 'fit', meaning its open sides
  // must be able to connect to the surrounding content, and its
  // content nodes must be valid children for the node they are placed
  // into. If any of this is violated, an error of type
  // [`ReplaceError`](#model.ReplaceError) is thrown.


  Node.prototype.replace = function replace$1(from, to, slice) {
    return replace(this.resolve(from), this.resolve(to), slice);
  }; // :: (number) → ?Node
  // Find the node directly after the given position.


  Node.prototype.nodeAt = function nodeAt(pos) {
    for (var node = this;;) {
      var ref = node.content.findIndex(pos);
      var index = ref.index;
      var offset = ref.offset;
      node = node.maybeChild(index);

      if (!node) {
        return null;
      }

      if (offset == pos || node.isText) {
        return node;
      }

      pos -= offset + 1;
    }
  }; // :: (number) → {node: ?Node, index: number, offset: number}
  // Find the (direct) child node after the given offset, if any,
  // and return it along with its index and offset relative to this
  // node.


  Node.prototype.childAfter = function childAfter(pos) {
    var ref = this.content.findIndex(pos);
    var index = ref.index;
    var offset = ref.offset;
    return {
      node: this.content.maybeChild(index),
      index: index,
      offset: offset
    };
  }; // :: (number) → {node: ?Node, index: number, offset: number}
  // Find the (direct) child node before the given offset, if any,
  // and return it along with its index and offset relative to this
  // node.


  Node.prototype.childBefore = function childBefore(pos) {
    if (pos == 0) {
      return {
        node: null,
        index: 0,
        offset: 0
      };
    }

    var ref = this.content.findIndex(pos);
    var index = ref.index;
    var offset = ref.offset;

    if (offset < pos) {
      return {
        node: this.content.child(index),
        index: index,
        offset: offset
      };
    }

    var node = this.content.child(index - 1);
    return {
      node: node,
      index: index - 1,
      offset: offset - node.nodeSize
    };
  }; // :: (number) → ResolvedPos
  // Resolve the given position in the document, returning an
  // [object](#model.ResolvedPos) with information about its context.


  Node.prototype.resolve = function resolve(pos) {
    return ResolvedPos.resolveCached(this, pos);
  };

  Node.prototype.resolveNoCache = function resolveNoCache(pos) {
    return ResolvedPos.resolve(this, pos);
  }; // :: (number, number, MarkType) → bool
  // Test whether a mark of the given type occurs in this document
  // between the two given positions.


  Node.prototype.rangeHasMark = function rangeHasMark(from, to, type) {
    var found = false;

    if (to > from) {
      this.nodesBetween(from, to, function (node) {
        if (type.isInSet(node.marks)) {
          found = true;
        }

        return !found;
      });
    }

    return found;
  }; // :: bool
  // True when this is a block (non-inline node)


  prototypeAccessors.isBlock.get = function () {
    return this.type.isBlock;
  }; // :: bool
  // True when this is a textblock node, a block node with inline
  // content.


  prototypeAccessors.isTextblock.get = function () {
    return this.type.isTextblock;
  }; // :: bool
  // True when this node has inline content.


  prototypeAccessors.inlineContent.get = function () {
    return this.type.inlineContent;
  }; // :: bool
  // True when this is an inline node (a text node or a node that can
  // appear among text).


  prototypeAccessors.isInline.get = function () {
    return this.type.isInline;
  }; // :: bool
  // True when this is a text node.


  prototypeAccessors.isText.get = function () {
    return this.type.isText;
  }; // :: bool
  // True when this is a leaf node.


  prototypeAccessors.isLeaf.get = function () {
    return this.type.isLeaf;
  }; // :: bool
  // True when this is an atom, i.e. when it does not have directly
  // editable content. This is usually the same as `isLeaf`, but can
  // be configured with the [`atom` property](#model.NodeSpec.atom) on
  // a node's spec (typically used when the node is displayed as an
  // uneditable [node view](#view.NodeView)).


  prototypeAccessors.isAtom.get = function () {
    return this.type.isAtom;
  }; // :: () → string
  // Return a string representation of this node for debugging
  // purposes.


  Node.prototype.toString = function toString() {
    if (this.type.spec.toDebugString) {
      return this.type.spec.toDebugString(this);
    }

    var name = this.type.name;

    if (this.content.size) {
      name += "(" + this.content.toStringInner() + ")";
    }

    return wrapMarks(this.marks, name);
  }; // :: (number) → ContentMatch
  // Get the content match in this node at the given index.


  Node.prototype.contentMatchAt = function contentMatchAt(index) {
    var match = this.type.contentMatch.matchFragment(this.content, 0, index);

    if (!match) {
      throw new Error("Called contentMatchAt on a node with invalid content");
    }

    return match;
  }; // :: (number, number, ?Fragment, ?number, ?number) → bool
  // Test whether replacing the range between `from` and `to` (by
  // child index) with the given replacement fragment (which defaults
  // to the empty fragment) would leave the node's content valid. You
  // can optionally pass `start` and `end` indices into the
  // replacement fragment.


  Node.prototype.canReplace = function canReplace(from, to, replacement, start, end) {
    var this$1 = this;
    if (replacement === void 0) replacement = Fragment.empty;
    if (start === void 0) start = 0;
    if (end === void 0) end = replacement.childCount;
    var one = this.contentMatchAt(from).matchFragment(replacement, start, end);
    var two = one && one.matchFragment(this.content, to);

    if (!two || !two.validEnd) {
      return false;
    }

    for (var i = start; i < end; i++) {
      if (!this$1.type.allowsMarks(replacement.child(i).marks)) {
        return false;
      }
    }

    return true;
  }; // :: (number, number, NodeType, ?[Mark]) → bool
  // Test whether replacing the range `from` to `to` (by index) with a
  // node of the given type would leave the node's content valid.


  Node.prototype.canReplaceWith = function canReplaceWith(from, to, type, marks) {
    if (marks && !this.type.allowsMarks(marks)) {
      return false;
    }

    var start = this.contentMatchAt(from).matchType(type);
    var end = start && start.matchFragment(this.content, to);
    return end ? end.validEnd : false;
  }; // :: (Node) → bool
  // Test whether the given node's content could be appended to this
  // node. If that node is empty, this will only return true if there
  // is at least one node type that can appear in both nodes (to avoid
  // merging completely incompatible nodes).


  Node.prototype.canAppend = function canAppend(other) {
    if (other.content.size) {
      return this.canReplace(this.childCount, this.childCount, other.content);
    } else {
      return this.type.compatibleContent(other.type);
    }
  }; // Unused. Left for backwards compatibility.


  Node.prototype.defaultContentType = function defaultContentType(at) {
    return this.contentMatchAt(at).defaultType;
  }; // :: ()
  // Check whether this node and its descendants conform to the
  // schema, and raise error when they do not.


  Node.prototype.check = function check() {
    if (!this.type.validContent(this.content)) {
      throw new RangeError("Invalid content for node " + this.type.name + ": " + this.content.toString().slice(0, 50));
    }

    this.content.forEach(function (node) {
      return node.check();
    });
  }; // :: () → Object
  // Return a JSON-serializeable representation of this node.


  Node.prototype.toJSON = function toJSON() {
    var this$1 = this;
    var obj = {
      type: this.type.name
    };

    for (var _ in this$1.attrs) {
      obj.attrs = this$1.attrs;
      break;
    }

    if (this.content.size) {
      obj.content = this.content.toJSON();
    }

    if (this.marks.length) {
      obj.marks = this.marks.map(function (n) {
        return n.toJSON();
      });
    }

    return obj;
  }; // :: (Schema, Object) → Node
  // Deserialize a node from its JSON representation.


  Node.fromJSON = function fromJSON(schema, json) {
    if (!json) {
      throw new RangeError("Invalid input for Node.fromJSON");
    }

    var marks = null;

    if (json.marks) {
      if (!Array.isArray(json.marks)) {
        throw new RangeError("Invalid mark data for Node.fromJSON");
      }

      marks = json.marks.map(schema.markFromJSON);
    }

    if (json.type == "text") {
      if (typeof json.text != "string") {
        throw new RangeError("Invalid text node in JSON");
      }

      return schema.text(json.text, marks);
    }

    var content = Fragment.fromJSON(schema, json.content);
    return schema.nodeType(json.type).create(json.attrs, content, marks);
  };

  Object.defineProperties(Node.prototype, prototypeAccessors);

  var TextNode = function (Node) {
    function TextNode(type, attrs, content, marks) {
      Node.call(this, type, attrs, null, marks);

      if (!content) {
        throw new RangeError("Empty text nodes are not allowed");
      }

      this.text = content;
    }

    if (Node) TextNode.__proto__ = Node;
    TextNode.prototype = Object.create(Node && Node.prototype);
    TextNode.prototype.constructor = TextNode;
    var prototypeAccessors$1 = {
      textContent: {},
      nodeSize: {}
    };

    TextNode.prototype.toString = function toString() {
      if (this.type.spec.toDebugString) {
        return this.type.spec.toDebugString(this);
      }

      return wrapMarks(this.marks, JSON.stringify(this.text));
    };

    prototypeAccessors$1.textContent.get = function () {
      return this.text;
    };

    TextNode.prototype.textBetween = function textBetween(from, to) {
      return this.text.slice(from, to);
    };

    prototypeAccessors$1.nodeSize.get = function () {
      return this.text.length;
    };

    TextNode.prototype.mark = function mark(marks) {
      return marks == this.marks ? this : new TextNode(this.type, this.attrs, this.text, marks);
    };

    TextNode.prototype.withText = function withText(text) {
      if (text == this.text) {
        return this;
      }

      return new TextNode(this.type, this.attrs, text, this.marks);
    };

    TextNode.prototype.cut = function cut(from, to) {
      if (from === void 0) from = 0;
      if (to === void 0) to = this.text.length;

      if (from == 0 && to == this.text.length) {
        return this;
      }

      return this.withText(this.text.slice(from, to));
    };

    TextNode.prototype.eq = function eq(other) {
      return this.sameMarkup(other) && this.text == other.text;
    };

    TextNode.prototype.toJSON = function toJSON() {
      var base = Node.prototype.toJSON.call(this);
      base.text = this.text;
      return base;
    };

    Object.defineProperties(TextNode.prototype, prototypeAccessors$1);
    return TextNode;
  }(Node);

  function wrapMarks(marks, str) {
    for (var i = marks.length - 1; i >= 0; i--) {
      str = marks[i].type.name + "(" + str + ")";
    }

    return str;
  } // ::- Instances of this class represent a match state of a node
  // type's [content expression](#model.NodeSpec.content), and can be
  // used to find out whether further content matches here, and whether
  // a given position is a valid end of the node.


  var ContentMatch = function ContentMatch(validEnd) {
    // :: bool
    // True when this match state represents a valid end of the node.
    this.validEnd = validEnd;
    this.next = [];
    this.wrapCache = [];
  };

  var prototypeAccessors$5 = {
    inlineContent: {},
    defaultType: {},
    edgeCount: {}
  };

  ContentMatch.parse = function parse(string, nodeTypes) {
    var stream = new TokenStream(string, nodeTypes);

    if (stream.next == null) {
      return ContentMatch.empty;
    }

    var expr = parseExpr(stream);

    if (stream.next) {
      stream.err("Unexpected trailing text");
    }

    var match = dfa(nfa(expr));
    checkForDeadEnds(match, stream);
    return match;
  }; // :: (NodeType) → ?ContentMatch
  // Match a node type, returning a match after that node if
  // successful.


  ContentMatch.prototype.matchType = function matchType(type) {
    var this$1 = this;

    for (var i = 0; i < this.next.length; i += 2) {
      if (this$1.next[i] == type) {
        return this$1.next[i + 1];
      }
    }

    return null;
  }; // :: (Fragment, ?number, ?number) → ?ContentMatch
  // Try to match a fragment. Returns the resulting match when
  // successful.


  ContentMatch.prototype.matchFragment = function matchFragment(frag, start, end) {
    if (start === void 0) start = 0;
    if (end === void 0) end = frag.childCount;
    var cur = this;

    for (var i = start; cur && i < end; i++) {
      cur = cur.matchType(frag.child(i).type);
    }

    return cur;
  };

  prototypeAccessors$5.inlineContent.get = function () {
    var first = this.next[0];
    return first ? first.isInline : false;
  }; // :: ?NodeType
  // Get the first matching node type at this match position that can
  // be generated.


  prototypeAccessors$5.defaultType.get = function () {
    var this$1 = this;

    for (var i = 0; i < this.next.length; i += 2) {
      var type = this$1.next[i];

      if (!(type.isText || type.hasRequiredAttrs())) {
        return type;
      }
    }
  };

  ContentMatch.prototype.compatible = function compatible(other) {
    var this$1 = this;

    for (var i = 0; i < this.next.length; i += 2) {
      for (var j = 0; j < other.next.length; j += 2) {
        if (this$1.next[i] == other.next[j]) {
          return true;
        }
      }
    }

    return false;
  }; // :: (Fragment, bool, ?number) → ?Fragment
  // Try to match the given fragment, and if that fails, see if it can
  // be made to match by inserting nodes in front of it. When
  // successful, return a fragment of inserted nodes (which may be
  // empty if nothing had to be inserted). When `toEnd` is true, only
  // return a fragment if the resulting match goes to the end of the
  // content expression.


  ContentMatch.prototype.fillBefore = function fillBefore(after, toEnd, startIndex) {
    if (toEnd === void 0) toEnd = false;
    if (startIndex === void 0) startIndex = 0;
    var seen = [this];

    function search(match, types) {
      var finished = match.matchFragment(after, startIndex);

      if (finished && (!toEnd || finished.validEnd)) {
        return Fragment.from(types.map(function (tp) {
          return tp.createAndFill();
        }));
      }

      for (var i = 0; i < match.next.length; i += 2) {
        var type = match.next[i],
            next = match.next[i + 1];

        if (!(type.isText || type.hasRequiredAttrs()) && seen.indexOf(next) == -1) {
          seen.push(next);
          var found = search(next, types.concat(type));

          if (found) {
            return found;
          }
        }
      }
    }

    return search(this, []);
  }; // :: (NodeType) → ?[NodeType]
  // Find a set of wrapping node types that would allow a node of the
  // given type to appear at this position. The result may be empty
  // (when it fits directly) and will be null when no such wrapping
  // exists.


  ContentMatch.prototype.findWrapping = function findWrapping(target) {
    var this$1 = this;

    for (var i = 0; i < this.wrapCache.length; i += 2) {
      if (this$1.wrapCache[i] == target) {
        return this$1.wrapCache[i + 1];
      }
    }

    var computed = this.computeWrapping(target);
    this.wrapCache.push(target, computed);
    return computed;
  };

  ContentMatch.prototype.computeWrapping = function computeWrapping(target) {
    var seen = Object.create(null),
        active = [{
      match: this,
      type: null,
      via: null
    }];

    while (active.length) {
      var current = active.shift(),
          match = current.match;

      if (match.matchType(target)) {
        var result = [];

        for (var obj = current; obj.type; obj = obj.via) {
          result.push(obj.type);
        }

        return result.reverse();
      }

      for (var i = 0; i < match.next.length; i += 2) {
        var type = match.next[i];

        if (!type.isLeaf && !type.hasRequiredAttrs() && !(type.name in seen) && (!current.type || match.next[i + 1].validEnd)) {
          active.push({
            match: type.contentMatch,
            type: type,
            via: current
          });
          seen[type.name] = true;
        }
      }
    }
  }; // :: number
  // The number of outgoing edges this node has in the finite
  // automaton that describes the content expression.


  prototypeAccessors$5.edgeCount.get = function () {
    return this.next.length >> 1;
  }; // :: (number) → {type: NodeType, next: ContentMatch}
  // Get the _n_th outgoing edge from this node in the finite
  // automaton that describes the content expression.


  ContentMatch.prototype.edge = function edge(n) {
    var i = n << 1;

    if (i > this.next.length) {
      throw new RangeError("There's no " + n + "th edge in this content match");
    }

    return {
      type: this.next[i],
      next: this.next[i + 1]
    };
  };

  ContentMatch.prototype.toString = function toString() {
    var seen = [];

    function scan(m) {
      seen.push(m);

      for (var i = 1; i < m.next.length; i += 2) {
        if (seen.indexOf(m.next[i]) == -1) {
          scan(m.next[i]);
        }
      }
    }

    scan(this);
    return seen.map(function (m, i) {
      var out = i + (m.validEnd ? "*" : " ") + " ";

      for (var i$1 = 0; i$1 < m.next.length; i$1 += 2) {
        out += (i$1 ? ", " : "") + m.next[i$1].name + "->" + seen.indexOf(m.next[i$1 + 1]);
      }

      return out;
    }).join("\n");
  };

  Object.defineProperties(ContentMatch.prototype, prototypeAccessors$5);
  ContentMatch.empty = new ContentMatch(true);

  var TokenStream = function TokenStream(string, nodeTypes) {
    this.string = string;
    this.nodeTypes = nodeTypes;
    this.inline = null;
    this.pos = 0;
    this.tokens = string.split(/\s*(?=\b|\W|$)/);

    if (this.tokens[this.tokens.length - 1] == "") {
      this.tokens.pop();
    }

    if (this.tokens[0] == "") {
      this.tokens.unshift();
    }
  };

  var prototypeAccessors$1$3 = {
    next: {}
  };

  prototypeAccessors$1$3.next.get = function () {
    return this.tokens[this.pos];
  };

  TokenStream.prototype.eat = function eat(tok) {
    return this.next == tok && (this.pos++ || true);
  };

  TokenStream.prototype.err = function err(str) {
    throw new SyntaxError(str + " (in content expression '" + this.string + "')");
  };

  Object.defineProperties(TokenStream.prototype, prototypeAccessors$1$3);

  function parseExpr(stream) {
    var exprs = [];

    do {
      exprs.push(parseExprSeq(stream));
    } while (stream.eat("|"));

    return exprs.length == 1 ? exprs[0] : {
      type: "choice",
      exprs: exprs
    };
  }

  function parseExprSeq(stream) {
    var exprs = [];

    do {
      exprs.push(parseExprSubscript(stream));
    } while (stream.next && stream.next != ")" && stream.next != "|");

    return exprs.length == 1 ? exprs[0] : {
      type: "seq",
      exprs: exprs
    };
  }

  function parseExprSubscript(stream) {
    var expr = parseExprAtom(stream);

    for (;;) {
      if (stream.eat("+")) {
        expr = {
          type: "plus",
          expr: expr
        };
      } else if (stream.eat("*")) {
        expr = {
          type: "star",
          expr: expr
        };
      } else if (stream.eat("?")) {
        expr = {
          type: "opt",
          expr: expr
        };
      } else if (stream.eat("{")) {
        expr = parseExprRange(stream, expr);
      } else {
        break;
      }
    }

    return expr;
  }

  function parseNum(stream) {
    if (/\D/.test(stream.next)) {
      stream.err("Expected number, got '" + stream.next + "'");
    }

    var result = Number(stream.next);
    stream.pos++;
    return result;
  }

  function parseExprRange(stream, expr) {
    var min = parseNum(stream),
        max = min;

    if (stream.eat(",")) {
      if (stream.next != "}") {
        max = parseNum(stream);
      } else {
        max = -1;
      }
    }

    if (!stream.eat("}")) {
      stream.err("Unclosed braced range");
    }

    return {
      type: "range",
      min: min,
      max: max,
      expr: expr
    };
  }

  function resolveName(stream, name) {
    var types = stream.nodeTypes,
        type = types[name];

    if (type) {
      return [type];
    }

    var result = [];

    for (var typeName in types) {
      var type$1 = types[typeName];

      if (type$1.groups.indexOf(name) > -1) {
        result.push(type$1);
      }
    }

    if (result.length == 0) {
      stream.err("No node type or group '" + name + "' found");
    }

    return result;
  }

  function parseExprAtom(stream) {
    if (stream.eat("(")) {
      var expr = parseExpr(stream);

      if (!stream.eat(")")) {
        stream.err("Missing closing paren");
      }

      return expr;
    } else if (!/\W/.test(stream.next)) {
      var exprs = resolveName(stream, stream.next).map(function (type) {
        if (stream.inline == null) {
          stream.inline = type.isInline;
        } else if (stream.inline != type.isInline) {
          stream.err("Mixing inline and block content");
        }

        return {
          type: "name",
          value: type
        };
      });
      stream.pos++;
      return exprs.length == 1 ? exprs[0] : {
        type: "choice",
        exprs: exprs
      };
    } else {
      stream.err("Unexpected token '" + stream.next + "'");
    }
  } // The code below helps compile a regular-expression-like language
  // into a deterministic finite automaton. For a good introduction to
  // these concepts, see https://swtch.com/~rsc/regexp/regexp1.html
  // : (Object) → [[{term: ?any, to: number}]]
  // Construct an NFA from an expression as returned by the parser. The
  // NFA is represented as an array of states, which are themselves
  // arrays of edges, which are `{term, to}` objects. The first state is
  // the entry state and the last node is the success state.
  //
  // Note that unlike typical NFAs, the edge ordering in this one is
  // significant, in that it is used to contruct filler content when
  // necessary.


  function nfa(expr) {
    var nfa = [[]];
    connect(compile(expr, 0), node());
    return nfa;

    function node() {
      return nfa.push([]) - 1;
    }

    function edge(from, to, term) {
      var edge = {
        term: term,
        to: to
      };
      nfa[from].push(edge);
      return edge;
    }

    function connect(edges, to) {
      edges.forEach(function (edge) {
        return edge.to = to;
      });
    }

    function compile(expr, from) {
      if (expr.type == "choice") {
        return expr.exprs.reduce(function (out, expr) {
          return out.concat(compile(expr, from));
        }, []);
      } else if (expr.type == "seq") {
        for (var i = 0;; i++) {
          var next = compile(expr.exprs[i], from);

          if (i == expr.exprs.length - 1) {
            return next;
          }

          connect(next, from = node());
        }
      } else if (expr.type == "star") {
        var loop = node();
        edge(from, loop);
        connect(compile(expr.expr, loop), loop);
        return [edge(loop)];
      } else if (expr.type == "plus") {
        var loop$1 = node();
        connect(compile(expr.expr, from), loop$1);
        connect(compile(expr.expr, loop$1), loop$1);
        return [edge(loop$1)];
      } else if (expr.type == "opt") {
        return [edge(from)].concat(compile(expr.expr, from));
      } else if (expr.type == "range") {
        var cur = from;

        for (var i$1 = 0; i$1 < expr.min; i$1++) {
          var next$1 = node();
          connect(compile(expr.expr, cur), next$1);
          cur = next$1;
        }

        if (expr.max == -1) {
          connect(compile(expr.expr, cur), cur);
        } else {
          for (var i$2 = expr.min; i$2 < expr.max; i$2++) {
            var next$2 = node();
            edge(cur, next$2);
            connect(compile(expr.expr, cur), next$2);
            cur = next$2;
          }
        }

        return [edge(cur)];
      } else if (expr.type == "name") {
        return [edge(from, null, expr.value)];
      }
    }
  }

  function cmp(a, b) {
    return a - b;
  } // Get the set of nodes reachable by null edges from `node`. Omit
  // nodes with only a single null-out-edge, since they may lead to
  // needless duplicated nodes.


  function nullFrom(nfa, node) {
    var result = [];
    scan(node);
    return result.sort(cmp);

    function scan(node) {
      var edges = nfa[node];

      if (edges.length == 1 && !edges[0].term) {
        return scan(edges[0].to);
      }

      result.push(node);

      for (var i = 0; i < edges.length; i++) {
        var ref = edges[i];
        var term = ref.term;
        var to = ref.to;

        if (!term && result.indexOf(to) == -1) {
          scan(to);
        }
      }
    }
  } // : ([[{term: ?any, to: number}]]) → ContentMatch
  // Compiles an NFA as produced by `nfa` into a DFA, modeled as a set
  // of state objects (`ContentMatch` instances) with transitions
  // between them.


  function dfa(nfa) {
    var labeled = Object.create(null);
    return explore(nullFrom(nfa, 0));

    function explore(states) {
      var out = [];
      states.forEach(function (node) {
        nfa[node].forEach(function (ref) {
          var term = ref.term;
          var to = ref.to;

          if (!term) {
            return;
          }

          var known = out.indexOf(term),
              set = known > -1 && out[known + 1];
          nullFrom(nfa, to).forEach(function (node) {
            if (!set) {
              out.push(term, set = []);
            }

            if (set.indexOf(node) == -1) {
              set.push(node);
            }
          });
        });
      });
      var state = labeled[states.join(",")] = new ContentMatch(states.indexOf(nfa.length - 1) > -1);

      for (var i = 0; i < out.length; i += 2) {
        var states$1 = out[i + 1].sort(cmp);
        state.next.push(out[i], labeled[states$1.join(",")] || explore(states$1));
      }

      return state;
    }
  }

  function checkForDeadEnds(match, stream) {
    for (var i = 0, work = [match]; i < work.length; i++) {
      var state = work[i],
          dead = !state.validEnd,
          nodes = [];

      for (var j = 0; j < state.next.length; j += 2) {
        var node = state.next[j],
            next = state.next[j + 1];
        nodes.push(node.name);

        if (dead && !(node.isText || node.hasRequiredAttrs())) {
          dead = false;
        }

        if (work.indexOf(next) == -1) {
          work.push(next);
        }
      }

      if (dead) {
        stream.err("Only non-generatable nodes (" + nodes.join(", ") + ") in a required position");
      }
    }
  } // For node types where all attrs have a default value (or which don't
  // have any attributes), build up a single reusable default attribute
  // object, and use it for all nodes that don't specify specific
  // attributes.


  function defaultAttrs(attrs) {
    var defaults = Object.create(null);

    for (var attrName in attrs) {
      var attr = attrs[attrName];

      if (!attr.hasDefault) {
        return null;
      }

      defaults[attrName] = attr.default;
    }

    return defaults;
  }

  function computeAttrs(attrs, value) {
    var built = Object.create(null);

    for (var name in attrs) {
      var given = value && value[name];

      if (given === undefined) {
        var attr = attrs[name];

        if (attr.hasDefault) {
          given = attr.default;
        } else {
          throw new RangeError("No value supplied for attribute " + name);
        }
      }

      built[name] = given;
    }

    return built;
  }

  function initAttrs(attrs) {
    var result = Object.create(null);

    if (attrs) {
      for (var name in attrs) {
        result[name] = new Attribute(attrs[name]);
      }
    }

    return result;
  } // ::- Node types are objects allocated once per `Schema` and used to
  // [tag](#model.Node.type) `Node` instances. They contain information
  // about the node type, such as its name and what kind of node it
  // represents.


  var NodeType = function NodeType(name, schema, spec) {
    // :: string
    // The name the node type has in this schema.
    this.name = name; // :: Schema
    // A link back to the `Schema` the node type belongs to.

    this.schema = schema; // :: NodeSpec
    // The spec that this type is based on

    this.spec = spec;
    this.groups = spec.group ? spec.group.split(" ") : [];
    this.attrs = initAttrs(spec.attrs);
    this.defaultAttrs = defaultAttrs(this.attrs); // :: ContentMatch
    // The starting match of the node type's content expression.

    this.contentMatch = null; // : ?[MarkType]
    // The set of marks allowed in this node. `null` means all marks
    // are allowed.

    this.markSet = null; // :: bool
    // True if this node type has inline content.

    this.inlineContent = null; // :: bool
    // True if this is a block type

    this.isBlock = !(spec.inline || name == "text"); // :: bool
    // True if this is the text node type.

    this.isText = name == "text";
  };

  var prototypeAccessors$4 = {
    isInline: {},
    isTextblock: {},
    isLeaf: {},
    isAtom: {}
  }; // :: bool
  // True if this is an inline type.

  prototypeAccessors$4.isInline.get = function () {
    return !this.isBlock;
  }; // :: bool
  // True if this is a textblock type, a block that contains inline
  // content.


  prototypeAccessors$4.isTextblock.get = function () {
    return this.isBlock && this.inlineContent;
  }; // :: bool
  // True for node types that allow no content.


  prototypeAccessors$4.isLeaf.get = function () {
    return this.contentMatch == ContentMatch.empty;
  }; // :: bool
  // True when this node is an atom, i.e. when it does not have
  // directly editable content.


  prototypeAccessors$4.isAtom.get = function () {
    return this.isLeaf || this.spec.atom;
  };

  NodeType.prototype.hasRequiredAttrs = function hasRequiredAttrs(ignore) {
    var this$1 = this;

    for (var n in this$1.attrs) {
      if (this$1.attrs[n].isRequired && (!ignore || !(n in ignore))) {
        return true;
      }
    }

    return false;
  };

  NodeType.prototype.compatibleContent = function compatibleContent(other) {
    return this == other || this.contentMatch.compatible(other.contentMatch);
  };

  NodeType.prototype.computeAttrs = function computeAttrs$1(attrs) {
    if (!attrs && this.defaultAttrs) {
      return this.defaultAttrs;
    } else {
      return computeAttrs(this.attrs, attrs);
    }
  }; // :: (?Object, ?union<Fragment, Node, [Node]>, ?[Mark]) → Node
  // Create a `Node` of this type. The given attributes are
  // checked and defaulted (you can pass `null` to use the type's
  // defaults entirely, if no required attributes exist). `content`
  // may be a `Fragment`, a node, an array of nodes, or
  // `null`. Similarly `marks` may be `null` to default to the empty
  // set of marks.


  NodeType.prototype.create = function create(attrs, content, marks) {
    if (this.isText) {
      throw new Error("NodeType.create can't construct text nodes");
    }

    return new Node(this, this.computeAttrs(attrs), Fragment.from(content), Mark.setFrom(marks));
  }; // :: (?Object, ?union<Fragment, Node, [Node]>, ?[Mark]) → Node
  // Like [`create`](#model.NodeType.create), but check the given content
  // against the node type's content restrictions, and throw an error
  // if it doesn't match.


  NodeType.prototype.createChecked = function createChecked(attrs, content, marks) {
    content = Fragment.from(content);

    if (!this.validContent(content)) {
      throw new RangeError("Invalid content for node " + this.name);
    }

    return new Node(this, this.computeAttrs(attrs), content, Mark.setFrom(marks));
  }; // :: (?Object, ?union<Fragment, Node, [Node]>, ?[Mark]) → ?Node
  // Like [`create`](#model.NodeType.create), but see if it is necessary to
  // add nodes to the start or end of the given fragment to make it
  // fit the node. If no fitting wrapping can be found, return null.
  // Note that, due to the fact that required nodes can always be
  // created, this will always succeed if you pass null or
  // `Fragment.empty` as content.


  NodeType.prototype.createAndFill = function createAndFill(attrs, content, marks) {
    attrs = this.computeAttrs(attrs);
    content = Fragment.from(content);

    if (content.size) {
      var before = this.contentMatch.fillBefore(content);

      if (!before) {
        return null;
      }

      content = before.append(content);
    }

    var after = this.contentMatch.matchFragment(content).fillBefore(Fragment.empty, true);

    if (!after) {
      return null;
    }

    return new Node(this, attrs, content.append(after), Mark.setFrom(marks));
  }; // :: (Fragment) → bool
  // Returns true if the given fragment is valid content for this node
  // type with the given attributes.


  NodeType.prototype.validContent = function validContent(content) {
    var this$1 = this;
    var result = this.contentMatch.matchFragment(content);

    if (!result || !result.validEnd) {
      return false;
    }

    for (var i = 0; i < content.childCount; i++) {
      if (!this$1.allowsMarks(content.child(i).marks)) {
        return false;
      }
    }

    return true;
  }; // :: (MarkType) → bool
  // Check whether the given mark type is allowed in this node.


  NodeType.prototype.allowsMarkType = function allowsMarkType(markType) {
    return this.markSet == null || this.markSet.indexOf(markType) > -1;
  }; // :: ([Mark]) → bool
  // Test whether the given set of marks are allowed in this node.


  NodeType.prototype.allowsMarks = function allowsMarks(marks) {
    var this$1 = this;

    if (this.markSet == null) {
      return true;
    }

    for (var i = 0; i < marks.length; i++) {
      if (!this$1.allowsMarkType(marks[i].type)) {
        return false;
      }
    }

    return true;
  }; // :: ([Mark]) → [Mark]
  // Removes the marks that are not allowed in this node from the given set.


  NodeType.prototype.allowedMarks = function allowedMarks(marks) {
    var this$1 = this;

    if (this.markSet == null) {
      return marks;
    }

    var copy;

    for (var i = 0; i < marks.length; i++) {
      if (!this$1.allowsMarkType(marks[i].type)) {
        if (!copy) {
          copy = marks.slice(0, i);
        }
      } else if (copy) {
        copy.push(marks[i]);
      }
    }

    return !copy ? marks : copy.length ? copy : Mark.empty;
  };

  NodeType.compile = function compile(nodes, schema) {
    var result = Object.create(null);
    nodes.forEach(function (name, spec) {
      return result[name] = new NodeType(name, schema, spec);
    });
    var topType = schema.spec.topNode || "doc";

    if (!result[topType]) {
      throw new RangeError("Schema is missing its top node type ('" + topType + "')");
    }

    if (!result.text) {
      throw new RangeError("Every schema needs a 'text' type");
    }

    for (var _ in result.text.attrs) {
      throw new RangeError("The text node type should not have attributes");
    }

    return result;
  };

  Object.defineProperties(NodeType.prototype, prototypeAccessors$4); // Attribute descriptors

  var Attribute = function Attribute(options) {
    this.hasDefault = Object.prototype.hasOwnProperty.call(options, "default");
    this.default = options.default;
  };

  var prototypeAccessors$1$2 = {
    isRequired: {}
  };

  prototypeAccessors$1$2.isRequired.get = function () {
    return !this.hasDefault;
  };

  Object.defineProperties(Attribute.prototype, prototypeAccessors$1$2); // Marks
  // ::- Like nodes, marks (which are associated with nodes to signify
  // things like emphasis or being part of a link) are
  // [tagged](#model.Mark.type) with type objects, which are
  // instantiated once per `Schema`.

  var MarkType = function MarkType(name, rank, schema, spec) {
    // :: string
    // The name of the mark type.
    this.name = name; // :: Schema
    // The schema that this mark type instance is part of.

    this.schema = schema; // :: MarkSpec
    // The spec on which the type is based.

    this.spec = spec;
    this.attrs = initAttrs(spec.attrs);
    this.rank = rank;
    this.excluded = null;
    var defaults = defaultAttrs(this.attrs);
    this.instance = defaults && new Mark(this, defaults);
  }; // :: (?Object) → Mark
  // Create a mark of this type. `attrs` may be `null` or an object
  // containing only some of the mark's attributes. The others, if
  // they have defaults, will be added.


  MarkType.prototype.create = function create(attrs) {
    if (!attrs && this.instance) {
      return this.instance;
    }

    return new Mark(this, computeAttrs(this.attrs, attrs));
  };

  MarkType.compile = function compile(marks, schema) {
    var result = Object.create(null),
        rank = 0;
    marks.forEach(function (name, spec) {
      return result[name] = new MarkType(name, rank++, schema, spec);
    });
    return result;
  }; // :: ([Mark]) → [Mark]
  // When there is a mark of this type in the given set, a new set
  // without it is returned. Otherwise, the input set is returned.


  MarkType.prototype.removeFromSet = function removeFromSet(set) {
    var this$1 = this;

    for (var i = 0; i < set.length; i++) {
      if (set[i].type == this$1) {
        return set.slice(0, i).concat(set.slice(i + 1));
      }
    }

    return set;
  }; // :: ([Mark]) → ?Mark
  // Tests whether there is a mark of this type in the given set.


  MarkType.prototype.isInSet = function isInSet(set) {
    var this$1 = this;

    for (var i = 0; i < set.length; i++) {
      if (set[i].type == this$1) {
        return set[i];
      }
    }
  }; // :: (MarkType) → bool
  // Queries whether a given mark type is
  // [excluded](#model.MarkSpec.excludes) by this one.


  MarkType.prototype.excludes = function excludes(other) {
    return this.excluded.indexOf(other) > -1;
  }; // SchemaSpec:: interface
  // An object describing a schema, as passed to the [`Schema`](#model.Schema)
  // constructor.
  //
  //   nodes:: union<Object<NodeSpec>, OrderedMap<NodeSpec>>
  //   The node types in this schema. Maps names to
  //   [`NodeSpec`](#model.NodeSpec) objects that describe the node type
  //   associated with that name. Their order is significant—it
  //   determines which [parse rules](#model.NodeSpec.parseDOM) take
  //   precedence by default, and which nodes come first in a given
  //   [group](#model.NodeSpec.group).
  //
  //   marks:: ?union<Object<MarkSpec>, OrderedMap<MarkSpec>>
  //   The mark types that exist in this schema. The order in which they
  //   are provided determines the order in which [mark
  //   sets](#model.Mark.addToSet) are sorted and in which [parse
  //   rules](#model.MarkSpec.parseDOM) are tried.
  //
  //   topNode:: ?string
  //   The name of the default top-level node for the schema. Defaults
  //   to `"doc"`.
  // NodeSpec:: interface
  //
  //   content:: ?string
  //   The content expression for this node, as described in the [schema
  //   guide](/docs/guide/#schema.content_expressions). When not given,
  //   the node does not allow any content.
  //
  //   marks:: ?string
  //   The marks that are allowed inside of this node. May be a
  //   space-separated string referring to mark names or groups, `"_"`
  //   to explicitly allow all marks, or `""` to disallow marks. When
  //   not given, nodes with inline content default to allowing all
  //   marks, other nodes default to not allowing marks.
  //
  //   group:: ?string
  //   The group or space-separated groups to which this node belongs,
  //   which can be referred to in the content expressions for the
  //   schema.
  //
  //   inline:: ?bool
  //   Should be set to true for inline nodes. (Implied for text nodes.)
  //
  //   atom:: ?bool
  //   Can be set to true to indicate that, though this isn't a [leaf
  //   node](#model.NodeType.isLeaf), it doesn't have directly editable
  //   content and should be treated as a single unit in the view.
  //
  //   attrs:: ?Object<AttributeSpec>
  //   The attributes that nodes of this type get.
  //
  //   selectable:: ?bool
  //   Controls whether nodes of this type can be selected as a [node
  //   selection](#state.NodeSelection). Defaults to true for non-text
  //   nodes.
  //
  //   draggable:: ?bool
  //   Determines whether nodes of this type can be dragged without
  //   being selected. Defaults to false.
  //
  //   code:: ?bool
  //   Can be used to indicate that this node contains code, which
  //   causes some commands to behave differently.
  //
  //   defining:: ?bool
  //   Determines whether this node is considered an important parent
  //   node during replace operations (such as paste). Non-defining (the
  //   default) nodes get dropped when their entire content is replaced,
  //   whereas defining nodes persist and wrap the inserted content.
  //   Likewise, in _inserted_ content the defining parents of the
  //   content are preserved when possible. Typically,
  //   non-default-paragraph textblock types, and possibly list items,
  //   are marked as defining.
  //
  //   isolating:: ?bool
  //   When enabled (default is false), the sides of nodes of this type
  //   count as boundaries that regular editing operations, like
  //   backspacing or lifting, won't cross. An example of a node that
  //   should probably have this enabled is a table cell.
  //
  //   toDOM:: ?(node: Node) → DOMOutputSpec
  //   Defines the default way a node of this type should be serialized
  //   to DOM/HTML (as used by
  //   [`DOMSerializer.fromSchema`](#model.DOMSerializer^fromSchema)).
  //   Should return a DOM node or an [array
  //   structure](#model.DOMOutputSpec) that describes one, with an
  //   optional number zero (“hole”) in it to indicate where the node's
  //   content should be inserted.
  //
  //   For text nodes, the default is to create a text DOM node. Though
  //   it is possible to create a serializer where text is rendered
  //   differently, this is not supported inside the editor, so you
  //   shouldn't override that in your text node spec.
  //
  //   parseDOM:: ?[ParseRule]
  //   Associates DOM parser information with this node, which can be
  //   used by [`DOMParser.fromSchema`](#model.DOMParser^fromSchema) to
  //   automatically derive a parser. The `node` field in the rules is
  //   implied (the name of this node will be filled in automatically).
  //   If you supply your own parser, you do not need to also specify
  //   parsing rules in your schema.
  //
  //   toDebugString:: ?(node: Node) -> string
  //   Defines the default way a node of this type should be serialized
  //   to a string representation for debugging (e.g. in error messages).
  // MarkSpec:: interface
  //
  //   attrs:: ?Object<AttributeSpec>
  //   The attributes that marks of this type get.
  //
  //   inclusive:: ?bool
  //   Whether this mark should be active when the cursor is positioned
  //   at its end (or at its start when that is also the start of the
  //   parent node). Defaults to true.
  //
  //   excludes:: ?string
  //   Determines which other marks this mark can coexist with. Should
  //   be a space-separated strings naming other marks or groups of marks.
  //   When a mark is [added](#model.Mark.addToSet) to a set, all marks
  //   that it excludes are removed in the process. If the set contains
  //   any mark that excludes the new mark but is not, itself, excluded
  //   by the new mark, the mark can not be added an the set. You can
  //   use the value `"_"` to indicate that the mark excludes all
  //   marks in the schema.
  //
  //   Defaults to only being exclusive with marks of the same type. You
  //   can set it to an empty string (or any string not containing the
  //   mark's own name) to allow multiple marks of a given type to
  //   coexist (as long as they have different attributes).
  //
  //   group:: ?string
  //   The group or space-separated groups to which this mark belongs.
  //
  //   toDOM:: ?(mark: Mark, inline: bool) → DOMOutputSpec
  //   Defines the default way marks of this type should be serialized
  //   to DOM/HTML. When the resulting spec contains a hole, that is
  //   where the marked content is placed. Otherwise, it is appended to
  //   the top node.
  //
  //   parseDOM:: ?[ParseRule]
  //   Associates DOM parser information with this mark (see the
  //   corresponding [node spec field](#model.NodeSpec.parseDOM)). The
  //   `mark` field in the rules is implied.
  // AttributeSpec:: interface
  //
  // Used to [define](#model.NodeSpec.attrs) attributes on nodes or
  // marks.
  //
  //   default:: ?any
  //   The default value for this attribute, to use when no explicit
  //   value is provided. Attributes that have no default must be
  //   provided whenever a node or mark of a type that has them is
  //   created.
  // ::- A document schema. Holds [node](#model.NodeType) and [mark
  // type](#model.MarkType) objects for the nodes and marks that may
  // occur in conforming documents, and provides functionality for
  // creating and deserializing such documents.


  var Schema = function Schema(spec) {
    var this$1 = this; // :: SchemaSpec
    // The [spec](#model.SchemaSpec) on which the schema is based,
    // with the added guarantee that its `nodes` and `marks`
    // properties are
    // [`OrderedMap`](https://github.com/marijnh/orderedmap) instances
    // (not raw objects).

    this.spec = {};

    for (var prop in spec) {
      this$1.spec[prop] = spec[prop];
    }

    this.spec.nodes = OrderedMap.from(spec.nodes);
    this.spec.marks = OrderedMap.from(spec.marks); // :: Object<NodeType>
    // An object mapping the schema's node names to node type objects.

    this.nodes = NodeType.compile(this.spec.nodes, this); // :: Object<MarkType>
    // A map from mark names to mark type objects.

    this.marks = MarkType.compile(this.spec.marks, this);
    var contentExprCache = Object.create(null);

    for (var prop$1 in this$1.nodes) {
      if (prop$1 in this$1.marks) {
        throw new RangeError(prop$1 + " can not be both a node and a mark");
      }

      var type = this$1.nodes[prop$1],
          contentExpr = type.spec.content || "",
          markExpr = type.spec.marks;
      type.contentMatch = contentExprCache[contentExpr] || (contentExprCache[contentExpr] = ContentMatch.parse(contentExpr, this$1.nodes));
      type.inlineContent = type.contentMatch.inlineContent;
      type.markSet = markExpr == "_" ? null : markExpr ? gatherMarks(this$1, markExpr.split(" ")) : markExpr == "" || !type.inlineContent ? [] : null;
    }

    for (var prop$2 in this$1.marks) {
      var type$1 = this$1.marks[prop$2],
          excl = type$1.spec.excludes;
      type$1.excluded = excl == null ? [type$1] : excl == "" ? [] : gatherMarks(this$1, excl.split(" "));
    }

    this.nodeFromJSON = this.nodeFromJSON.bind(this);
    this.markFromJSON = this.markFromJSON.bind(this); // :: NodeType
    // The type of the [default top node](#model.SchemaSpec.topNode)
    // for this schema.

    this.topNodeType = this.nodes[this.spec.topNode || "doc"]; // :: Object
    // An object for storing whatever values modules may want to
    // compute and cache per schema. (If you want to store something
    // in it, try to use property names unlikely to clash.)

    this.cached = Object.create(null);
    this.cached.wrappings = Object.create(null);
  }; // :: (union<string, NodeType>, ?Object, ?union<Fragment, Node, [Node]>, ?[Mark]) → Node
  // Create a node in this schema. The `type` may be a string or a
  // `NodeType` instance. Attributes will be extended
  // with defaults, `content` may be a `Fragment`,
  // `null`, a `Node`, or an array of nodes.


  Schema.prototype.node = function node(type, attrs, content, marks) {
    if (typeof type == "string") {
      type = this.nodeType(type);
    } else if (!(type instanceof NodeType)) {
      throw new RangeError("Invalid node type: " + type);
    } else if (type.schema != this) {
      throw new RangeError("Node type from different schema used (" + type.name + ")");
    }

    return type.createChecked(attrs, content, marks);
  }; // :: (string, ?[Mark]) → Node
  // Create a text node in the schema. Empty text nodes are not
  // allowed.


  Schema.prototype.text = function text(text$1, marks) {
    var type = this.nodes.text;
    return new TextNode(type, type.defaultAttrs, text$1, Mark.setFrom(marks));
  }; // :: (union<string, MarkType>, ?Object) → Mark
  // Create a mark with the given type and attributes.


  Schema.prototype.mark = function mark(type, attrs) {
    if (typeof type == "string") {
      type = this.marks[type];
    }

    return type.create(attrs);
  }; // :: (Object) → Node
  // Deserialize a node from its JSON representation. This method is
  // bound.


  Schema.prototype.nodeFromJSON = function nodeFromJSON(json) {
    return Node.fromJSON(this, json);
  }; // :: (Object) → Mark
  // Deserialize a mark from its JSON representation. This method is
  // bound.


  Schema.prototype.markFromJSON = function markFromJSON(json) {
    return Mark.fromJSON(this, json);
  };

  Schema.prototype.nodeType = function nodeType(name) {
    var found = this.nodes[name];

    if (!found) {
      throw new RangeError("Unknown node type: " + name);
    }

    return found;
  };

  function gatherMarks(schema, marks) {
    var found = [];

    for (var i = 0; i < marks.length; i++) {
      var name = marks[i],
          mark = schema.marks[name],
          ok = mark;

      if (mark) {
        found.push(mark);
      } else {
        for (var prop in schema.marks) {
          var mark$1 = schema.marks[prop];

          if (name == "_" || mark$1.spec.group && mark$1.spec.group.split(" ").indexOf(name) > -1) {
            found.push(ok = mark$1);
          }
        }
      }

      if (!ok) {
        throw new SyntaxError("Unknown mark type: '" + marks[i] + "'");
      }
    }

    return found;
  } // ParseOptions:: interface
  // These are the options recognized by the
  // [`parse`](#model.DOMParser.parse) and
  // [`parseSlice`](#model.DOMParser.parseSlice) methods.
  //
  //   preserveWhitespace:: ?union<bool, "full">
  //   By default, whitespace is collapsed as per HTML's rules. Pass
  //   `true` to preserve whitespace, but normalize newlines to
  //   spaces, and `"full"` to preserve whitespace entirely.
  //
  //   findPositions:: ?[{node: dom.Node, offset: number}]
  //   When given, the parser will, beside parsing the content,
  //   record the document positions of the given DOM positions. It
  //   will do so by writing to the objects, adding a `pos` property
  //   that holds the document position. DOM positions that are not
  //   in the parsed content will not be written to.
  //
  //   from:: ?number
  //   The child node index to start parsing from.
  //
  //   to:: ?number
  //   The child node index to stop parsing at.
  //
  //   topNode:: ?Node
  //   By default, the content is parsed into the schema's default
  //   [top node type](#model.Schema.topNodeType). You can pass this
  //   option to use the type and attributes from a different node
  //   as the top container.
  //
  //   topMatch:: ?ContentMatch
  //   Provide the starting content match that content parsed into the
  //   top node is matched against.
  //
  //   context:: ?ResolvedPos
  //   A set of additional nodes to count as
  //   [context](#model.ParseRule.context) when parsing, above the
  //   given [top node](#model.ParseOptions.topNode).
  // ParseRule:: interface
  // A value that describes how to parse a given DOM node or inline
  // style as a ProseMirror node or mark.
  //
  //   tag:: ?string
  //   A CSS selector describing the kind of DOM elements to match. A
  //   single rule should have _either_ a `tag` or a `style` property.
  //
  //   namespace:: ?string
  //   The namespace to match. This should be used with `tag`.
  //   Nodes are only matched when the namespace matches or this property
  //   is null.
  //
  //   style:: ?string
  //   A CSS property name to match. When given, this rule matches
  //   inline styles that list that property. May also have the form
  //   `"property=value"`, in which case the rule only matches if the
  //   propery's value exactly matches the given value. (For more
  //   complicated filters, use [`getAttrs`](#model.ParseRule.getAttrs)
  //   and return undefined to indicate that the match failed.)
  //
  //   priority:: ?number
  //   Can be used to change the order in which the parse rules in a
  //   schema are tried. Those with higher priority come first. Rules
  //   without a priority are counted as having priority 50. This
  //   property is only meaningful in a schema—when directly
  //   constructing a parser, the order of the rule array is used.
  //
  //   context:: ?string
  //   When given, restricts this rule to only match when the current
  //   context—the parent nodes into which the content is being
  //   parsed—matches this expression. Should contain one or more node
  //   names or node group names followed by single or double slashes.
  //   For example `"paragraph/"` means the rule only matches when the
  //   parent node is a paragraph, `"blockquote/paragraph/"` restricts
  //   it to be in a paragraph that is inside a blockquote, and
  //   `"section//"` matches any position inside a section—a double
  //   slash matches any sequence of ancestor nodes. To allow multiple
  //   different contexts, they can be separated by a pipe (`|`)
  //   character, as in `"blockquote/|list_item/"`.
  //
  //   node:: ?string
  //   The name of the node type to create when this rule matches. Only
  //   valid for rules with a `tag` property, not for style rules. Each
  //   rule should have one of a `node`, `mark`, or `ignore` property
  //   (except when it appears in a [node](#model.NodeSpec.parseDOM) or
  //   [mark spec](#model.MarkSpec.parseDOM), in which case the `node`
  //   or `mark` property will be derived from its position).
  //
  //   mark:: ?string
  //   The name of the mark type to wrap the matched content in.
  //
  //   ignore:: ?bool
  //   When true, ignore content that matches this rule.
  //
  //   skip:: ?bool
  //   When true, ignore the node that matches this rule, but do parse
  //   its content.
  //
  //   attrs:: ?Object
  //   Attributes for the node or mark created by this rule. When
  //   `getAttrs` is provided, it takes precedence.
  //
  //   getAttrs:: ?(union<dom.Node, string>) → ?union<Object, false>
  //   A function used to compute the attributes for the node or mark
  //   created by this rule. Can also be used to describe further
  //   conditions the DOM element or style must match. When it returns
  //   `false`, the rule won't match. When it returns null or undefined,
  //   that is interpreted as an empty/default set of attributes.
  //
  //   Called with a DOM Element for `tag` rules, and with a string (the
  //   style's value) for `style` rules.
  //
  //   contentElement:: ?union<string, (dom.Node) → dom.Node>
  //   For `tag` rules that produce non-leaf nodes or marks, by default
  //   the content of the DOM element is parsed as content of the mark
  //   or node. If the child nodes are in a descendent node, this may be
  //   a CSS selector string that the parser must use to find the actual
  //   content element, or a function that returns the actual content
  //   element to the parser.
  //
  //   getContent:: ?(dom.Node, schema: Schema) → Fragment
  //   Can be used to override the content of a matched node. When
  //   present, instead of parsing the node's child nodes, the result of
  //   this function is used.
  //
  //   preserveWhitespace:: ?union<bool, "full">
  //   Controls whether whitespace should be preserved when parsing the
  //   content inside the matched element. `false` means whitespace may
  //   be collapsed, `true` means that whitespace should be preserved
  //   but newlines normalized to spaces, and `"full"` means that
  //   newlines should also be preserved.
  // ::- A DOM parser represents a strategy for parsing DOM content into
  // a ProseMirror document conforming to a given schema. Its behavior
  // is defined by an array of [rules](#model.ParseRule).


  var DOMParser = function DOMParser(schema, rules) {
    var this$1 = this; // :: Schema
    // The schema into which the parser parses.

    this.schema = schema; // :: [ParseRule]
    // The set of [parse rules](#model.ParseRule) that the parser
    // uses, in order of precedence.

    this.rules = rules;
    this.tags = [];
    this.styles = [];
    rules.forEach(function (rule) {
      if (rule.tag) {
        this$1.tags.push(rule);
      } else if (rule.style) {
        this$1.styles.push(rule);
      }
    });
  }; // :: (dom.Node, ?ParseOptions) → Node
  // Parse a document from the content of a DOM node.


  DOMParser.prototype.parse = function parse(dom, options) {
    if (options === void 0) options = {};
    var context = new ParseContext(this, options, false);
    context.addAll(dom, null, options.from, options.to);
    return context.finish();
  }; // :: (dom.Node, ?ParseOptions) → Slice
  // Parses the content of the given DOM node, like
  // [`parse`](#model.DOMParser.parse), and takes the same set of
  // options. But unlike that method, which produces a whole node,
  // this one returns a slice that is open at the sides, meaning that
  // the schema constraints aren't applied to the start of nodes to
  // the left of the input and the end of nodes at the end.


  DOMParser.prototype.parseSlice = function parseSlice(dom, options) {
    if (options === void 0) options = {};
    var context = new ParseContext(this, options, true);
    context.addAll(dom, null, options.from, options.to);
    return Slice.maxOpen(context.finish());
  };

  DOMParser.prototype.matchTag = function matchTag(dom, context) {
    var this$1 = this;

    for (var i = 0; i < this.tags.length; i++) {
      var rule = this$1.tags[i];

      if (matches(dom, rule.tag) && (rule.namespace === undefined || dom.namespaceURI == rule.namespace) && (!rule.context || context.matchesContext(rule.context))) {
        if (rule.getAttrs) {
          var result = rule.getAttrs(dom);

          if (result === false) {
            continue;
          }

          rule.attrs = result;
        }

        return rule;
      }
    }
  };

  DOMParser.prototype.matchStyle = function matchStyle(prop, value, context) {
    var this$1 = this;

    for (var i = 0; i < this.styles.length; i++) {
      var rule = this$1.styles[i];

      if (rule.style.indexOf(prop) != 0 || rule.context && !context.matchesContext(rule.context) || // Test that the style string either precisely matches the prop,
      // or has an '=' sign after the prop, followed by the given
      // value.
      rule.style.length > prop.length && (rule.style.charCodeAt(prop.length) != 61 || rule.style.slice(prop.length + 1) != value)) {
        continue;
      }

      if (rule.getAttrs) {
        var result = rule.getAttrs(value);

        if (result === false) {
          continue;
        }

        rule.attrs = result;
      }

      return rule;
    }
  }; // : (Schema) → [ParseRule]


  DOMParser.schemaRules = function schemaRules(schema) {
    var result = [];

    function insert(rule) {
      var priority = rule.priority == null ? 50 : rule.priority,
          i = 0;

      for (; i < result.length; i++) {
        var next = result[i],
            nextPriority = next.priority == null ? 50 : next.priority;

        if (nextPriority < priority) {
          break;
        }
      }

      result.splice(i, 0, rule);
    }

    var loop = function (name) {
      var rules = schema.marks[name].spec.parseDOM;

      if (rules) {
        rules.forEach(function (rule) {
          insert(rule = copy(rule));
          rule.mark = name;
        });
      }
    };

    for (var name in schema.marks) loop(name);

    var loop$1 = function (name) {
      var rules$1 = schema.nodes[name$1].spec.parseDOM;

      if (rules$1) {
        rules$1.forEach(function (rule) {
          insert(rule = copy(rule));
          rule.node = name$1;
        });
      }
    };

    for (var name$1 in schema.nodes) loop$1(name);

    return result;
  }; // :: (Schema) → DOMParser
  // Construct a DOM parser using the parsing rules listed in a
  // schema's [node specs](#model.NodeSpec.parseDOM), reordered by
  // [priority](#model.ParseRule.priority).


  DOMParser.fromSchema = function fromSchema(schema) {
    return schema.cached.domParser || (schema.cached.domParser = new DOMParser(schema, DOMParser.schemaRules(schema)));
  }; // : Object<bool> The block-level tags in HTML5


  var blockTags = {
    address: true,
    article: true,
    aside: true,
    blockquote: true,
    canvas: true,
    dd: true,
    div: true,
    dl: true,
    fieldset: true,
    figcaption: true,
    figure: true,
    footer: true,
    form: true,
    h1: true,
    h2: true,
    h3: true,
    h4: true,
    h5: true,
    h6: true,
    header: true,
    hgroup: true,
    hr: true,
    li: true,
    noscript: true,
    ol: true,
    output: true,
    p: true,
    pre: true,
    section: true,
    table: true,
    tfoot: true,
    ul: true
  }; // : Object<bool> The tags that we normally ignore.

  var ignoreTags = {
    head: true,
    noscript: true,
    object: true,
    script: true,
    style: true,
    title: true
  }; // : Object<bool> List tags.

  var listTags = {
    ol: true,
    ul: true
  }; // Using a bitfield for node context options

  var OPT_PRESERVE_WS = 1;
  var OPT_PRESERVE_WS_FULL = 2;
  var OPT_OPEN_LEFT = 4;

  function wsOptionsFor(preserveWhitespace) {
    return (preserveWhitespace ? OPT_PRESERVE_WS : 0) | (preserveWhitespace === "full" ? OPT_PRESERVE_WS_FULL : 0);
  }

  var NodeContext = function NodeContext(type, attrs, marks, solid, match, options) {
    this.type = type;
    this.attrs = attrs;
    this.solid = solid;
    this.match = match || (options & OPT_OPEN_LEFT ? null : type.contentMatch);
    this.options = options;
    this.content = [];
    this.marks = marks;
    this.activeMarks = Mark.none;
  };

  NodeContext.prototype.findWrapping = function findWrapping(node) {
    if (!this.match) {
      if (!this.type) {
        return [];
      }

      var fill = this.type.contentMatch.fillBefore(Fragment.from(node));

      if (fill) {
        this.match = this.type.contentMatch.matchFragment(fill);
      } else {
        var start = this.type.contentMatch,
            wrap;

        if (wrap = start.findWrapping(node.type)) {
          this.match = start;
          return wrap;
        } else {
          return null;
        }
      }
    }

    return this.match.findWrapping(node.type);
  };

  NodeContext.prototype.finish = function finish(openEnd) {
    if (!(this.options & OPT_PRESERVE_WS)) {
      // Strip trailing whitespace
      var last = this.content[this.content.length - 1],
          m;

      if (last && last.isText && (m = /\s+$/.exec(last.text))) {
        if (last.text.length == m[0].length) {
          this.content.pop();
        } else {
          this.content[this.content.length - 1] = last.withText(last.text.slice(0, last.text.length - m[0].length));
        }
      }
    }

    var content = Fragment.from(this.content);

    if (!openEnd && this.match) {
      content = content.append(this.match.fillBefore(Fragment.empty, true));
    }

    return this.type ? this.type.create(this.attrs, content, this.marks) : content;
  };

  var ParseContext = function ParseContext(parser, options, open) {
    // : DOMParser The parser we are using.
    this.parser = parser; // : Object The options passed to this parse.

    this.options = options;
    this.isOpen = open;
    this.pendingMarks = [];
    var topNode = options.topNode,
        topContext;
    var topOptions = wsOptionsFor(options.preserveWhitespace) | (open ? OPT_OPEN_LEFT : 0);

    if (topNode) {
      topContext = new NodeContext(topNode.type, topNode.attrs, Mark.none, true, options.topMatch || topNode.type.contentMatch, topOptions);
    } else if (open) {
      topContext = new NodeContext(null, null, Mark.none, true, null, topOptions);
    } else {
      topContext = new NodeContext(parser.schema.topNodeType, null, Mark.none, true, null, topOptions);
    }

    this.nodes = [topContext]; // : [Mark] The current set of marks

    this.open = 0;
    this.find = options.findPositions;
    this.needsBlock = false;
  };

  var prototypeAccessors$6 = {
    top: {},
    currentPos: {}
  };

  prototypeAccessors$6.top.get = function () {
    return this.nodes[this.open];
  }; // : (dom.Node)
  // Add a DOM node to the content. Text is inserted as text node,
  // otherwise, the node is passed to `addElement` or, if it has a
  // `style` attribute, `addElementWithStyles`.


  ParseContext.prototype.addDOM = function addDOM(dom) {
    var this$1 = this;

    if (dom.nodeType == 3) {
      this.addTextNode(dom);
    } else if (dom.nodeType == 1) {
      var style = dom.getAttribute("style");
      var marks = style ? this.readStyles(parseStyles(style)) : null;

      if (marks != null) {
        for (var i = 0; i < marks.length; i++) {
          this$1.addPendingMark(marks[i]);
        }
      }

      this.addElement(dom);

      if (marks != null) {
        for (var i$1 = 0; i$1 < marks.length; i$1++) {
          this$1.removePendingMark(marks[i$1]);
        }
      }
    }
  };

  ParseContext.prototype.addTextNode = function addTextNode(dom) {
    var value = dom.nodeValue;
    var top = this.top;

    if ((top.type ? top.type.inlineContent : top.content.length && top.content[0].isInline) || /\S/.test(value)) {
      if (!(top.options & OPT_PRESERVE_WS)) {
        value = value.replace(/\s+/g, " "); // If this starts with whitespace, and there is either no node
        // before it or a node that ends with whitespace, strip the
        // leading space.

        if (/^\s/.test(value) && this.open == this.nodes.length - 1) {
          var nodeBefore = top.content[top.content.length - 1];

          if (!nodeBefore || nodeBefore.isText && /\s$/.test(nodeBefore.text)) {
            value = value.slice(1);
          }
        }
      } else if (!(top.options & OPT_PRESERVE_WS_FULL)) {
        value = value.replace(/\r?\n|\r/g, " ");
      }

      if (value) {
        this.insertNode(this.parser.schema.text(value));
      }

      this.findInText(dom);
    } else {
      this.findInside(dom);
    }
  }; // : (dom.Element)
  // Try to find a handler for the given tag and use that to parse. If
  // none is found, the element's content nodes are added directly.


  ParseContext.prototype.addElement = function addElement(dom) {
    var name = dom.nodeName.toLowerCase();

    if (listTags.hasOwnProperty(name)) {
      normalizeList(dom);
    }

    var rule = this.options.ruleFromNode && this.options.ruleFromNode(dom) || this.parser.matchTag(dom, this);

    if (rule ? rule.ignore : ignoreTags.hasOwnProperty(name)) {
      this.findInside(dom);
    } else if (!rule || rule.skip) {
      if (rule && rule.skip.nodeType) {
        dom = rule.skip;
      }

      var sync,
          top = this.top,
          oldNeedsBlock = this.needsBlock;

      if (blockTags.hasOwnProperty(name)) {
        sync = true;

        if (!top.type) {
          this.needsBlock = true;
        }
      }

      this.addAll(dom);

      if (sync) {
        this.sync(top);
      }

      this.needsBlock = oldNeedsBlock;
    } else {
      this.addElementByRule(dom, rule);
    }
  }; // Run any style parser associated with the node's styles. Either
  // return an array of marks, or null to indicate some of the styles
  // had a rule with `ignore` set.


  ParseContext.prototype.readStyles = function readStyles(styles) {
    var this$1 = this;
    var marks = Mark.none;

    for (var i = 0; i < styles.length; i += 2) {
      var rule = this$1.parser.matchStyle(styles[i], styles[i + 1], this$1);

      if (!rule) {
        continue;
      }

      if (rule.ignore) {
        return null;
      }

      marks = this$1.parser.schema.marks[rule.mark].create(rule.attrs).addToSet(marks);
    }

    return marks;
  }; // : (dom.Element, ParseRule) → bool
  // Look up a handler for the given node. If none are found, return
  // false. Otherwise, apply it, use its return value to drive the way
  // the node's content is wrapped, and return true.


  ParseContext.prototype.addElementByRule = function addElementByRule(dom, rule) {
    var this$1 = this;
    var sync, nodeType, markType, mark;

    if (rule.node) {
      nodeType = this.parser.schema.nodes[rule.node];

      if (nodeType.isLeaf) {
        this.insertNode(nodeType.create(rule.attrs));
      } else {
        sync = this.enter(nodeType, rule.attrs, rule.preserveWhitespace);
      }
    } else {
      markType = this.parser.schema.marks[rule.mark];
      mark = markType.create(rule.attrs);
      this.addPendingMark(mark);
    }

    var startIn = this.top;

    if (nodeType && nodeType.isLeaf) {
      this.findInside(dom);
    } else if (rule.getContent) {
      this.findInside(dom);
      rule.getContent(dom, this.parser.schema).forEach(function (node) {
        return this$1.insertNode(node);
      });
    } else {
      var contentDOM = rule.contentElement;

      if (typeof contentDOM == "string") {
        contentDOM = dom.querySelector(contentDOM);
      } else if (typeof contentDOM == "function") {
        contentDOM = contentDOM(dom);
      }

      if (!contentDOM) {
        contentDOM = dom;
      }

      this.findAround(dom, contentDOM, true);
      this.addAll(contentDOM, sync);
    }

    if (sync) {
      this.sync(startIn);
      this.open--;
    }

    if (mark) {
      this.removePendingMark(mark);
    }

    return true;
  }; // : (dom.Node, ?NodeBuilder, ?number, ?number)
  // Add all child nodes between `startIndex` and `endIndex` (or the
  // whole node, if not given). If `sync` is passed, use it to
  // synchronize after every block element.


  ParseContext.prototype.addAll = function addAll(parent, sync, startIndex, endIndex) {
    var this$1 = this;
    var index = startIndex || 0;

    for (var dom = startIndex ? parent.childNodes[startIndex] : parent.firstChild, end = endIndex == null ? null : parent.childNodes[endIndex]; dom != end; dom = dom.nextSibling, ++index) {
      this$1.findAtPoint(parent, index);
      this$1.addDOM(dom);

      if (sync && blockTags.hasOwnProperty(dom.nodeName.toLowerCase())) {
        this$1.sync(sync);
      }
    }

    this.findAtPoint(parent, index);
  }; // Try to find a way to fit the given node type into the current
  // context. May add intermediate wrappers and/or leave non-solid
  // nodes that we're in.


  ParseContext.prototype.findPlace = function findPlace(node) {
    var this$1 = this;
    var route, sync;

    for (var depth = this.open; depth >= 0; depth--) {
      var cx = this$1.nodes[depth];
      var found = cx.findWrapping(node);

      if (found && (!route || route.length > found.length)) {
        route = found;
        sync = cx;

        if (!found.length) {
          break;
        }
      }

      if (cx.solid) {
        break;
      }
    }

    if (!route) {
      return false;
    }

    this.sync(sync);

    for (var i = 0; i < route.length; i++) {
      this$1.enterInner(route[i], null, false);
    }

    return true;
  }; // : (Node) → ?Node
  // Try to insert the given node, adjusting the context when needed.


  ParseContext.prototype.insertNode = function insertNode(node) {
    if (node.isInline && this.needsBlock && !this.top.type) {
      var block = this.textblockFromContext();

      if (block) {
        this.enterInner(block);
      }
    }

    if (this.findPlace(node)) {
      this.closeExtra();
      var top = this.top;
      this.applyPendingMarks(top);

      if (top.match) {
        top.match = top.match.matchType(node.type);
      }

      var marks = top.activeMarks;

      for (var i = 0; i < node.marks.length; i++) {
        if (!top.type || top.type.allowsMarkType(node.marks[i].type)) {
          marks = node.marks[i].addToSet(marks);
        }
      }

      top.content.push(node.mark(marks));
    }
  };

  ParseContext.prototype.applyPendingMarks = function applyPendingMarks(top) {
    var this$1 = this;

    for (var i = 0; i < this.pendingMarks.length; i++) {
      var mark = this$1.pendingMarks[i];

      if ((!top.type || top.type.allowsMarkType(mark.type)) && !mark.type.isInSet(top.activeMarks)) {
        top.activeMarks = mark.addToSet(top.activeMarks);
        this$1.pendingMarks.splice(i--, 1);
      }
    }
  }; // : (NodeType, ?Object) → bool
  // Try to start a node of the given type, adjusting the context when
  // necessary.


  ParseContext.prototype.enter = function enter(type, attrs, preserveWS) {
    var ok = this.findPlace(type.create(attrs));

    if (ok) {
      this.applyPendingMarks(this.top);
      this.enterInner(type, attrs, true, preserveWS);
    }

    return ok;
  }; // Open a node of the given type


  ParseContext.prototype.enterInner = function enterInner(type, attrs, solid, preserveWS) {
    this.closeExtra();
    var top = this.top;
    top.match = top.match && top.match.matchType(type, attrs);
    var options = preserveWS == null ? top.options & ~OPT_OPEN_LEFT : wsOptionsFor(preserveWS);

    if (top.options & OPT_OPEN_LEFT && top.content.length == 0) {
      options |= OPT_OPEN_LEFT;
    }

    this.nodes.push(new NodeContext(type, attrs, top.activeMarks, solid, null, options));
    this.open++;
  }; // Make sure all nodes above this.open are finished and added to
  // their parents


  ParseContext.prototype.closeExtra = function closeExtra(openEnd) {
    var this$1 = this;
    var i = this.nodes.length - 1;

    if (i > this.open) {
      for (; i > this.open; i--) {
        this$1.nodes[i - 1].content.push(this$1.nodes[i].finish(openEnd));
      }

      this.nodes.length = this.open + 1;
    }
  };

  ParseContext.prototype.finish = function finish() {
    this.open = 0;
    this.closeExtra(this.isOpen);
    return this.nodes[0].finish(this.isOpen || this.options.topOpen);
  };

  ParseContext.prototype.sync = function sync(to) {
    var this$1 = this;

    for (var i = this.open; i >= 0; i--) {
      if (this$1.nodes[i] == to) {
        this$1.open = i;
        return;
      }
    }
  };

  ParseContext.prototype.addPendingMark = function addPendingMark(mark) {
    this.pendingMarks.push(mark);
  };

  ParseContext.prototype.removePendingMark = function removePendingMark(mark) {
    var found = this.pendingMarks.lastIndexOf(mark);

    if (found > -1) {
      this.pendingMarks.splice(found, 1);
    } else {
      var top = this.top;
      top.activeMarks = mark.removeFromSet(top.activeMarks);
    }
  };

  prototypeAccessors$6.currentPos.get = function () {
    var this$1 = this;
    this.closeExtra();
    var pos = 0;

    for (var i = this.open; i >= 0; i--) {
      var content = this$1.nodes[i].content;

      for (var j = content.length - 1; j >= 0; j--) {
        pos += content[j].nodeSize;
      }

      if (i) {
        pos++;
      }
    }

    return pos;
  };

  ParseContext.prototype.findAtPoint = function findAtPoint(parent, offset) {
    var this$1 = this;

    if (this.find) {
      for (var i = 0; i < this.find.length; i++) {
        if (this$1.find[i].node == parent && this$1.find[i].offset == offset) {
          this$1.find[i].pos = this$1.currentPos;
        }
      }
    }
  };

  ParseContext.prototype.findInside = function findInside(parent) {
    var this$1 = this;

    if (this.find) {
      for (var i = 0; i < this.find.length; i++) {
        if (this$1.find[i].pos == null && parent.nodeType == 1 && parent.contains(this$1.find[i].node)) {
          this$1.find[i].pos = this$1.currentPos;
        }
      }
    }
  };

  ParseContext.prototype.findAround = function findAround(parent, content, before) {
    var this$1 = this;

    if (parent != content && this.find) {
      for (var i = 0; i < this.find.length; i++) {
        if (this$1.find[i].pos == null && parent.nodeType == 1 && parent.contains(this$1.find[i].node)) {
          var pos = content.compareDocumentPosition(this$1.find[i].node);

          if (pos & (before ? 2 : 4)) {
            this$1.find[i].pos = this$1.currentPos;
          }
        }
      }
    }
  };

  ParseContext.prototype.findInText = function findInText(textNode) {
    var this$1 = this;

    if (this.find) {
      for (var i = 0; i < this.find.length; i++) {
        if (this$1.find[i].node == textNode) {
          this$1.find[i].pos = this$1.currentPos - (textNode.nodeValue.length - this$1.find[i].offset);
        }
      }
    }
  }; // : (string) → bool
  // Determines whether the given [context
  // string](#ParseRule.context) matches this context.


  ParseContext.prototype.matchesContext = function matchesContext(context) {
    var this$1 = this;

    if (context.indexOf("|") > -1) {
      return context.split(/\s*\|\s*/).some(this.matchesContext, this);
    }

    var parts = context.split("/");
    var option = this.options.context;
    var useRoot = !this.isOpen && (!option || option.parent.type == this.nodes[0].type);
    var minDepth = -(option ? option.depth + 1 : 0) + (useRoot ? 0 : 1);

    var match = function (i, depth) {
      for (; i >= 0; i--) {
        var part = parts[i];

        if (part == "") {
          if (i == parts.length - 1 || i == 0) {
            continue;
          }

          for (; depth >= minDepth; depth--) {
            if (match(i - 1, depth)) {
              return true;
            }
          }

          return false;
        } else {
          var next = depth > 0 || depth == 0 && useRoot ? this$1.nodes[depth].type : option && depth >= minDepth ? option.node(depth - minDepth).type : null;

          if (!next || next.name != part && next.groups.indexOf(part) == -1) {
            return false;
          }

          depth--;
        }
      }

      return true;
    };

    return match(parts.length - 1, this.open);
  };

  ParseContext.prototype.textblockFromContext = function textblockFromContext() {
    var this$1 = this;
    var $context = this.options.context;

    if ($context) {
      for (var d = $context.depth; d >= 0; d--) {
        var deflt = $context.node(d).contentMatchAt($context.indexAfter(d)).defaultType;

        if (deflt && deflt.isTextblock && deflt.defaultAttrs) {
          return deflt;
        }
      }
    }

    for (var name in this$1.parser.schema.nodes) {
      var type = this$1.parser.schema.nodes[name];

      if (type.isTextblock && type.defaultAttrs) {
        return type;
      }
    }
  };

  Object.defineProperties(ParseContext.prototype, prototypeAccessors$6); // Kludge to work around directly nested list nodes produced by some
  // tools and allowed by browsers to mean that the nested list is
  // actually part of the list item above it.

  function normalizeList(dom) {
    for (var child = dom.firstChild, prevItem = null; child; child = child.nextSibling) {
      var name = child.nodeType == 1 ? child.nodeName.toLowerCase() : null;

      if (name && listTags.hasOwnProperty(name) && prevItem) {
        prevItem.appendChild(child);
        child = prevItem;
      } else if (name == "li") {
        prevItem = child;
      } else if (name) {
        prevItem = null;
      }
    }
  } // Apply a CSS selector.


  function matches(dom, selector) {
    return (dom.matches || dom.msMatchesSelector || dom.webkitMatchesSelector || dom.mozMatchesSelector).call(dom, selector);
  } // : (string) → [string]
  // Tokenize a style attribute into property/value pairs.


  function parseStyles(style) {
    var re = /\s*([\w-]+)\s*:\s*([^;]+)/g,
        m,
        result = [];

    while (m = re.exec(style)) {
      result.push(m[1], m[2].trim());
    }

    return result;
  }

  function copy(obj) {
    var copy = {};

    for (var prop in obj) {
      copy[prop] = obj[prop];
    }

    return copy;
  } // DOMOutputSpec:: interface
  // A description of a DOM structure. Can be either a string, which is
  // interpreted as a text node, a DOM node, which is interpreted as
  // itself, or an array.
  //
  // An array describes a DOM element. The first value in the array
  // should be a string—the name of the DOM element. If the second
  // element is plain object, it is interpreted as a set of attributes
  // for the element. Any elements after that (including the 2nd if it's
  // not an attribute object) are interpreted as children of the DOM
  // elements, and must either be valid `DOMOutputSpec` values, or the
  // number zero.
  //
  // The number zero (pronounced “hole”) is used to indicate the place
  // where a node's child nodes should be inserted. It it occurs in an
  // output spec, it should be the only child element in its parent
  // node.
  // ::- A DOM serializer knows how to convert ProseMirror nodes and
  // marks of various types to DOM nodes.


  var DOMSerializer = function DOMSerializer(nodes, marks) {
    // :: Object<(node: Node) → DOMOutputSpec>
    // The node serialization functions.
    this.nodes = nodes || {}; // :: Object<?(mark: Mark, inline: bool) → DOMOutputSpec>
    // The mark serialization functions.

    this.marks = marks || {};
  }; // :: (Fragment, ?Object) → dom.DocumentFragment
  // Serialize the content of this fragment to a DOM fragment. When
  // not in the browser, the `document` option, containing a DOM
  // document, should be passed so that the serializer can create
  // nodes.


  DOMSerializer.prototype.serializeFragment = function serializeFragment(fragment, options, target) {
    var this$1 = this;
    if (options === void 0) options = {};

    if (!target) {
      target = doc(options).createDocumentFragment();
    }

    var top = target,
        active = null;
    fragment.forEach(function (node) {
      if (active || node.marks.length) {
        if (!active) {
          active = [];
        }

        var keep = 0,
            rendered = 0;

        while (keep < active.length && rendered < node.marks.length) {
          var next = node.marks[rendered];

          if (!this$1.marks[next.type.name]) {
            rendered++;
            continue;
          }

          if (!next.eq(active[keep])) {
            break;
          }

          keep += 2;
          rendered++;
        }

        while (keep < active.length) {
          top = active.pop();
          active.pop();
        }

        while (rendered < node.marks.length) {
          var add = node.marks[rendered++];
          var markDOM = this$1.serializeMark(add, node.isInline, options);

          if (markDOM) {
            active.push(add, top);
            top.appendChild(markDOM.dom);
            top = markDOM.contentDOM || markDOM.dom;
          }
        }
      }

      top.appendChild(this$1.serializeNode(node, options));
    });
    return target;
  }; // :: (Node, ?Object) → dom.Node
  // Serialize this node to a DOM node. This can be useful when you
  // need to serialize a part of a document, as opposed to the whole
  // document. To serialize a whole document, use
  // [`serializeFragment`](#model.DOMSerializer.serializeFragment) on
  // its [content](#model.Node.content).


  DOMSerializer.prototype.serializeNode = function serializeNode(node, options) {
    if (options === void 0) options = {};
    var ref = DOMSerializer.renderSpec(doc(options), this.nodes[node.type.name](node));
    var dom = ref.dom;
    var contentDOM = ref.contentDOM;

    if (contentDOM) {
      if (node.isLeaf) {
        throw new RangeError("Content hole not allowed in a leaf node spec");
      }

      if (options.onContent) {
        options.onContent(node, contentDOM, options);
      } else {
        this.serializeFragment(node.content, options, contentDOM);
      }
    }

    return dom;
  };

  DOMSerializer.prototype.serializeNodeAndMarks = function serializeNodeAndMarks(node, options) {
    var this$1 = this;
    if (options === void 0) options = {};
    var dom = this.serializeNode(node, options);

    for (var i = node.marks.length - 1; i >= 0; i--) {
      var wrap = this$1.serializeMark(node.marks[i], node.isInline, options);

      if (wrap) {
        (wrap.contentDOM || wrap.dom).appendChild(dom);
        dom = wrap.dom;
      }
    }

    return dom;
  };

  DOMSerializer.prototype.serializeMark = function serializeMark(mark, inline, options) {
    if (options === void 0) options = {};
    var toDOM = this.marks[mark.type.name];
    return toDOM && DOMSerializer.renderSpec(doc(options), toDOM(mark, inline));
  }; // :: (dom.Document, DOMOutputSpec) → {dom: dom.Node, contentDOM: ?dom.Node}
  // Render an [output spec](#model.DOMOutputSpec) to a DOM node. If
  // the spec has a hole (zero) in it, `contentDOM` will point at the
  // node with the hole.


  DOMSerializer.renderSpec = function renderSpec(doc, structure) {
    if (typeof structure == "string") {
      return {
        dom: doc.createTextNode(structure)
      };
    }

    if (structure.nodeType != null) {
      return {
        dom: structure
      };
    }

    var dom = doc.createElement(structure[0]),
        contentDOM = null;
    var attrs = structure[1],
        start = 1;

    if (attrs && typeof attrs == "object" && attrs.nodeType == null && !Array.isArray(attrs)) {
      start = 2;

      for (var name in attrs) {
        if (name == "style") {
          dom.style.cssText = attrs[name];
        } else if (attrs[name] != null) {
          dom.setAttribute(name, attrs[name]);
        }
      }
    }

    for (var i = start; i < structure.length; i++) {
      var child = structure[i];

      if (child === 0) {
        if (i < structure.length - 1 || i > start) {
          throw new RangeError("Content hole must be the only child of its parent node");
        }

        return {
          dom: dom,
          contentDOM: dom
        };
      } else {
        var ref = DOMSerializer.renderSpec(doc, child);
        var inner = ref.dom;
        var innerContent = ref.contentDOM;
        dom.appendChild(inner);

        if (innerContent) {
          if (contentDOM) {
            throw new RangeError("Multiple content holes");
          }

          contentDOM = innerContent;
        }
      }
    }

    return {
      dom: dom,
      contentDOM: contentDOM
    };
  }; // :: (Schema) → DOMSerializer
  // Build a serializer using the [`toDOM`](#model.NodeSpec.toDOM)
  // properties in a schema's node and mark specs.


  DOMSerializer.fromSchema = function fromSchema(schema) {
    return schema.cached.domSerializer || (schema.cached.domSerializer = new DOMSerializer(this.nodesFromSchema(schema), this.marksFromSchema(schema)));
  }; // : (Schema) → Object<(node: Node) → DOMOutputSpec>
  // Gather the serializers in a schema's node specs into an object.
  // This can be useful as a base to build a custom serializer from.


  DOMSerializer.nodesFromSchema = function nodesFromSchema(schema) {
    var result = gatherToDOM(schema.nodes);

    if (!result.text) {
      result.text = function (node) {
        return node.text;
      };
    }

    return result;
  }; // : (Schema) → Object<(mark: Mark) → DOMOutputSpec>
  // Gather the serializers in a schema's mark specs into an object.


  DOMSerializer.marksFromSchema = function marksFromSchema(schema) {
    return gatherToDOM(schema.marks);
  };

  function gatherToDOM(obj) {
    var result = {};

    for (var name in obj) {
      var toDOM = obj[name].spec.toDOM;

      if (toDOM) {
        result[name] = toDOM;
      }
    }

    return result;
  }

  function doc(options) {
    // declare global: window
    return options.document || window.document;
  }

  exports.Node = Node;
  exports.ResolvedPos = ResolvedPos;
  exports.NodeRange = NodeRange;
  exports.Fragment = Fragment;
  exports.Slice = Slice;
  exports.ReplaceError = ReplaceError;
  exports.Mark = Mark;
  exports.Schema = Schema;
  exports.NodeType = NodeType;
  exports.MarkType = MarkType;
  exports.ContentMatch = ContentMatch;
  exports.DOMParser = DOMParser;
  exports.DOMSerializer = DOMSerializer;
});
unwrapExports(dist);
var dist_1 = dist.Node;
var dist_2 = dist.ResolvedPos;
var dist_3 = dist.NodeRange;
var dist_4 = dist.Fragment;
var dist_5 = dist.Slice;
var dist_6 = dist.ReplaceError;
var dist_7 = dist.Mark;
var dist_8 = dist.Schema;
var dist_9 = dist.NodeType;
var dist_10 = dist.MarkType;
var dist_11 = dist.ContentMatch;
var dist_12 = dist.DOMParser;
var dist_13 = dist.DOMSerializer;

// [Specs](#model.NodeSpec) for the nodes defined in this schema.

const nodes = {
  // :: NodeSpec The top level document node.
  doc: {
    content: "block+"
  },
  // :: NodeSpec A plain paragraph textblock. Represented in the DOM
  // as a `<p>` element.
  paragraph: {
    content: "inline*",
    group: "block",
    parseDOM: [{
      tag: "p"
    }],

    toDOM() {
      return ["p", 0];
    }

  },
  // :: NodeSpec A blockquote (`<blockquote>`) wrapping one or more blocks.
  blockquote: {
    content: "block+",
    group: "block",
    defining: true,
    parseDOM: [{
      tag: "blockquote"
    }],

    toDOM() {
      return ["blockquote", 0];
    }

  },
  // :: NodeSpec A horizontal rule (`<hr>`).
  horizontal_rule: {
    group: "block",
    parseDOM: [{
      tag: "hr"
    }],

    toDOM() {
      return ["hr"];
    }

  },
  // :: NodeSpec A heading textblock, with a `level` attribute that
  // should hold the number 1 to 6. Parsed and serialized as `<h1>` to
  // `<h6>` elements.
  heading: {
    attrs: {
      level: {
        default: 1
      }
    },
    content: "inline*",
    group: "block",
    defining: true,
    parseDOM: [{
      tag: "h1",
      attrs: {
        level: 1
      }
    }, {
      tag: "h2",
      attrs: {
        level: 2
      }
    }, {
      tag: "h3",
      attrs: {
        level: 3
      }
    }, {
      tag: "h4",
      attrs: {
        level: 4
      }
    }, {
      tag: "h5",
      attrs: {
        level: 5
      }
    }, {
      tag: "h6",
      attrs: {
        level: 6
      }
    }],

    toDOM(node) {
      return ["h" + node.attrs.level, 0];
    }

  },
  // :: NodeSpec A code listing. Disallows marks or non-text inline
  // nodes by default. Represented as a `<pre>` element with a
  // `<code>` element inside of it.
  code_block: {
    content: "text*",
    marks: "",
    group: "block",
    code: true,
    defining: true,
    parseDOM: [{
      tag: "pre",
      preserveWhitespace: "full"
    }],

    toDOM() {
      return ["pre", ["code", 0]];
    }

  },
  // :: NodeSpec The text node.
  text: {
    group: "inline"
  },
  // :: NodeSpec An inline image (`<img>`) node. Supports `src`,
  // `alt`, and `href` attributes. The latter two default to the empty
  // string.
  image: {
    inline: true,
    attrs: {
      src: {},
      alt: {
        default: null
      },
      title: {
        default: null
      }
    },
    group: "inline",
    draggable: true,
    parseDOM: [{
      tag: "img[src]",

      getAttrs(dom) {
        return {
          src: dom.getAttribute("src"),
          title: dom.getAttribute("title"),
          alt: dom.getAttribute("alt")
        };
      }

    }],

    toDOM(node) {
      return ["img", node.attrs];
    }

  },
  // :: NodeSpec A hard line break, represented in the DOM as `<br>`.
  hard_break: {
    inline: true,
    group: "inline",
    selectable: false,
    parseDOM: [{
      tag: "br"
    }],

    toDOM() {
      return ["br"];
    }

  } // :: Object [Specs](#model.MarkSpec) for the marks in the schema.

};
const marks = {
  // :: MarkSpec A link. Has `href` and `title` attributes. `title`
  // defaults to the empty string. Rendered and parsed as an `<a>`
  // element.
  link: {
    attrs: {
      href: {},
      title: {
        default: null
      }
    },
    inclusive: false,
    parseDOM: [{
      tag: "a[href]",

      getAttrs(dom) {
        return {
          href: dom.getAttribute("href"),
          title: dom.getAttribute("title")
        };
      }

    }],

    toDOM(node) {
      return ["a", node.attrs];
    }

  },
  // :: MarkSpec An emphasis mark. Rendered as an `<em>` element.
  // Has parse rules that also match `<i>` and `font-style: italic`.
  em: {
    parseDOM: [{
      tag: "i"
    }, {
      tag: "em"
    }, {
      style: "font-style=italic"
    }],

    toDOM() {
      return ["em"];
    }

  },
  // :: MarkSpec A strong mark. Rendered as `<strong>`, parse rules
  // also match `<b>` and `font-weight: bold`.
  strong: {
    parseDOM: [{
      tag: "strong"
    }, // This works around a Google Docs misbehavior where
    // pasted content will be inexplicably wrapped in `<b>`
    // tags with a font-weight normal.
    {
      tag: "b",
      getAttrs: node => node.style.fontWeight != "normal" && null
    }, {
      style: "font-weight",
      getAttrs: value => /^(bold(er)?|[5-9]\d{2,})$/.test(value) && null
    }],

    toDOM() {
      return ["strong"];
    }

  },
  // :: MarkSpec Code font mark. Represented as a `<code>` element.
  code: {
    parseDOM: [{
      tag: "code"
    }],

    toDOM() {
      return ["code"];
    }

  } // :: Schema
  // This schema rougly corresponds to the document schema used by
  // [CommonMark](http://commonmark.org/), minus the list elements,
  // which are defined in the [`prosemirror-schema-list`](#schema-list)
  // module.
  //
  // To reuse elements from this schema, extend or read from its
  // `spec.nodes` and `spec.marks` [properties](#model.Schema.spec).

};
const schema = new dist_8({
  nodes,
  marks
});

function getAttrs(dom) {
  var attrs = {
    src: dom.getAttribute('src'),
    align: dom.getAttribute('align'),
    alt: dom.getAttribute('alt'),
    width: dom.getAttribute('width'),
    height: dom.getAttribute('height')
  };

  if (dom.style.width) {
    attrs.width = parseInt(dom.style.width, 10);
  }

  if (dom.style.height) {
    attrs.height = parseInt(dom.style.height, 10);
  }

  if (dom.style.borderWidth) {
    attrs.border = parseInt(dom.style.borderWidth, 10);
  }

  if (dom.style.border) {
    attrs.border = parseInt(dom.style.border, 10);
  }

  if (dom.style.marginLeft) {
    attrs.horizontalPadding = parseInt(dom.style.marginLeft, 10);
  }

  if (dom.style.marginTop) {
    attrs.verticalPadding = parseInt(dom.style.marginTop, 10);
  }

  return attrs;
}

function setAttrs(attrs) {
  var style = '';

  if (attrs.border) {
    style += "border:".concat(attrs.border, "px solid black; ");
  }

  if (attrs.width) {
    style += "width:".concat(attrs.width, "px; ");
  }

  if (attrs.height) {
    style += "height:".concat(attrs.height, "px; ");
  }

  if (attrs.horizontalPadding || attrs.verticalPadding) {
    style += "margin:".concat(attrs.verticalPadding || 0, "px ").concat(attrs.horizontalPadding || 0, "px; ");
  }

  return {
    src: attrs.src,
    align: attrs.align,
    alt: attrs.alt,
    style: style
  };
}

var imageNodes = {
  image: {
    inline: true,
    attrs: {
      src: {},
      align: {
        default: null
      },
      alt: {
        default: null
      },
      border: {
        default: null
      },
      width: {
        default: null
      },
      height: {
        default: null
      },
      horizontalPadding: {
        default: null
      },
      verticalPadding: {
        default: null
      }
    },
    marks: '',
    group: 'inline',
    draggable: true,
    parseDOM: [{
      tag: 'img[src]',
      getAttrs: getAttrs
    }],
    toDOM: function toDOM(node) {
      return ['img', setAttrs(node.attrs)];
    }
  }
};

function getAttrs$1(dom) {
  var attrs = {
    alignment: dom.getAttribute('align')
  };
  if (dom.style.textAlign) attrs.alignment = dom.style.textAlign;
  var classString = dom.getAttribute('class');
  var color = /color-(\w+)/.exec(classString);
  if (color) attrs.color = color[1];
  var oldIndent = parseInt(dom.style.marginLeft);

  if (oldIndent > 0) {
    attrs.indent = Math.floor(oldIndent / 30);
  } else {
    var indent = /indent-(\d+)/.exec(classString);
    if (indent) attrs.indent = Number(indent[1]);
  }

  return attrs;
}

function setAttrs$1(attrs) {
  var alignment = attrs.alignment,
      color = attrs.color,
      indent = attrs.indent;
  var style = '';
  var className = '';
  if (alignment) style += "text-align: ".concat(alignment);
  if (color) className += " color-".concat(color);
  if (indent !== 0) className += " indent-".concat(indent);
  return {
    class: className.trim(),
    style: style
  };
}

var paragraphNodes = {
  paragraph: {
    attrs: {
      alignment: {
        default: null
      },
      color: {
        default: null
      },
      indent: {
        default: 0
      }
    },
    content: "inline*",
    group: 'block',
    toDOM: function toDOM(node) {
      return ['p', setAttrs$1(node.attrs), 0];
    },
    parseDOM: [{
      tag: 'p',
      getAttrs: getAttrs$1
    }]
  }
};

var getHeadingAttrs = function getHeadingAttrs(level) {
  return function (dom) {
    var attrs = {
      level: level,
      alignment: dom.getAttribute('align')
    };
    if (dom.style.textAlign) attrs.alignment = dom.style.textAlign;
    return attrs;
  };
};

var setHeadingAttrs = function setHeadingAttrs(attrs) {
  var alignment = attrs.alignment;
  var style = '';

  if (alignment) {
    style += "text-align: ".concat(alignment);
  }

  return {
    style: style
  };
};

var headingNodes = {
  heading: {
    attrs: {
      level: {
        default: 1
      },
      alignment: {
        default: null
      }
    },
    content: "inline*",
    group: "block",
    defining: true,
    parseDOM: [{
      tag: "h1",
      getAttrs: getHeadingAttrs(1)
    }, {
      tag: "h2",
      getAttrs: getHeadingAttrs(2)
    }, {
      tag: "h3",
      getAttrs: getHeadingAttrs(3)
    }, {
      tag: "h4",
      getAttrs: getHeadingAttrs(4)
    }, {
      tag: "h5",
      getAttrs: getHeadingAttrs(5)
    }, {
      tag: "h6",
      getAttrs: getHeadingAttrs(6)
    }],
    toDOM: function toDOM(node) {
      return ["h" + node.attrs.level, setHeadingAttrs(node.attrs), 0];
    }
  }
};

var horizontalRuleNodes = {
  horizontal_rule: {
    attrs: {
      thickness: {
        default: 1
      }
    },
    group: "block",
    parseDOM: [{
      tag: "hr",
      getAttrs: function getAttrs(dom) {
        return {
          thickness: dom.style.borderWidth
        };
      }
    }],
    toDOM: function toDOM(node) {
      return ["hr", {
        style: "border-width:".concat(node.attrs.thickness, "px")
      }];
    }
  }
};

var doc = nodes.doc,
    code_block = nodes.code_block,
    text = nodes.text,
    hard_break = nodes.hard_break;
var baseNodes = _objectSpread({
  doc: doc
}, paragraphNodes, headingNodes, {
  code_block: code_block
}, horizontalRuleNodes, {
  text: text,
  hard_break: hard_break
}, imageNodes);

var anchorNodes = {
  anchor: {
    attrs: {
      name: {}
    },
    group: 'block',
    toDOM: function toDOM(node) {
      return ['a', {
        name: node.attrs.name
      }];
    },
    parseDOM: [{
      tag: 'a[name]',
      getAttrs: function getAttrs(dom) {
        return {
          name: dom.getAttribute('name')
        };
      },
      priority: 100
    }]
  }
};

var assessmentNodes = {
  assessmentProblem: {
    attrs: {
      id: {}
    },
    group: 'block',
    content: 'block+',
    toDOM: function toDOM(node) {
      return ['assessment-problem', node.attrs, 0];
    },
    parseDOM: [{
      tag: 'assessment-problem',
      getAttrs: function getAttrs(dom) {
        return {
          id: dom.getAttribute('id')
        };
      }
    }]
  },
  assessmentAnswer: {
    attrs: {
      id: {}
    },
    group: 'block',
    content: 'block+',
    toDOM: function toDOM(node) {
      return ['assessment-answer', node.attrs, 0];
    },
    parseDOM: [{
      tag: 'assessment-answer',
      getAttrs: function getAttrs(dom) {
        return {
          id: dom.getAttribute('id')
        };
      }
    }]
  }
};

var dist$1 = createCommonjsModule(function (module, exports) {

  Object.defineProperty(exports, '__esModule', {
    value: true
  }); // Mappable:: interface
  // There are several things that positions can be mapped through.
  // Such objects conform to this interface.
  //
  //   map:: (pos: number, assoc: ?number) → number
  //   Map a position through this object. When given, `assoc` (should
  //   be -1 or 1, defaults to 1) determines with which side the
  //   position is associated, which determines in which direction to
  //   move when a chunk of content is inserted at the mapped position.
  //
  //   mapResult:: (pos: number, assoc: ?number) → MapResult
  //   Map a position, and return an object containing additional
  //   information about the mapping. The result's `deleted` field tells
  //   you whether the position was deleted (completely enclosed in a
  //   replaced range) during the mapping. When content on only one side
  //   is deleted, the position itself is only considered deleted when
  //   `assoc` points in the direction of the deleted content.
  // Recovery values encode a range index and an offset. They are
  // represented as numbers, because tons of them will be created when
  // mapping, for example, a large number of decorations. The number's
  // lower 16 bits provide the index, the remaining bits the offset.
  //
  // Note: We intentionally don't use bit shift operators to en- and
  // decode these, since those clip to 32 bits, which we might in rare
  // cases want to overflow. A 64-bit float can represent 48-bit
  // integers precisely.

  var lower16 = 0xffff;
  var factor16 = Math.pow(2, 16);

  function makeRecover(index, offset) {
    return index + offset * factor16;
  }

  function recoverIndex(value) {
    return value & lower16;
  }

  function recoverOffset(value) {
    return (value - (value & lower16)) / factor16;
  } // ::- An object representing a mapped position with extra
  // information.


  var MapResult = function MapResult(pos, deleted, recover) {
    if (deleted === void 0) deleted = false;
    if (recover === void 0) recover = null; // :: number The mapped version of the position.

    this.pos = pos; // :: bool Tells you whether the position was deleted, that is,
    // whether the step removed its surroundings from the document.

    this.deleted = deleted;
    this.recover = recover;
  }; // :: class extends Mappable
  // A map describing the deletions and insertions made by a step, which
  // can be used to find the correspondence between positions in the
  // pre-step version of a document and the same position in the
  // post-step version.


  var StepMap = function StepMap(ranges, inverted) {
    if (inverted === void 0) inverted = false;
    this.ranges = ranges;
    this.inverted = inverted;
  };

  StepMap.prototype.recover = function recover(value) {
    var this$1 = this;
    var diff = 0,
        index = recoverIndex(value);

    if (!this.inverted) {
      for (var i = 0; i < index; i++) {
        diff += this$1.ranges[i * 3 + 2] - this$1.ranges[i * 3 + 1];
      }
    }

    return this.ranges[index * 3] + diff + recoverOffset(value);
  }; // : (number, ?number) → MapResult


  StepMap.prototype.mapResult = function mapResult(pos, assoc) {
    if (assoc === void 0) assoc = 1;
    return this._map(pos, assoc, false);
  }; // : (number, ?number) → number


  StepMap.prototype.map = function map(pos, assoc) {
    if (assoc === void 0) assoc = 1;
    return this._map(pos, assoc, true);
  };

  StepMap.prototype._map = function _map(pos, assoc, simple) {
    var this$1 = this;
    var diff = 0,
        oldIndex = this.inverted ? 2 : 1,
        newIndex = this.inverted ? 1 : 2;

    for (var i = 0; i < this.ranges.length; i += 3) {
      var start = this$1.ranges[i] - (this$1.inverted ? diff : 0);

      if (start > pos) {
        break;
      }

      var oldSize = this$1.ranges[i + oldIndex],
          newSize = this$1.ranges[i + newIndex],
          end = start + oldSize;

      if (pos <= end) {
        var side = !oldSize ? assoc : pos == start ? -1 : pos == end ? 1 : assoc;
        var result = start + diff + (side < 0 ? 0 : newSize);

        if (simple) {
          return result;
        }

        var recover = makeRecover(i / 3, pos - start);
        return new MapResult(result, assoc < 0 ? pos != start : pos != end, recover);
      }

      diff += newSize - oldSize;
    }

    return simple ? pos + diff : new MapResult(pos + diff);
  };

  StepMap.prototype.touches = function touches(pos, recover) {
    var this$1 = this;
    var diff = 0,
        index = recoverIndex(recover);
    var oldIndex = this.inverted ? 2 : 1,
        newIndex = this.inverted ? 1 : 2;

    for (var i = 0; i < this.ranges.length; i += 3) {
      var start = this$1.ranges[i] - (this$1.inverted ? diff : 0);

      if (start > pos) {
        break;
      }

      var oldSize = this$1.ranges[i + oldIndex],
          end = start + oldSize;

      if (pos <= end && i == index * 3) {
        return true;
      }

      diff += this$1.ranges[i + newIndex] - oldSize;
    }

    return false;
  }; // :: ((oldStart: number, oldEnd: number, newStart: number, newEnd: number))
  // Calls the given function on each of the changed ranges included in
  // this map.


  StepMap.prototype.forEach = function forEach(f) {
    var this$1 = this;
    var oldIndex = this.inverted ? 2 : 1,
        newIndex = this.inverted ? 1 : 2;

    for (var i = 0, diff = 0; i < this.ranges.length; i += 3) {
      var start = this$1.ranges[i],
          oldStart = start - (this$1.inverted ? diff : 0),
          newStart = start + (this$1.inverted ? 0 : diff);
      var oldSize = this$1.ranges[i + oldIndex],
          newSize = this$1.ranges[i + newIndex];
      f(oldStart, oldStart + oldSize, newStart, newStart + newSize);
      diff += newSize - oldSize;
    }
  }; // :: () → StepMap
  // Create an inverted version of this map. The result can be used to
  // map positions in the post-step document to the pre-step document.


  StepMap.prototype.invert = function invert() {
    return new StepMap(this.ranges, !this.inverted);
  };

  StepMap.prototype.toString = function toString() {
    return (this.inverted ? "-" : "") + JSON.stringify(this.ranges);
  }; // :: (n: number) → StepMap
  // Create a map that moves all positions by offset `n` (which may be
  // negative). This can be useful when applying steps meant for a
  // sub-document to a larger document, or vice-versa.


  StepMap.offset = function offset(n) {
    return n == 0 ? StepMap.empty : new StepMap(n < 0 ? [0, -n, 0] : [0, 0, n]);
  };

  StepMap.empty = new StepMap([]); // :: class extends Mappable
  // A mapping represents a pipeline of zero or more [step
  // maps](#transform.StepMap). It has special provisions for losslessly
  // handling mapping positions through a series of steps in which some
  // steps are inverted versions of earlier steps. (This comes up when
  // ‘[rebasing](/docs/guide/#transform.rebasing)’ steps for
  // collaboration or history management.)

  var Mapping = function Mapping(maps, mirror, from, to) {
    // :: [StepMap]
    // The step maps in this mapping.
    this.maps = maps || []; // :: number
    // The starting position in the `maps` array, used when `map` or
    // `mapResult` is called.

    this.from = from || 0; // :: number
    // The end position in the `maps` array.

    this.to = to == null ? this.maps.length : to;
    this.mirror = mirror;
  }; // :: (?number, ?number) → Mapping
  // Create a mapping that maps only through a part of this one.


  Mapping.prototype.slice = function slice(from, to) {
    if (from === void 0) from = 0;
    if (to === void 0) to = this.maps.length;
    return new Mapping(this.maps, this.mirror, from, to);
  };

  Mapping.prototype.copy = function copy() {
    return new Mapping(this.maps.slice(), this.mirror && this.mirror.slice(), this.from, this.to);
  }; // :: (StepMap, ?number)
  // Add a step map to the end of this mapping. If `mirrors` is
  // given, it should be the index of the step map that is the mirror
  // image of this one.


  Mapping.prototype.appendMap = function appendMap(map, mirrors) {
    this.to = this.maps.push(map);

    if (mirrors != null) {
      this.setMirror(this.maps.length - 1, mirrors);
    }
  }; // :: (Mapping)
  // Add all the step maps in a given mapping to this one (preserving
  // mirroring information).


  Mapping.prototype.appendMapping = function appendMapping(mapping) {
    var this$1 = this;

    for (var i = 0, startSize = this.maps.length; i < mapping.maps.length; i++) {
      var mirr = mapping.getMirror(i);
      this$1.appendMap(mapping.maps[i], mirr != null && mirr < i ? startSize + mirr : null);
    }
  }; // :: (number) → ?number
  // Finds the offset of the step map that mirrors the map at the
  // given offset, in this mapping (as per the second argument to
  // `appendMap`).


  Mapping.prototype.getMirror = function getMirror(n) {
    var this$1 = this;

    if (this.mirror) {
      for (var i = 0; i < this.mirror.length; i++) {
        if (this$1.mirror[i] == n) {
          return this$1.mirror[i + (i % 2 ? -1 : 1)];
        }
      }
    }
  };

  Mapping.prototype.setMirror = function setMirror(n, m) {
    if (!this.mirror) {
      this.mirror = [];
    }

    this.mirror.push(n, m);
  }; // :: (Mapping)
  // Append the inverse of the given mapping to this one.


  Mapping.prototype.appendMappingInverted = function appendMappingInverted(mapping) {
    var this$1 = this;

    for (var i = mapping.maps.length - 1, totalSize = this.maps.length + mapping.maps.length; i >= 0; i--) {
      var mirr = mapping.getMirror(i);
      this$1.appendMap(mapping.maps[i].invert(), mirr != null && mirr > i ? totalSize - mirr - 1 : null);
    }
  }; // () → Mapping
  // Create an inverted version of this mapping.


  Mapping.prototype.invert = function invert() {
    var inverse = new Mapping();
    inverse.appendMappingInverted(this);
    return inverse;
  }; // : (number, ?number) → number
  // Map a position through this mapping.


  Mapping.prototype.map = function map(pos, assoc) {
    var this$1 = this;
    if (assoc === void 0) assoc = 1;

    if (this.mirror) {
      return this._map(pos, assoc, true);
    }

    for (var i = this.from; i < this.to; i++) {
      pos = this$1.maps[i].map(pos, assoc);
    }

    return pos;
  }; // : (number, ?number) → MapResult
  // Map a position through this mapping, returning a mapping
  // result.


  Mapping.prototype.mapResult = function mapResult(pos, assoc) {
    if (assoc === void 0) assoc = 1;
    return this._map(pos, assoc, false);
  };

  Mapping.prototype._map = function _map(pos, assoc, simple) {
    var this$1 = this;
    var deleted = false,
        recoverables = null;

    for (var i = this.from; i < this.to; i++) {
      var map = this$1.maps[i],
          rec = recoverables && recoverables[i];

      if (rec != null && map.touches(pos, rec)) {
        pos = map.recover(rec);
        continue;
      }

      var result = map.mapResult(pos, assoc);

      if (result.recover != null) {
        var corr = this$1.getMirror(i);

        if (corr != null && corr > i && corr < this$1.to) {
          if (result.deleted) {
            i = corr;
            pos = this$1.maps[corr].recover(result.recover);
            continue;
          } else {
            (recoverables || (recoverables = Object.create(null)))[corr] = result.recover;
          }
        }
      }

      if (result.deleted) {
        deleted = true;
      }

      pos = result.pos;
    }

    return simple ? pos : new MapResult(pos, deleted);
  };

  function TransformError(message) {
    var err = Error.call(this, message);
    err.__proto__ = TransformError.prototype;
    return err;
  }

  TransformError.prototype = Object.create(Error.prototype);
  TransformError.prototype.constructor = TransformError;
  TransformError.prototype.name = "TransformError"; // ::- Abstraction to build up and track an array of
  // [steps](#transform.Step) representing a document transformation.
  //
  // Most transforming methods return the `Transform` object itself, so
  // that they can be chained.

  var Transform = function Transform(doc) {
    // :: Node
    // The current document (the result of applying the steps in the
    // transform).
    this.doc = doc; // :: [Step]
    // The steps in this transform.

    this.steps = []; // :: [Node]
    // The documents before each of the steps.

    this.docs = []; // :: Mapping
    // A mapping with the maps for each of the steps in this transform.

    this.mapping = new Mapping();
  };

  var prototypeAccessors = {
    before: {},
    docChanged: {}
  }; // :: Node The starting document.

  prototypeAccessors.before.get = function () {
    return this.docs.length ? this.docs[0] : this.doc;
  }; // :: (step: Step) → this
  // Apply a new step in this transform, saving the result. Throws an
  // error when the step fails.


  Transform.prototype.step = function step(object) {
    var result = this.maybeStep(object);

    if (result.failed) {
      throw new TransformError(result.failed);
    }

    return this;
  }; // :: (Step) → StepResult
  // Try to apply a step in this transformation, ignoring it if it
  // fails. Returns the step result.


  Transform.prototype.maybeStep = function maybeStep(step) {
    var result = step.apply(this.doc);

    if (!result.failed) {
      this.addStep(step, result.doc);
    }

    return result;
  }; // :: bool
  // True when the document has been changed (when there are any
  // steps).


  prototypeAccessors.docChanged.get = function () {
    return this.steps.length > 0;
  };

  Transform.prototype.addStep = function addStep(step, doc) {
    this.docs.push(this.doc);
    this.steps.push(step);
    this.mapping.appendMap(step.getMap());
    this.doc = doc;
  };

  Object.defineProperties(Transform.prototype, prototypeAccessors);

  function mustOverride() {
    throw new Error("Override me");
  }

  var stepsByID = Object.create(null); // ::- A step object represents an atomic change. It generally applies
  // only to the document it was created for, since the positions
  // stored in it will only make sense for that document.
  //
  // New steps are defined by creating classes that extend `Step`,
  // overriding the `apply`, `invert`, `map`, `getMap` and `fromJSON`
  // methods, and registering your class with a unique
  // JSON-serialization identifier using
  // [`Step.jsonID`](#transform.Step^jsonID).

  var Step = function Step() {};

  Step.prototype.apply = function apply(_doc) {
    return mustOverride();
  }; // :: () → StepMap
  // Get the step map that represents the changes made by this step,
  // and which can be used to transform between positions in the old
  // and the new document.


  Step.prototype.getMap = function getMap() {
    return StepMap.empty;
  }; // :: (doc: Node) → Step
  // Create an inverted version of this step. Needs the document as it
  // was before the step as argument.


  Step.prototype.invert = function invert(_doc) {
    return mustOverride();
  }; // :: (mapping: Mappable) → ?Step
  // Map this step through a mappable thing, returning either a
  // version of that step with its positions adjusted, or `null` if
  // the step was entirely deleted by the mapping.


  Step.prototype.map = function map(_mapping) {
    return mustOverride();
  }; // :: (other: Step) → ?Step
  // Try to merge this step with another one, to be applied directly
  // after it. Returns the merged step when possible, null if the
  // steps can't be merged.


  Step.prototype.merge = function merge(_other) {
    return null;
  }; // :: () → Object
  // Create a JSON-serializeable representation of this step. When
  // defining this for a custom subclass, make sure the result object
  // includes the step type's [JSON id](#transform.Step^jsonID) under
  // the `stepType` property.


  Step.prototype.toJSON = function toJSON() {
    return mustOverride();
  }; // :: (Schema, Object) → Step
  // Deserialize a step from its JSON representation. Will call
  // through to the step class' own implementation of this method.


  Step.fromJSON = function fromJSON(schema, json) {
    if (!json || !json.stepType) {
      throw new RangeError("Invalid input for Step.fromJSON");
    }

    var type = stepsByID[json.stepType];

    if (!type) {
      throw new RangeError("No step type " + json.stepType + " defined");
    }

    return type.fromJSON(schema, json);
  }; // :: (string, constructor<Step>)
  // To be able to serialize steps to JSON, each step needs a string
  // ID to attach to its JSON representation. Use this method to
  // register an ID for your step classes. Try to pick something
  // that's unlikely to clash with steps from other modules.


  Step.jsonID = function jsonID(id, stepClass) {
    if (id in stepsByID) {
      throw new RangeError("Duplicate use of step JSON ID " + id);
    }

    stepsByID[id] = stepClass;
    stepClass.prototype.jsonID = id;
    return stepClass;
  }; // ::- The result of [applying](#transform.Step.apply) a step. Contains either a
  // new document or a failure value.


  var StepResult = function StepResult(doc, failed) {
    // :: ?Node The transformed document.
    this.doc = doc; // :: ?string Text providing information about a failed step.

    this.failed = failed;
  }; // :: (Node) → StepResult
  // Create a successful step result.


  StepResult.ok = function ok(doc) {
    return new StepResult(doc, null);
  }; // :: (string) → StepResult
  // Create a failed step result.


  StepResult.fail = function fail(message) {
    return new StepResult(null, message);
  }; // :: (Node, number, number, Slice) → StepResult
  // Call [`Node.replace`](#model.Node.replace) with the given
  // arguments. Create a successful result if it succeeds, and a
  // failed one if it throws a `ReplaceError`.


  StepResult.fromReplace = function fromReplace(doc, from, to, slice) {
    try {
      return StepResult.ok(doc.replace(from, to, slice));
    } catch (e) {
      if (e instanceof dist.ReplaceError) {
        return StepResult.fail(e.message);
      }

      throw e;
    }
  }; // ::- Replace a part of the document with a slice of new content.


  var ReplaceStep = function (Step$$1) {
    function ReplaceStep(from, to, slice, structure) {
      Step$$1.call(this);
      this.from = from;
      this.to = to;
      this.slice = slice;
      this.structure = !!structure;
    }

    if (Step$$1) ReplaceStep.__proto__ = Step$$1;
    ReplaceStep.prototype = Object.create(Step$$1 && Step$$1.prototype);
    ReplaceStep.prototype.constructor = ReplaceStep;

    ReplaceStep.prototype.apply = function apply(doc) {
      if (this.structure && contentBetween(doc, this.from, this.to)) {
        return StepResult.fail("Structure replace would overwrite content");
      }

      return StepResult.fromReplace(doc, this.from, this.to, this.slice);
    };

    ReplaceStep.prototype.getMap = function getMap() {
      return new StepMap([this.from, this.to - this.from, this.slice.size]);
    };

    ReplaceStep.prototype.invert = function invert(doc) {
      return new ReplaceStep(this.from, this.from + this.slice.size, doc.slice(this.from, this.to));
    };

    ReplaceStep.prototype.map = function map(mapping) {
      var from = mapping.mapResult(this.from, 1),
          to = mapping.mapResult(this.to, -1);

      if (from.deleted && to.deleted) {
        return null;
      }

      return new ReplaceStep(from.pos, Math.max(from.pos, to.pos), this.slice);
    };

    ReplaceStep.prototype.merge = function merge(other) {
      if (!(other instanceof ReplaceStep) || other.structure != this.structure) {
        return null;
      }

      if (this.from + this.slice.size == other.from && !this.slice.openEnd && !other.slice.openStart) {
        var slice = this.slice.size + other.slice.size == 0 ? dist.Slice.empty : new dist.Slice(this.slice.content.append(other.slice.content), this.slice.openStart, other.slice.openEnd);
        return new ReplaceStep(this.from, this.to + (other.to - other.from), slice, this.structure);
      } else if (other.to == this.from && !this.slice.openStart && !other.slice.openEnd) {
        var slice$1 = this.slice.size + other.slice.size == 0 ? dist.Slice.empty : new dist.Slice(other.slice.content.append(this.slice.content), other.slice.openStart, this.slice.openEnd);
        return new ReplaceStep(other.from, this.to, slice$1, this.structure);
      } else {
        return null;
      }
    };

    ReplaceStep.prototype.toJSON = function toJSON() {
      var json = {
        stepType: "replace",
        from: this.from,
        to: this.to
      };

      if (this.slice.size) {
        json.slice = this.slice.toJSON();
      }

      if (this.structure) {
        json.structure = true;
      }

      return json;
    };

    ReplaceStep.fromJSON = function fromJSON(schema, json) {
      if (typeof json.from != "number" || typeof json.to != "number") {
        throw new RangeError("Invalid input for ReplaceStep.fromJSON");
      }

      return new ReplaceStep(json.from, json.to, dist.Slice.fromJSON(schema, json.slice), !!json.structure);
    };

    return ReplaceStep;
  }(Step);

  Step.jsonID("replace", ReplaceStep); // ::- Replace a part of the document with a slice of content, but
  // preserve a range of the replaced content by moving it into the
  // slice.

  var ReplaceAroundStep = function (Step$$1) {
    function ReplaceAroundStep(from, to, gapFrom, gapTo, slice, insert, structure) {
      Step$$1.call(this);
      this.from = from;
      this.to = to;
      this.gapFrom = gapFrom;
      this.gapTo = gapTo;
      this.slice = slice;
      this.insert = insert;
      this.structure = !!structure;
    }

    if (Step$$1) ReplaceAroundStep.__proto__ = Step$$1;
    ReplaceAroundStep.prototype = Object.create(Step$$1 && Step$$1.prototype);
    ReplaceAroundStep.prototype.constructor = ReplaceAroundStep;

    ReplaceAroundStep.prototype.apply = function apply(doc) {
      if (this.structure && (contentBetween(doc, this.from, this.gapFrom) || contentBetween(doc, this.gapTo, this.to))) {
        return StepResult.fail("Structure gap-replace would overwrite content");
      }

      var gap = doc.slice(this.gapFrom, this.gapTo);

      if (gap.openStart || gap.openEnd) {
        return StepResult.fail("Gap is not a flat range");
      }

      var inserted = this.slice.insertAt(this.insert, gap.content);

      if (!inserted) {
        return StepResult.fail("Content does not fit in gap");
      }

      return StepResult.fromReplace(doc, this.from, this.to, inserted);
    };

    ReplaceAroundStep.prototype.getMap = function getMap() {
      return new StepMap([this.from, this.gapFrom - this.from, this.insert, this.gapTo, this.to - this.gapTo, this.slice.size - this.insert]);
    };

    ReplaceAroundStep.prototype.invert = function invert(doc) {
      var gap = this.gapTo - this.gapFrom;
      return new ReplaceAroundStep(this.from, this.from + this.slice.size + gap, this.from + this.insert, this.from + this.insert + gap, doc.slice(this.from, this.to).removeBetween(this.gapFrom - this.from, this.gapTo - this.from), this.gapFrom - this.from, this.structure);
    };

    ReplaceAroundStep.prototype.map = function map(mapping) {
      var from = mapping.mapResult(this.from, 1),
          to = mapping.mapResult(this.to, -1);
      var gapFrom = mapping.map(this.gapFrom, -1),
          gapTo = mapping.map(this.gapTo, 1);

      if (from.deleted && to.deleted || gapFrom < from.pos || gapTo > to.pos) {
        return null;
      }

      return new ReplaceAroundStep(from.pos, to.pos, gapFrom, gapTo, this.slice, this.insert, this.structure);
    };

    ReplaceAroundStep.prototype.toJSON = function toJSON() {
      var json = {
        stepType: "replaceAround",
        from: this.from,
        to: this.to,
        gapFrom: this.gapFrom,
        gapTo: this.gapTo,
        insert: this.insert
      };

      if (this.slice.size) {
        json.slice = this.slice.toJSON();
      }

      if (this.structure) {
        json.structure = true;
      }

      return json;
    };

    ReplaceAroundStep.fromJSON = function fromJSON(schema, json) {
      if (typeof json.from != "number" || typeof json.to != "number" || typeof json.gapFrom != "number" || typeof json.gapTo != "number" || typeof json.insert != "number") {
        throw new RangeError("Invalid input for ReplaceAroundStep.fromJSON");
      }

      return new ReplaceAroundStep(json.from, json.to, json.gapFrom, json.gapTo, dist.Slice.fromJSON(schema, json.slice), json.insert, !!json.structure);
    };

    return ReplaceAroundStep;
  }(Step);

  Step.jsonID("replaceAround", ReplaceAroundStep);

  function contentBetween(doc, from, to) {
    var $from = doc.resolve(from),
        dist$$1 = to - from,
        depth = $from.depth;

    while (dist$$1 > 0 && depth > 0 && $from.indexAfter(depth) == $from.node(depth).childCount) {
      depth--;
      dist$$1--;
    }

    if (dist$$1 > 0) {
      var next = $from.node(depth).maybeChild($from.indexAfter(depth));

      while (dist$$1 > 0) {
        if (!next || next.isLeaf) {
          return true;
        }

        next = next.firstChild;
        dist$$1--;
      }
    }

    return false;
  }

  function canCut(node, start, end) {
    return (start == 0 || node.canReplace(start, node.childCount)) && (end == node.childCount || node.canReplace(0, end));
  } // :: (NodeRange) → ?number
  // Try to find a target depth to which the content in the given range
  // can be lifted. Will not go across
  // [isolating](#model.NodeSpec.isolating) parent nodes.


  function liftTarget(range) {
    var parent = range.parent;
    var content = parent.content.cutByIndex(range.startIndex, range.endIndex);

    for (var depth = range.depth;; --depth) {
      var node = range.$from.node(depth);
      var index = range.$from.index(depth),
          endIndex = range.$to.indexAfter(depth);

      if (depth < range.depth && node.canReplace(index, endIndex, content)) {
        return depth;
      }

      if (depth == 0 || node.type.spec.isolating || !canCut(node, index, endIndex)) {
        break;
      }
    }
  } // :: (NodeRange, number) → this
  // Split the content in the given range off from its parent, if there
  // is sibling content before or after it, and move it up the tree to
  // the depth specified by `target`. You'll probably want to use
  // [`liftTarget`](#transform.liftTarget) to compute `target`, to make
  // sure the lift is valid.


  Transform.prototype.lift = function (range, target) {
    var $from = range.$from;
    var $to = range.$to;
    var depth = range.depth;
    var gapStart = $from.before(depth + 1),
        gapEnd = $to.after(depth + 1);
    var start = gapStart,
        end = gapEnd;
    var before = dist.Fragment.empty,
        openStart = 0;

    for (var d = depth, splitting = false; d > target; d--) {
      if (splitting || $from.index(d) > 0) {
        splitting = true;
        before = dist.Fragment.from($from.node(d).copy(before));
        openStart++;
      } else {
        start--;
      }
    }

    var after = dist.Fragment.empty,
        openEnd = 0;

    for (var d$1 = depth, splitting$1 = false; d$1 > target; d$1--) {
      if (splitting$1 || $to.after(d$1 + 1) < $to.end(d$1)) {
        splitting$1 = true;
        after = dist.Fragment.from($to.node(d$1).copy(after));
        openEnd++;
      } else {
        end++;
      }
    }

    return this.step(new ReplaceAroundStep(start, end, gapStart, gapEnd, new dist.Slice(before.append(after), openStart, openEnd), before.size - openStart, true));
  }; // :: (NodeRange, NodeType, ?Object, ?NodeRange) → ?[{type: NodeType, attrs: ?Object}]
  // Try to find a valid way to wrap the content in the given range in a
  // node of the given type. May introduce extra nodes around and inside
  // the wrapper node, if necessary. Returns null if no valid wrapping
  // could be found. When `innerRange` is given, that range's content is
  // used as the content to fit into the wrapping, instead of the
  // content of `range`.


  function findWrapping(range, nodeType, attrs, innerRange) {
    if (innerRange === void 0) innerRange = range;
    var around = findWrappingOutside(range, nodeType);
    var inner = around && findWrappingInside(innerRange, nodeType);

    if (!inner) {
      return null;
    }

    return around.map(withAttrs).concat({
      type: nodeType,
      attrs: attrs
    }).concat(inner.map(withAttrs));
  }

  function withAttrs(type) {
    return {
      type: type,
      attrs: null
    };
  }

  function findWrappingOutside(range, type) {
    var parent = range.parent;
    var startIndex = range.startIndex;
    var endIndex = range.endIndex;
    var around = parent.contentMatchAt(startIndex).findWrapping(type);

    if (!around) {
      return null;
    }

    var outer = around.length ? around[0] : type;
    return parent.canReplaceWith(startIndex, endIndex, outer) ? around : null;
  }

  function findWrappingInside(range, type) {
    var parent = range.parent;
    var startIndex = range.startIndex;
    var endIndex = range.endIndex;
    var inner = parent.child(startIndex);
    var inside = type.contentMatch.findWrapping(inner.type);

    if (!inside) {
      return null;
    }

    var lastType = inside.length ? inside[inside.length - 1] : type;
    var innerMatch = lastType.contentMatch;

    for (var i = startIndex; innerMatch && i < endIndex; i++) {
      innerMatch = innerMatch.matchType(parent.child(i).type);
    }

    if (!innerMatch || !innerMatch.validEnd) {
      return null;
    }

    return inside;
  } // :: (NodeRange, [{type: NodeType, attrs: ?Object}]) → this
  // Wrap the given [range](#model.NodeRange) in the given set of wrappers.
  // The wrappers are assumed to be valid in this position, and should
  // probably be computed with [`findWrapping`](#transform.findWrapping).


  Transform.prototype.wrap = function (range, wrappers) {
    var content = dist.Fragment.empty;

    for (var i = wrappers.length - 1; i >= 0; i--) {
      content = dist.Fragment.from(wrappers[i].type.create(wrappers[i].attrs, content));
    }

    var start = range.start,
        end = range.end;
    return this.step(new ReplaceAroundStep(start, end, start, end, new dist.Slice(content, 0, 0), wrappers.length, true));
  }; // :: (number, ?number, NodeType, ?Object) → this
  // Set the type of all textblocks (partly) between `from` and `to` to
  // the given node type with the given attributes.


  Transform.prototype.setBlockType = function (from, to, type, attrs) {
    var this$1 = this;
    if (to === void 0) to = from;

    if (!type.isTextblock) {
      throw new RangeError("Type given to setBlockType should be a textblock");
    }

    var mapFrom = this.steps.length;
    this.doc.nodesBetween(from, to, function (node, pos) {
      if (node.isTextblock && !node.hasMarkup(type, attrs) && canChangeType(this$1.doc, this$1.mapping.slice(mapFrom).map(pos), type)) {
        // Ensure all markup that isn't allowed in the new node type is cleared
        this$1.clearIncompatible(this$1.mapping.slice(mapFrom).map(pos, 1), type);
        var mapping = this$1.mapping.slice(mapFrom);
        var startM = mapping.map(pos, 1),
            endM = mapping.map(pos + node.nodeSize, 1);
        this$1.step(new ReplaceAroundStep(startM, endM, startM + 1, endM - 1, new dist.Slice(dist.Fragment.from(type.create(attrs, null, node.marks)), 0, 0), 1, true));
        return false;
      }
    });
    return this;
  };

  function canChangeType(doc, pos, type) {
    var $pos = doc.resolve(pos),
        index = $pos.index();
    return $pos.parent.canReplaceWith(index, index + 1, type);
  } // :: (number, ?NodeType, ?Object, ?[Mark]) → this
  // Change the type, attributes, and/or marks of the node at `pos`.
  // When `type` isn't given, the existing node type is preserved,


  Transform.prototype.setNodeMarkup = function (pos, type, attrs, marks) {
    var node = this.doc.nodeAt(pos);

    if (!node) {
      throw new RangeError("No node at given position");
    }

    if (!type) {
      type = node.type;
    }

    var newNode = type.create(attrs, null, marks || node.marks);

    if (node.isLeaf) {
      return this.replaceWith(pos, pos + node.nodeSize, newNode);
    }

    if (!type.validContent(node.content)) {
      throw new RangeError("Invalid content for node type " + type.name);
    }

    return this.step(new ReplaceAroundStep(pos, pos + node.nodeSize, pos + 1, pos + node.nodeSize - 1, new dist.Slice(dist.Fragment.from(newNode), 0, 0), 1, true));
  }; // :: (Node, number, number, ?[?{type: NodeType, attrs: ?Object}]) → bool
  // Check whether splitting at the given position is allowed.


  function canSplit(doc, pos, depth, typesAfter) {
    if (depth === void 0) depth = 1;
    var $pos = doc.resolve(pos),
        base = $pos.depth - depth;
    var innerType = typesAfter && typesAfter[typesAfter.length - 1] || $pos.parent;

    if (base < 0 || $pos.parent.type.spec.isolating || !$pos.parent.canReplace($pos.index(), $pos.parent.childCount) || !innerType.type.validContent($pos.parent.content.cutByIndex($pos.index(), $pos.parent.childCount))) {
      return false;
    }

    for (var d = $pos.depth - 1, i = depth - 2; d > base; d--, i--) {
      var node = $pos.node(d),
          index$1 = $pos.index(d);

      if (node.type.spec.isolating) {
        return false;
      }

      var rest = node.content.cutByIndex(index$1, node.childCount);
      var after = typesAfter && typesAfter[i] || node;

      if (after != node) {
        rest = rest.replaceChild(0, after.type.create(after.attrs));
      }

      if (!node.canReplace(index$1 + 1, node.childCount) || !after.type.validContent(rest)) {
        return false;
      }
    }

    var index = $pos.indexAfter(base);
    var baseType = typesAfter && typesAfter[0];
    return $pos.node(base).canReplaceWith(index, index, baseType ? baseType.type : $pos.node(base + 1).type);
  } // :: (number, ?number, ?[?{type: NodeType, attrs: ?Object}]) → this
  // Split the node at the given position, and optionally, if `depth` is
  // greater than one, any number of nodes above that. By default, the
  // parts split off will inherit the node type of the original node.
  // This can be changed by passing an array of types and attributes to
  // use after the split.


  Transform.prototype.split = function (pos, depth, typesAfter) {
    if (depth === void 0) depth = 1;
    var $pos = this.doc.resolve(pos),
        before = dist.Fragment.empty,
        after = dist.Fragment.empty;

    for (var d = $pos.depth, e = $pos.depth - depth, i = depth - 1; d > e; d--, i--) {
      before = dist.Fragment.from($pos.node(d).copy(before));
      var typeAfter = typesAfter && typesAfter[i];
      after = dist.Fragment.from(typeAfter ? typeAfter.type.create(typeAfter.attrs, after) : $pos.node(d).copy(after));
    }

    return this.step(new ReplaceStep(pos, pos, new dist.Slice(before.append(after), depth, depth, true)));
  }; // :: (Node, number) → bool
  // Test whether the blocks before and after a given position can be
  // joined.


  function canJoin(doc, pos) {
    var $pos = doc.resolve(pos),
        index = $pos.index();
    return joinable($pos.nodeBefore, $pos.nodeAfter) && $pos.parent.canReplace(index, index + 1);
  }

  function joinable(a, b) {
    return a && b && !a.isLeaf && a.canAppend(b);
  } // :: (Node, number, ?number) → ?number
  // Find an ancestor of the given position that can be joined to the
  // block before (or after if `dir` is positive). Returns the joinable
  // point, if any.


  function joinPoint(doc, pos, dir) {
    if (dir === void 0) dir = -1;
    var $pos = doc.resolve(pos);

    for (var d = $pos.depth;; d--) {
      var before = void 0,
          after = void 0;

      if (d == $pos.depth) {
        before = $pos.nodeBefore;
        after = $pos.nodeAfter;
      } else if (dir > 0) {
        before = $pos.node(d + 1);
        after = $pos.node(d).maybeChild($pos.index(d) + 1);
      } else {
        before = $pos.node(d).maybeChild($pos.index(d) - 1);
        after = $pos.node(d + 1);
      }

      if (before && !before.isTextblock && joinable(before, after)) {
        return pos;
      }

      if (d == 0) {
        break;
      }

      pos = dir < 0 ? $pos.before(d) : $pos.after(d);
    }
  } // :: (number, ?number) → this
  // Join the blocks around the given position. If depth is 2, their
  // last and first siblings are also joined, and so on.


  Transform.prototype.join = function (pos, depth) {
    if (depth === void 0) depth = 1;
    var step = new ReplaceStep(pos - depth, pos + depth, dist.Slice.empty, true);
    return this.step(step);
  }; // :: (Node, number, NodeType) → ?number
  // Try to find a point where a node of the given type can be inserted
  // near `pos`, by searching up the node hierarchy when `pos` itself
  // isn't a valid place but is at the start or end of a node. Return
  // null if no position was found.


  function insertPoint(doc, pos, nodeType) {
    var $pos = doc.resolve(pos);

    if ($pos.parent.canReplaceWith($pos.index(), $pos.index(), nodeType)) {
      return pos;
    }

    if ($pos.parentOffset == 0) {
      for (var d = $pos.depth - 1; d >= 0; d--) {
        var index = $pos.index(d);

        if ($pos.node(d).canReplaceWith(index, index, nodeType)) {
          return $pos.before(d + 1);
        }

        if (index > 0) {
          return null;
        }
      }
    }

    if ($pos.parentOffset == $pos.parent.content.size) {
      for (var d$1 = $pos.depth - 1; d$1 >= 0; d$1--) {
        var index$1 = $pos.indexAfter(d$1);

        if ($pos.node(d$1).canReplaceWith(index$1, index$1, nodeType)) {
          return $pos.after(d$1 + 1);
        }

        if (index$1 < $pos.node(d$1).childCount) {
          return null;
        }
      }
    }
  } // :: (Node, number, Slice) → ?number
  // Finds a position at or around the given position where the given
  // slice can be inserted. Will look at parent nodes' nearest boundary
  // and try there, even if the original position wasn't directly at the
  // start or end of that node. Returns null when no position was found.


  function dropPoint(doc, pos, slice) {
    var $pos = doc.resolve(pos);

    if (!slice.content.size) {
      return pos;
    }

    var content = slice.content;

    for (var i = 0; i < slice.openStart; i++) {
      content = content.firstChild.content;
    }

    for (var pass = 1; pass <= (slice.openStart == 0 && slice.size ? 2 : 1); pass++) {
      for (var d = $pos.depth; d >= 0; d--) {
        var bias = d == $pos.depth ? 0 : $pos.pos <= ($pos.start(d + 1) + $pos.end(d + 1)) / 2 ? -1 : 1;
        var insertPos = $pos.index(d) + (bias > 0 ? 1 : 0);

        if (pass == 1 ? $pos.node(d).canReplace(insertPos, insertPos, content) : $pos.node(d).contentMatchAt(insertPos).findWrapping(content.firstChild.type)) {
          return bias == 0 ? $pos.pos : bias < 0 ? $pos.before(d + 1) : $pos.after(d + 1);
        }
      }
    }

    return null;
  }

  function mapFragment(fragment, f, parent) {
    var mapped = [];

    for (var i = 0; i < fragment.childCount; i++) {
      var child = fragment.child(i);

      if (child.content.size) {
        child = child.copy(mapFragment(child.content, f, child));
      }

      if (child.isInline) {
        child = f(child, parent, i);
      }

      mapped.push(child);
    }

    return dist.Fragment.fromArray(mapped);
  } // ::- Add a mark to all inline content between two positions.


  var AddMarkStep = function (Step$$1) {
    function AddMarkStep(from, to, mark) {
      Step$$1.call(this);
      this.from = from;
      this.to = to;
      this.mark = mark;
    }

    if (Step$$1) AddMarkStep.__proto__ = Step$$1;
    AddMarkStep.prototype = Object.create(Step$$1 && Step$$1.prototype);
    AddMarkStep.prototype.constructor = AddMarkStep;

    AddMarkStep.prototype.apply = function apply(doc) {
      var this$1 = this;
      var oldSlice = doc.slice(this.from, this.to),
          $from = doc.resolve(this.from);
      var parent = $from.node($from.sharedDepth(this.to));
      var slice = new dist.Slice(mapFragment(oldSlice.content, function (node, parent) {
        if (!parent.type.allowsMarkType(this$1.mark.type)) {
          return node;
        }

        return node.mark(this$1.mark.addToSet(node.marks));
      }, parent), oldSlice.openStart, oldSlice.openEnd);
      return StepResult.fromReplace(doc, this.from, this.to, slice);
    };

    AddMarkStep.prototype.invert = function invert() {
      return new RemoveMarkStep(this.from, this.to, this.mark);
    };

    AddMarkStep.prototype.map = function map(mapping) {
      var from = mapping.mapResult(this.from, 1),
          to = mapping.mapResult(this.to, -1);

      if (from.deleted && to.deleted || from.pos >= to.pos) {
        return null;
      }

      return new AddMarkStep(from.pos, to.pos, this.mark);
    };

    AddMarkStep.prototype.merge = function merge(other) {
      if (other instanceof AddMarkStep && other.mark.eq(this.mark) && this.from <= other.to && this.to >= other.from) {
        return new AddMarkStep(Math.min(this.from, other.from), Math.max(this.to, other.to), this.mark);
      }
    };

    AddMarkStep.prototype.toJSON = function toJSON() {
      return {
        stepType: "addMark",
        mark: this.mark.toJSON(),
        from: this.from,
        to: this.to
      };
    };

    AddMarkStep.fromJSON = function fromJSON(schema, json) {
      if (typeof json.from != "number" || typeof json.to != "number") {
        throw new RangeError("Invalid input for AddMarkStep.fromJSON");
      }

      return new AddMarkStep(json.from, json.to, schema.markFromJSON(json.mark));
    };

    return AddMarkStep;
  }(Step);

  Step.jsonID("addMark", AddMarkStep); // ::- Remove a mark from all inline content between two positions.

  var RemoveMarkStep = function (Step$$1) {
    function RemoveMarkStep(from, to, mark) {
      Step$$1.call(this);
      this.from = from;
      this.to = to;
      this.mark = mark;
    }

    if (Step$$1) RemoveMarkStep.__proto__ = Step$$1;
    RemoveMarkStep.prototype = Object.create(Step$$1 && Step$$1.prototype);
    RemoveMarkStep.prototype.constructor = RemoveMarkStep;

    RemoveMarkStep.prototype.apply = function apply(doc) {
      var this$1 = this;
      var oldSlice = doc.slice(this.from, this.to);
      var slice = new dist.Slice(mapFragment(oldSlice.content, function (node) {
        return node.mark(this$1.mark.removeFromSet(node.marks));
      }), oldSlice.openStart, oldSlice.openEnd);
      return StepResult.fromReplace(doc, this.from, this.to, slice);
    };

    RemoveMarkStep.prototype.invert = function invert() {
      return new AddMarkStep(this.from, this.to, this.mark);
    };

    RemoveMarkStep.prototype.map = function map(mapping) {
      var from = mapping.mapResult(this.from, 1),
          to = mapping.mapResult(this.to, -1);

      if (from.deleted && to.deleted || from.pos >= to.pos) {
        return null;
      }

      return new RemoveMarkStep(from.pos, to.pos, this.mark);
    };

    RemoveMarkStep.prototype.merge = function merge(other) {
      if (other instanceof RemoveMarkStep && other.mark.eq(this.mark) && this.from <= other.to && this.to >= other.from) {
        return new RemoveMarkStep(Math.min(this.from, other.from), Math.max(this.to, other.to), this.mark);
      }
    };

    RemoveMarkStep.prototype.toJSON = function toJSON() {
      return {
        stepType: "removeMark",
        mark: this.mark.toJSON(),
        from: this.from,
        to: this.to
      };
    };

    RemoveMarkStep.fromJSON = function fromJSON(schema, json) {
      if (typeof json.from != "number" || typeof json.to != "number") {
        throw new RangeError("Invalid input for RemoveMarkStep.fromJSON");
      }

      return new RemoveMarkStep(json.from, json.to, schema.markFromJSON(json.mark));
    };

    return RemoveMarkStep;
  }(Step);

  Step.jsonID("removeMark", RemoveMarkStep); // :: (number, number, Mark) → this
  // Add the given mark to the inline content between `from` and `to`.

  Transform.prototype.addMark = function (from, to, mark) {
    var this$1 = this;
    var removed = [],
        added = [],
        removing = null,
        adding = null;
    this.doc.nodesBetween(from, to, function (node, pos, parent) {
      if (!node.isInline) {
        return;
      }

      var marks = node.marks;

      if (!mark.isInSet(marks) && parent.type.allowsMarkType(mark.type)) {
        var start = Math.max(pos, from),
            end = Math.min(pos + node.nodeSize, to);
        var newSet = mark.addToSet(marks);

        for (var i = 0; i < marks.length; i++) {
          if (!marks[i].isInSet(newSet)) {
            if (removing && removing.to == start && removing.mark.eq(marks[i])) {
              removing.to = end;
            } else {
              removed.push(removing = new RemoveMarkStep(start, end, marks[i]));
            }
          }
        }

        if (adding && adding.to == start) {
          adding.to = end;
        } else {
          added.push(adding = new AddMarkStep(start, end, mark));
        }
      }
    });
    removed.forEach(function (s) {
      return this$1.step(s);
    });
    added.forEach(function (s) {
      return this$1.step(s);
    });
    return this;
  }; // :: (number, number, ?union<Mark, MarkType>) → this
  // Remove marks from inline nodes between `from` and `to`. When `mark`
  // is a single mark, remove precisely that mark. When it is a mark type,
  // remove all marks of that type. When it is null, remove all marks of
  // any type.


  Transform.prototype.removeMark = function (from, to, mark) {
    var this$1 = this;
    if (mark === void 0) mark = null;
    var matched = [],
        step = 0;
    this.doc.nodesBetween(from, to, function (node, pos) {
      if (!node.isInline) {
        return;
      }

      step++;
      var toRemove = null;

      if (mark instanceof dist.MarkType) {
        var found = mark.isInSet(node.marks);

        if (found) {
          toRemove = [found];
        }
      } else if (mark) {
        if (mark.isInSet(node.marks)) {
          toRemove = [mark];
        }
      } else {
        toRemove = node.marks;
      }

      if (toRemove && toRemove.length) {
        var end = Math.min(pos + node.nodeSize, to);

        for (var i = 0; i < toRemove.length; i++) {
          var style = toRemove[i],
              found$1 = void 0;

          for (var j = 0; j < matched.length; j++) {
            var m = matched[j];

            if (m.step == step - 1 && style.eq(matched[j].style)) {
              found$1 = m;
            }
          }

          if (found$1) {
            found$1.to = end;
            found$1.step = step;
          } else {
            matched.push({
              style: style,
              from: Math.max(pos, from),
              to: end,
              step: step
            });
          }
        }
      }
    });
    matched.forEach(function (m) {
      return this$1.step(new RemoveMarkStep(m.from, m.to, m.style));
    });
    return this;
  }; // :: (number, NodeType, ?ContentMatch) → this
  // Removes all marks and nodes from the content of the node at `pos`
  // that don't match the given new parent node type. Accepts an
  // optional starting [content match](#model.ContentMatch) as third
  // argument.


  Transform.prototype.clearIncompatible = function (pos, parentType, match) {
    var this$1 = this;
    if (match === void 0) match = parentType.contentMatch;
    var node = this.doc.nodeAt(pos);
    var delSteps = [],
        cur = pos + 1;

    for (var i = 0; i < node.childCount; i++) {
      var child = node.child(i),
          end = cur + child.nodeSize;
      var allowed = match.matchType(child.type, child.attrs);

      if (!allowed) {
        delSteps.push(new ReplaceStep(cur, end, dist.Slice.empty));
      } else {
        match = allowed;

        for (var j = 0; j < child.marks.length; j++) {
          if (!parentType.allowsMarkType(child.marks[j].type)) {
            this$1.step(new RemoveMarkStep(cur, end, child.marks[j]));
          }
        }
      }

      cur = end;
    }

    if (!match.validEnd) {
      var fill = match.fillBefore(dist.Fragment.empty, true);
      this.replace(cur, cur, new dist.Slice(fill, 0, 0));
    }

    for (var i$1 = delSteps.length - 1; i$1 >= 0; i$1--) {
      this$1.step(delSteps[i$1]);
    }

    return this;
  }; // :: (Node, number, ?number, ?Slice) → ?Step
  // ‘Fit’ a slice into a given position in the document, producing a
  // [step](#transform.Step) that inserts it. Will return null if
  // there's no meaningful way to insert the slice here, or inserting it
  // would be a no-op (an empty slice over an empty range).


  function replaceStep(doc, from, to, slice) {
    if (to === void 0) to = from;
    if (slice === void 0) slice = dist.Slice.empty;

    if (from == to && !slice.size) {
      return null;
    }

    var $from = doc.resolve(from),
        $to = doc.resolve(to); // Optimization -- avoid work if it's obvious that it's not needed.

    if (fitsTrivially($from, $to, slice)) {
      return new ReplaceStep(from, to, slice);
    }

    var placed = placeSlice($from, slice);
    var fittedLeft = fitLeft($from, placed);
    var fitted = fitRight($from, $to, fittedLeft);

    if (!fitted) {
      return null;
    }

    if (fittedLeft.size != fitted.size && canMoveText($from, $to, fittedLeft)) {
      var d = $to.depth,
          after = $to.after(d);

      while (d > 1 && after == $to.end(--d)) {
        ++after;
      }

      var fittedAfter = fitRight($from, doc.resolve(after), fittedLeft);

      if (fittedAfter) {
        return new ReplaceAroundStep(from, after, to, $to.end(), fittedAfter, fittedLeft.size);
      }
    }

    return fitted.size || from != to ? new ReplaceStep(from, to, fitted) : null;
  } // :: (number, ?number, ?Slice) → this
  // Replace the part of the document between `from` and `to` with the
  // given `slice`.


  Transform.prototype.replace = function (from, to, slice) {
    if (to === void 0) to = from;
    if (slice === void 0) slice = dist.Slice.empty;
    var step = replaceStep(this.doc, from, to, slice);

    if (step) {
      this.step(step);
    }

    return this;
  }; // :: (number, number, union<Fragment, Node, [Node]>) → this
  // Replace the given range with the given content, which may be a
  // fragment, node, or array of nodes.


  Transform.prototype.replaceWith = function (from, to, content) {
    return this.replace(from, to, new dist.Slice(dist.Fragment.from(content), 0, 0));
  }; // :: (number, number) → this
  // Delete the content between the given positions.


  Transform.prototype.delete = function (from, to) {
    return this.replace(from, to, dist.Slice.empty);
  }; // :: (number, union<Fragment, Node, [Node]>) → this
  // Insert the given content at the given position.


  Transform.prototype.insert = function (pos, content) {
    return this.replaceWith(pos, pos, content);
  };

  function fitLeftInner($from, depth, placed, placedBelow) {
    var content = dist.Fragment.empty,
        openEnd = 0,
        placedHere = placed[depth];

    if ($from.depth > depth) {
      var inner = fitLeftInner($from, depth + 1, placed, placedBelow || placedHere);
      openEnd = inner.openEnd + 1;
      content = dist.Fragment.from($from.node(depth + 1).copy(inner.content));
    }

    if (placedHere) {
      content = content.append(placedHere.content);
      openEnd = placedHere.openEnd;
    }

    if (placedBelow) {
      content = content.append($from.node(depth).contentMatchAt($from.indexAfter(depth)).fillBefore(dist.Fragment.empty, true));
      openEnd = 0;
    }

    return {
      content: content,
      openEnd: openEnd
    };
  }

  function fitLeft($from, placed) {
    var ref = fitLeftInner($from, 0, placed, false);
    var content = ref.content;
    var openEnd = ref.openEnd;
    return new dist.Slice(content, $from.depth, openEnd || 0);
  }

  function fitRightJoin(content, parent, $from, $to, depth, openStart, openEnd) {
    var match,
        count = content.childCount,
        matchCount = count - (openEnd > 0 ? 1 : 0);
    var parentNode = openStart < 0 ? parent : $from.node(depth);

    if (openStart < 0) {
      match = parentNode.contentMatchAt(matchCount);
    } else if (count == 1 && openEnd > 0) {
      match = parentNode.contentMatchAt(openStart ? $from.index(depth) : $from.indexAfter(depth));
    } else {
      match = parentNode.contentMatchAt($from.indexAfter(depth)).matchFragment(content, count > 0 && openStart ? 1 : 0, matchCount);
    }

    var toNode = $to.node(depth);

    if (openEnd > 0 && depth < $to.depth) {
      var after = toNode.content.cutByIndex($to.indexAfter(depth)).addToStart(content.lastChild);
      var joinable$1 = match.fillBefore(after, true); // Can't insert content if there's a single node stretched across this gap

      if (joinable$1 && joinable$1.size && openStart > 0 && count == 1) {
        joinable$1 = null;
      }

      if (joinable$1) {
        var inner = fitRightJoin(content.lastChild.content, content.lastChild, $from, $to, depth + 1, count == 1 ? openStart - 1 : -1, openEnd - 1);

        if (inner) {
          var last = content.lastChild.copy(inner);

          if (joinable$1.size) {
            return content.cutByIndex(0, count - 1).append(joinable$1).addToEnd(last);
          } else {
            return content.replaceChild(count - 1, last);
          }
        }
      }
    }

    if (openEnd > 0) {
      match = match.matchType((count == 1 && openStart > 0 ? $from.node(depth + 1) : content.lastChild).type);
    } // If we're here, the next level can't be joined, so we see what
    // happens if we leave it open.


    var toIndex = $to.index(depth);

    if (toIndex == toNode.childCount && !toNode.type.compatibleContent(parent.type)) {
      return null;
    }

    var joinable = match.fillBefore(toNode.content, true, toIndex);

    for (var i = toIndex; joinable && i < toNode.content.childCount; i++) {
      if (!parentNode.type.allowsMarks(toNode.content.child(i).marks)) {
        joinable = null;
      }
    }

    if (!joinable) {
      return null;
    }

    if (openEnd > 0) {
      var closed = fitRightClosed(content.lastChild, openEnd - 1, $from, depth + 1, count == 1 ? openStart - 1 : -1);
      content = content.replaceChild(count - 1, closed);
    }

    content = content.append(joinable);

    if ($to.depth > depth) {
      content = content.addToEnd(fitRightSeparate($to, depth + 1));
    }

    return content;
  }

  function fitRightClosed(node, openEnd, $from, depth, openStart) {
    var match,
        content = node.content,
        count = content.childCount;

    if (openStart >= 0) {
      match = $from.node(depth).contentMatchAt($from.indexAfter(depth)).matchFragment(content, openStart > 0 ? 1 : 0, count);
    } else {
      match = node.contentMatchAt(count);
    }

    if (openEnd > 0) {
      var closed = fitRightClosed(content.lastChild, openEnd - 1, $from, depth + 1, count == 1 ? openStart - 1 : -1);
      content = content.replaceChild(count - 1, closed);
    }

    return node.copy(content.append(match.fillBefore(dist.Fragment.empty, true)));
  }

  function fitRightSeparate($to, depth) {
    var node = $to.node(depth);
    var fill = node.contentMatchAt(0).fillBefore(node.content, true, $to.index(depth));

    if ($to.depth > depth) {
      fill = fill.addToEnd(fitRightSeparate($to, depth + 1));
    }

    return node.copy(fill);
  }

  function normalizeSlice(content, openStart, openEnd) {
    while (openStart > 0 && openEnd > 0 && content.childCount == 1) {
      content = content.firstChild.content;
      openStart--;
      openEnd--;
    }

    return new dist.Slice(content, openStart, openEnd);
  } // : (ResolvedPos, ResolvedPos, number, Slice) → Slice


  function fitRight($from, $to, slice) {
    var fitted = fitRightJoin(slice.content, $from.node(0), $from, $to, 0, slice.openStart, slice.openEnd);

    if (!fitted) {
      return null;
    }

    return normalizeSlice(fitted, slice.openStart, $to.depth);
  }

  function fitsTrivially($from, $to, slice) {
    return !slice.openStart && !slice.openEnd && $from.start() == $to.start() && $from.parent.canReplace($from.index(), $to.index(), slice.content);
  }

  function canMoveText($from, $to, slice) {
    if (!$to.parent.isTextblock) {
      return false;
    }

    var parent = slice.openEnd ? nodeRight(slice.content, slice.openEnd) : $from.node($from.depth - (slice.openStart - slice.openEnd));

    if (!parent.isTextblock) {
      return false;
    }

    for (var i = $to.index(); i < $to.parent.childCount; i++) {
      if (!parent.type.allowsMarks($to.parent.child(i).marks)) {
        return false;
      }
    }

    var match;

    if (slice.openEnd) {
      match = parent.contentMatchAt(parent.childCount);
    } else {
      match = parent.contentMatchAt(parent.childCount);

      if (slice.size) {
        match = match.matchFragment(slice.content, slice.openStart ? 1 : 0);
      }
    }

    match = match.matchFragment($to.parent.content, $to.index());
    return match && match.validEnd;
  }

  function nodeRight(content, depth) {
    for (var i = 1; i < depth; i++) {
      content = content.lastChild.content;
    }

    return content.lastChild;
  } // Algorithm for 'placing' the elements of a slice into a gap:
  //
  // We consider the content of each node that is open to the left to be
  // independently placeable. I.e. in <p("foo"), p("bar")>, when the
  // paragraph on the left is open, "foo" can be placed (somewhere on
  // the left side of the replacement gap) independently from p("bar").
  //
  // So placeSlice splits up a slice into a number of sub-slices,
  // along with information on where they can be placed on the given
  // left-side edge. It works by walking the open side of the slice,
  // from the inside out, and trying to find a landing spot for each
  // element, by simultaneously scanning over the gap side. When no
  // place is found for an open node's content, it is left in that node.
  // : (ResolvedPos, Slice) → [{content: Fragment, openEnd: number, depth: number}]


  function placeSlice($from, slice) {
    var frontier = new Frontier($from);

    for (var pass = 1; slice.size && pass <= 3; pass++) {
      slice = frontier.placeSlice(slice.content, slice.openStart, slice.openEnd, pass);
    }

    while (frontier.open.length) {
      frontier.closeNode();
    }

    return frontier.placed;
  } // Helper class that models the open side of the insert position,
  // keeping track of the content match and already inserted content
  // at each depth.


  var Frontier = function Frontier($pos) {
    var this$1 = this; // : [{parent: Node, match: ContentMatch, content: Fragment, wrapper: bool, openEnd: number, depth: number}]

    this.open = [];

    for (var d = 0; d <= $pos.depth; d++) {
      var parent = $pos.node(d),
          match = parent.contentMatchAt($pos.indexAfter(d));
      this$1.open.push({
        parent: parent,
        match: match,
        content: dist.Fragment.empty,
        wrapper: false,
        openEnd: 0,
        depth: d
      });
    }

    this.placed = [];
  }; // : (Fragment, number, number, number, ?Node) → Slice
  // Tries to place the content of the given slice, and returns a
  // slice containing unplaced content.
  //
  // pass 1: try to fit directly
  // pass 2: allow wrapper nodes to be introduced
  // pass 3: allow unwrapping of nodes that aren't open


  Frontier.prototype.placeSlice = function placeSlice(fragment, openStart, openEnd, pass, parent) {
    var this$1 = this;

    if (openStart > 0) {
      var first = fragment.firstChild;
      var inner = this.placeSlice(first.content, Math.max(0, openStart - 1), openEnd && fragment.childCount == 1 ? openEnd - 1 : 0, pass, first);

      if (inner.content != first.content) {
        if (inner.content.size) {
          fragment = fragment.replaceChild(0, first.copy(inner.content));
          openStart = inner.openStart + 1;
        } else {
          if (fragment.childCount == 1) {
            openEnd = 0;
          }

          fragment = fragment.cutByIndex(1);
          openStart = 0;
        }
      }
    }

    var result = this.placeContent(fragment, openStart, openEnd, pass, parent);

    if (pass > 2 && result.size && openStart == 0) {
      for (var i = 0; i < result.content.childCount; i++) {
        var child = result.content.child(i);
        this$1.placeContent(child.content, 0, openEnd && i == result.content.childCount.length - 1 ? openEnd - 1 : 0, pass, child);
      }

      result = dist.Fragment.empty;
    }

    return result;
  };

  Frontier.prototype.placeContent = function placeContent(fragment, openStart, openEnd, pass, parent) {
    var this$1 = this;
    var i = 0; // Go over the fragment's children

    for (; i < fragment.childCount; i++) {
      var child = fragment.child(i),
          placed = false,
          last = i == fragment.childCount - 1; // Try each open node in turn, starting from the innermost

      for (var d = this.open.length - 1; d >= 0; d--) {
        var open = this$1.open[d],
            wrap = void 0; // If pass > 1, it is allowed to wrap the node to help find a
        // fit, so if findWrappeing returns something, we add open
        // nodes to the frontier for that wrapping.

        if (pass > 1 && (wrap = open.match.findWrapping(child.type)) && !(parent && wrap.length && wrap[wrap.length - 1] == parent.type)) {
          while (this.open.length - 1 > d) {
            this$1.closeNode();
          }

          for (var w = 0; w < wrap.length; w++) {
            open.match = open.match.matchType(wrap[w]);
            d++;
            open = {
              parent: wrap[w].create(),
              match: wrap[w].contentMatch,
              content: dist.Fragment.empty,
              wrapper: true,
              openEnd: 0,
              depth: d + w
            };
            this$1.open.push(open);
          }
        } // See if the child fits here


        var match = open.match.matchType(child.type);

        if (!match) {
          var fill = open.match.fillBefore(dist.Fragment.from(child));

          if (fill) {
            for (var j = 0; j < fill.childCount; j++) {
              var ch = fill.child(j);
              this$1.addNode(open, ch, 0);
              match = open.match.matchFragment(ch);
            }
          } else if (parent && open.match.matchType(parent.type)) {
            // Don't continue looking further up if the parent node
            // would fit here.
            break;
          } else {
            continue;
          }
        } // Close open nodes above this one, since we're starting to
        // add to this.


        while (this.open.length - 1 > d) {
          this$1.closeNode();
        } // Strip marks from the child or close its start when necessary


        child = child.mark(open.parent.type.allowedMarks(child.marks));

        if (openStart) {
          child = closeNodeStart(child, openStart, last ? openEnd : 0);
          openStart = 0;
        } // Add the child to this open node and adjust its metadata


        this$1.addNode(open, child, last ? openEnd : 0);
        open.match = match;

        if (last) {
          openEnd = 0;
        }

        placed = true;
        break;
      } // As soon as we've failed to place a node we stop looking at
      // later nodes


      if (!placed) {
        break;
      }
    } // Close the current open node if it's not the the root and we
    // either placed up to the end of the node or the the current
    // slice depth's node type matches the open node's type


    if (this.open.length > 1 && (i > 0 && i == fragment.childCount || parent && this.open[this.open.length - 1].parent.type == parent.type)) {
      this.closeNode();
    }

    return new dist.Slice(fragment.cutByIndex(i), openStart, openEnd);
  };

  Frontier.prototype.addNode = function addNode(open, node, openEnd) {
    open.content = closeFragmentEnd(open.content, open.openEnd).addToEnd(node);
    open.openEnd = openEnd;
  };

  Frontier.prototype.closeNode = function closeNode() {
    var open = this.open.pop();

    if (open.content.size == 0) ; else if (open.wrapper) {
      this.addNode(this.open[this.open.length - 1], open.parent.copy(open.content), open.openEnd + 1);
    } else {
      this.placed[open.depth] = {
        depth: open.depth,
        content: open.content,
        openEnd: open.openEnd
      };
    }
  };

  function closeNodeStart(node, openStart, openEnd) {
    var content = node.content;

    if (openStart > 1) {
      var first = closeNodeStart(node.firstChild, openStart - 1, node.childCount == 1 ? openEnd - 1 : 0);
      content = node.content.replaceChild(0, first);
    }

    var fill = node.type.contentMatch.fillBefore(content, openEnd == 0);
    return node.copy(fill.append(content));
  }

  function closeNodeEnd(node, depth) {
    var content = node.content;

    if (depth > 1) {
      var last = closeNodeEnd(node.lastChild, depth - 1);
      content = node.content.replaceChild(node.childCount - 1, last);
    }

    var fill = node.contentMatchAt(node.childCount).fillBefore(dist.Fragment.empty, true);
    return node.copy(content.append(fill));
  }

  function closeFragmentEnd(fragment, depth) {
    return depth ? fragment.replaceChild(fragment.childCount - 1, closeNodeEnd(fragment.lastChild, depth)) : fragment;
  } // :: (number, number, Slice) → this
  // Replace a range of the document with a given slice, using `from`,
  // `to`, and the slice's [`openStart`](#model.Slice.openStart) property
  // as hints, rather than fixed start and end points. This method may
  // grow the replaced area or close open nodes in the slice in order to
  // get a fit that is more in line with WYSIWYG expectations, by
  // dropping fully covered parent nodes of the replaced region when
  // they are marked [non-defining](#model.NodeSpec.defining), or
  // including an open parent node from the slice that _is_ marked as
  // [defining](#model.NodeSpec.defining).
  //
  // This is the method, for example, to handle paste. The similar
  // [`replace`](#transform.Transform.replace) method is a more
  // primitive tool which will _not_ move the start and end of its given
  // range, and is useful in situations where you need more precise
  // control over what happens.


  Transform.prototype.replaceRange = function (from, to, slice) {
    var this$1 = this;

    if (!slice.size) {
      return this.deleteRange(from, to);
    }

    var $from = this.doc.resolve(from),
        $to = this.doc.resolve(to);

    if (fitsTrivially($from, $to, slice)) {
      return this.step(new ReplaceStep(from, to, slice));
    }

    var targetDepths = coveredDepths($from, this.doc.resolve(to)); // Can't replace the whole document, so remove 0 if it's present

    if (targetDepths[targetDepths.length - 1] == 0) {
      targetDepths.pop();
    } // Negative numbers represent not expansion over the whole node at
    // that depth, but replacing from $from.before(-D) to $to.pos.


    var preferredTarget = -($from.depth + 1);
    targetDepths.unshift(preferredTarget); // This loop picks a preferred target depth, if one of the covering
    // depths is not outside of a defining node, and adds negative
    // depths for any depth that has $from at its start and does not
    // cross a defining node.

    for (var d = $from.depth, pos = $from.pos - 1; d > 0; d--, pos--) {
      var spec = $from.node(d).type.spec;

      if (spec.defining || spec.isolating) {
        break;
      }

      if (targetDepths.indexOf(d) > -1) {
        preferredTarget = d;
      } else if ($from.before(d) == pos) {
        targetDepths.splice(1, 0, -d);
      }
    } // Try to fit each possible depth of the slice into each possible
    // target depth, starting with the preferred depths.


    var preferredTargetIndex = targetDepths.indexOf(preferredTarget);
    var leftNodes = [],
        preferredDepth = slice.openStart;

    for (var content = slice.content, i = 0;; i++) {
      var node = content.firstChild;
      leftNodes.push(node);

      if (i == slice.openStart) {
        break;
      }

      content = node.content;
    } // Back up if the node directly above openStart, or the node above
    // that separated only by a non-defining textblock node, is defining.


    if (preferredDepth > 0 && leftNodes[preferredDepth - 1].type.spec.defining && $from.node(preferredTargetIndex).type != leftNodes[preferredDepth - 1].type) {
      preferredDepth -= 1;
    } else if (preferredDepth >= 2 && leftNodes[preferredDepth - 1].isTextblock && leftNodes[preferredDepth - 2].type.spec.defining && $from.node(preferredTargetIndex).type != leftNodes[preferredDepth - 2].type) {
      preferredDepth -= 2;
    }

    for (var j = slice.openStart; j >= 0; j--) {
      var openDepth = (j + preferredDepth + 1) % (slice.openStart + 1);
      var insert = leftNodes[openDepth];

      if (!insert) {
        continue;
      }

      for (var i$1 = 0; i$1 < targetDepths.length; i$1++) {
        // Loop over possible expansion levels, starting with the
        // preferred one
        var targetDepth = targetDepths[(i$1 + preferredTargetIndex) % targetDepths.length],
            expand = true;

        if (targetDepth < 0) {
          expand = false;
          targetDepth = -targetDepth;
        }

        var parent = $from.node(targetDepth - 1),
            index = $from.index(targetDepth - 1);

        if (parent.canReplaceWith(index, index, insert.type, insert.marks)) {
          return this$1.replace($from.before(targetDepth), expand ? $to.after(targetDepth) : to, new dist.Slice(closeFragment(slice.content, 0, slice.openStart, openDepth), openDepth, slice.openEnd));
        }
      }
    }

    return this.replace(from, to, slice);
  };

  function closeFragment(fragment, depth, oldOpen, newOpen, parent) {
    if (depth < oldOpen) {
      var first = fragment.firstChild;
      fragment = fragment.replaceChild(0, first.copy(closeFragment(first.content, depth + 1, oldOpen, newOpen, first)));
    }

    if (depth > newOpen) {
      fragment = parent.contentMatchAt(0).fillBefore(fragment, true).append(fragment);
    }

    return fragment;
  } // :: (number, number, Node) → this
  // Replace the given range with a node, but use `from` and `to` as
  // hints, rather than precise positions. When from and to are the same
  // and are at the start or end of a parent node in which the given
  // node doesn't fit, this method may _move_ them out towards a parent
  // that does allow the given node to be placed. When the given range
  // completely covers a parent node, this method may completely replace
  // that parent node.


  Transform.prototype.replaceRangeWith = function (from, to, node) {
    if (!node.isInline && from == to && this.doc.resolve(from).parent.content.size) {
      var point = insertPoint(this.doc, from, node.type);

      if (point != null) {
        from = to = point;
      }
    }

    return this.replaceRange(from, to, new dist.Slice(dist.Fragment.from(node), 0, 0));
  }; // :: (number, number) → this
  // Delete the given range, expanding it to cover fully covered
  // parent nodes until a valid replace is found.


  Transform.prototype.deleteRange = function (from, to) {
    var this$1 = this;
    var $from = this.doc.resolve(from),
        $to = this.doc.resolve(to);
    var covered = coveredDepths($from, $to);

    for (var i = 0; i < covered.length; i++) {
      var depth = covered[i],
          last = i == covered.length - 1;

      if (last && depth == 0 || $from.node(depth).type.contentMatch.validEnd) {
        return this$1.delete($from.start(depth), $to.end(depth));
      }

      if (depth > 0 && (last || $from.node(depth - 1).canReplace($from.index(depth - 1), $to.indexAfter(depth - 1)))) {
        return this$1.delete($from.before(depth), $to.after(depth));
      }
    }

    for (var d = 1; d <= $from.depth; d++) {
      if (from - $from.start(d) == $from.depth - d && to > $from.end(d)) {
        return this$1.delete($from.before(d), to);
      }
    }

    return this.delete(from, to);
  }; // : (ResolvedPos, ResolvedPos) → [number]
  // Returns an array of all depths for which $from - $to spans the
  // whole content of the nodes at that depth.


  function coveredDepths($from, $to) {
    var result = [],
        minDepth = Math.min($from.depth, $to.depth);

    for (var d = minDepth; d >= 0; d--) {
      var start = $from.start(d);

      if (start < $from.pos - ($from.depth - d) || $to.end(d) > $to.pos + ($to.depth - d) || $from.node(d).type.spec.isolating || $to.node(d).type.spec.isolating) {
        break;
      }

      if (start == $to.start(d)) {
        result.push(d);
      }
    }

    return result;
  }

  exports.Transform = Transform;
  exports.TransformError = TransformError;
  exports.Step = Step;
  exports.StepResult = StepResult;
  exports.joinPoint = joinPoint;
  exports.canJoin = canJoin;
  exports.canSplit = canSplit;
  exports.insertPoint = insertPoint;
  exports.dropPoint = dropPoint;
  exports.liftTarget = liftTarget;
  exports.findWrapping = findWrapping;
  exports.StepMap = StepMap;
  exports.MapResult = MapResult;
  exports.Mapping = Mapping;
  exports.AddMarkStep = AddMarkStep;
  exports.RemoveMarkStep = RemoveMarkStep;
  exports.ReplaceStep = ReplaceStep;
  exports.ReplaceAroundStep = ReplaceAroundStep;
  exports.replaceStep = replaceStep;
});
unwrapExports(dist$1);
var dist_1$1 = dist$1.Transform;
var dist_2$1 = dist$1.TransformError;
var dist_3$1 = dist$1.Step;
var dist_4$1 = dist$1.StepResult;
var dist_5$1 = dist$1.joinPoint;
var dist_6$1 = dist$1.canJoin;
var dist_7$1 = dist$1.canSplit;
var dist_8$1 = dist$1.insertPoint;
var dist_9$1 = dist$1.dropPoint;
var dist_10$1 = dist$1.liftTarget;
var dist_11$1 = dist$1.findWrapping;
var dist_12$1 = dist$1.StepMap;
var dist_13$1 = dist$1.MapResult;
var dist_14 = dist$1.Mapping;
var dist_15 = dist$1.AddMarkStep;
var dist_16 = dist$1.RemoveMarkStep;
var dist_17 = dist$1.ReplaceStep;
var dist_18 = dist$1.ReplaceAroundStep;
var dist_19 = dist$1.replaceStep;

const olDOM = ["ol", 0],
      ulDOM = ["ul", 0],
      liDOM = ["li", 0]; // :: NodeSpec
// An ordered list [node spec](#model.NodeSpec). Has a single
// attribute, `order`, which determines the number at which the list
// starts counting, and defaults to 1. Represented as an `<ol>`
// element.

const orderedList = {
  attrs: {
    order: {
      default: 1
    }
  },
  parseDOM: [{
    tag: "ol",

    getAttrs(dom) {
      return {
        order: dom.hasAttribute("start") ? +dom.getAttribute("start") : 1
      };
    }

  }],

  toDOM(node) {
    return node.attrs.order == 1 ? olDOM : ["ol", {
      start: node.attrs.order
    }, 0];
  }

}; // :: NodeSpec
// A bullet list node spec, represented in the DOM as `<ul>`.

const bulletList = {
  parseDOM: [{
    tag: "ul"
  }],

  toDOM() {
    return ulDOM;
  }

}; // :: NodeSpec
// A list item (`<li>`) spec.

const listItem = {
  parseDOM: [{
    tag: "li"
  }],

  toDOM() {
    return liDOM;
  },

  defining: true
};

var listNodes = {
  ordered_list: _objectSpread({}, orderedList, {
    attrs: _objectSpread({}, orderedList.attrs, {
      listStyle: {
        default: null
      },
      indent: {
        default: 0
      },
      columns: {
        default: 1
      }
    }),
    content: 'list_item+',
    group: 'block',
    parseDOM: [{
      tag: "ol",
      getAttrs: function getAttrs(dom) {
        var listStyle = dom.getAttribute("class");
        return {
          order: dom.hasAttribute("start") ? +dom.getAttribute("start") : 1,
          listStyle: listStyle
        };
      }
    }],
    toDOM: function toDOM(node) {
      var attrs = {};
      var classNames = [];
      if (node.attrs.order != 1) attrs.start = node.attrs.order;

      if (node.attrs.listStyle) {
        classNames.push(node.attrs.listStyle);

        switch (node.attrs.listStyle) {
          case 'decimal':
            attrs.type = '1';
            break;

          case 'lower-alpha':
            attrs.type = 'a';
            break;

          case 'lower-roman':
            attrs.type = 'i';
            break;

          case 'upper-alpha':
            attrs.type = 'A';
            break;

          case 'upper-roman':
            attrs.type = 'I';
            break;
        }
      }

      if (node.attrs.indent !== 0) attrs.style = "margin-left: ".concat(node.attrs.indent * 30, "px");

      if (node.attrs.columns !== 1) {
        classNames.push("list-columns-".concat(node.attrs.columns));
      }

      attrs.class = classNames.join(' ');
      return ["ol", attrs, 0];
    }
  }),
  bullet_list: _objectSpread({}, bulletList, {
    attrs: _objectSpread({}, bulletList.attrs, {
      listStyle: {
        default: null
      },
      indent: {
        default: 0
      },
      columns: {
        default: 1
      }
    }),
    parseDOM: [{
      tag: "ul",
      getAttrs: function getAttrs(dom) {
        return {
          listStyle: dom.getAttribute("class")
        };
      }
    }],
    toDOM: function toDOM(node) {
      var attrs = {};
      var classNames = [];

      if (node.attrs.listStyle) {
        classNames.push(node.attrs.listStyle);
      }

      if (node.attrs.indent !== 0) {
        attrs.style = "margin-left: ".concat(node.attrs.indent * 30, "px");
      }

      if (node.attrs.columns !== 1) {
        classNames.push("list-columns-".concat(node.attrs.columns));
      }

      attrs.class = classNames.join(' ');
      return ["ul", attrs, 0];
    },
    content: 'list_item+',
    group: 'block'
  }),
  list_item: _objectSpread({}, listItem, {
    content: 'block+'
  })
};

function parseBorderSpec(spec) {
  if (!spec) return 0;
  var width = parseInt(spec);
  if (isNaN(width)) return 1;
  return width;
}

function getCellBorders(dom) {
  var _dom$style = dom.style,
      borderLeft = _dom$style.borderLeft,
      borderTop = _dom$style.borderTop,
      borderRight = _dom$style.borderRight,
      borderBottom = _dom$style.borderBottom;

  if (borderLeft || borderTop || borderRight || borderBottom) {
    return [parseBorderSpec(borderLeft), parseBorderSpec(borderTop), parseBorderSpec(borderRight), parseBorderSpec(borderBottom)];
  }

  var borderWidth = dom.style.borderWidth;

  if (borderWidth) {
    var b = borderWidth.split(' ').map(parseInt);

    var _b = _slicedToArray(b, 4),
        top = _b[0],
        right = _b[1],
        bottom = _b[2],
        left = _b[3];

    switch (b.length) {
      case 1:
        return [top, top, top, top];

      case 2:
        return [right, top, right, top];

      case 3:
        return [right, top, right, bottom];

      case 4:
        return [left, top, right, bottom];
    }
  }

  var border = dom.style.border;

  if (border) {
    var _b2 = parseBorderSpec(border);

    return [_b2, _b2, _b2, _b2];
  }

  return [0, 0, 0, 0];
}

function getCellAttrs(dom) {
  var widthAttr = dom.getAttribute("data-colwidth");
  var widths = widthAttr && /^\d+(,\d+)*$/.test(widthAttr) ? widthAttr.split(",").map(function (s) {
    return Number(s);
  }) : null;
  var colspan = Number(dom.getAttribute("colspan") || 1);
  var alignment = dom.style.textAlign || null;
  var vAlign = dom.style.verticalAlign || null;
  var color = /color-(\w+)/.exec(dom.getAttribute('class'));
  var borders = getCellBorders(dom);
  return {
    colspan: colspan,
    alignment: alignment,
    vAlign: vAlign,
    rowspan: Number(dom.getAttribute("rowspan") || 1),
    colwidth: widths && widths.length === colspan ? widths : null,
    borders: borders,
    color: color
  };
}

function setCellAttrs(node) {
  var attrs = {
    style: ''
  };
  if (node.attrs.colspan !== 1) attrs.colspan = node.attrs.colspan;
  if (node.attrs.rowspan !== 1) attrs.rowspan = node.attrs.rowspan;
  if (node.attrs.alignment) attrs.style += "text-align:".concat(node.attrs.alignment, ";");
  if (node.attrs.vAlign) attrs.style += "vertical-align:".concat(node.attrs.vAlign, ";");

  if (node.attrs.colwidth) {
    var totalWidth = node.attrs.colwidth.reduce(function (acc, cur) {
      return acc + cur;
    });
    attrs.style += "width:".concat(totalWidth, "px;");
    attrs["data-colwidth"] = node.attrs.colwidth.join(",");
  }

  if (node.attrs.borders[0]) attrs.style += "border-left:".concat(node.attrs.borders[0], "px solid black;");
  if (node.attrs.borders[1]) attrs.style += "border-top:".concat(node.attrs.borders[1], "px solid black;");
  if (node.attrs.borders[2]) attrs.style += "border-right:".concat(node.attrs.borders[2], "px solid black;");
  if (node.attrs.borders[3]) attrs.style += "border-bottom:".concat(node.attrs.borders[3], "px solid black;");
  if (node.attrs.color) attrs.class = "color-".concat(node.attrs.color);
  return attrs;
}

function getTableAttrs(dom) {
  var attrs = {
    presentationOnly: dom.getAttribute('role') === 'presentation',
    fixedWidth: /px/i.test(dom.style.width),
    squareCells: /square-cells/i.test(dom.getAttribute('class'))
  };

  if (dom.style.margin != null) {
    if (dom.style.marginRight) attrs.alignment = 'left';else if (dom.style.marginLeft) attrs.alignment = 'right';else attrs.alignment = 'center';
  }

  return attrs;
}

function setTableAttrs(node) {
  var attrs = {};
  var style;

  switch (node.attrs.alignment) {
    case 'left':
      style = 'margin: 0; margin-right:auto;';
      break;

    case 'center':
      style = 'margin: 0 auto;';
      break;

    case 'right':
      style = 'margin: 0; margin-left:auto;';
      break;

    default:
      style = null;
      break;
  }

  if (node.attrs.fixedWidth && node.firstChild) {
    var totalWidth = 0; // Get overall table width from first row

    node.firstChild.forEach(function (cell) {
      if (!Array.isArray(cell.attrs.colwidth)) return;
      totalWidth += cell.attrs.colwidth.reduce(function (acc, next) {
        return acc + next;
      });
    });

    if (totalWidth > 0) {
      if (style) style += "width: ".concat(totalWidth, "px;");else style = "width: ".concat(totalWidth, "px;");
    }
  }

  if (style) attrs.style = style;
  if (node.attrs.presentationOnly) attrs.role = "presentation";
  if (node.attrs.squareCells) attrs.class = 'square-cells';
  return attrs;
}

var cellAttrs = {
  colspan: {
    default: 1
  },
  rowspan: {
    default: 1
  },
  colwidth: {
    default: null
  },
  alignment: {
    default: null
  },
  vAlign: {
    default: null
  },
  borders: {
    default: [0, 0, 0, 0]
  },
  // [LEFT, TOP, RIGHT, BOTTOM]
  color: {
    default: null
  }
};
var tableNodes = {
  table: {
    content: "table_row+",
    attrs: {
      alignment: {
        default: null
      },
      presentationOnly: {
        default: false
      },
      fixedWidth: {
        default: false
      },
      squareCells: {
        default: false
      }
    },
    tableRole: "table",
    isolating: true,
    group: 'block',
    parseDOM: [{
      tag: "table",
      getAttrs: getTableAttrs
    }],
    toDOM: function toDOM(node) {
      return ["table", setTableAttrs(node), ["tbody", 0]];
    }
  },
  table_row: {
    content: "(table_cell | table_header)*",
    tableRole: "row",
    parseDOM: [{
      tag: "tr"
    }],
    toDOM: function toDOM() {
      return ["tr", 0];
    }
  },
  table_cell: {
    content: 'block+',
    attrs: cellAttrs,
    tableRole: "cell",
    isolating: true,
    parseDOM: [{
      tag: "td",
      getAttrs: function getAttrs(dom) {
        return getCellAttrs(dom);
      }
    }],
    toDOM: function toDOM(node) {
      return ["td", setCellAttrs(node), 0];
    }
  },
  table_header: {
    content: 'block+',
    attrs: cellAttrs,
    tableRole: "header_cell",
    isolating: true,
    parseDOM: [{
      tag: "th",
      getAttrs: function getAttrs(dom) {
        return getCellAttrs(dom);
      }
    }],
    toDOM: function toDOM(node) {
      return ["th", setCellAttrs(node), 0];
    }
  }
};

var getColumnAttrs = function getColumnAttrs(dom) {
  var classNames = dom.getAttribute('class');
  if (!classNames) return false;
  var match = /col(-.{2})?-(\d+)/g.exec(classNames);
  if (!match) return false;
  var attrs = {
    breakpoint: match[1] ? match[1].slice(1) : '',
    width: parseInt(match[2])
  };
  match = /col-align-(\w+)/g.exec(classNames);
  if (match) attrs.vAlign = match[1];
  return attrs;
};

var setColumnAttrs = function setColumnAttrs(_ref) {
  var breakpoint = _ref.breakpoint,
      width = _ref.width,
      alignment = _ref.alignment,
      vAlign = _ref.vAlign,
      borderWidth = _ref.borderWidth;
  var breakpointClass = breakpoint ? "".concat(breakpoint, "-") : '';
  var attrs = {
    class: "col-".concat(breakpointClass).concat(width)
  };
  var style = '';
  if (alignment) style += "text-align:".concat(alignment, ";");
  if (borderWidth > 0) style += "border: ".concat(borderWidth, "px solid black;");
  if (vAlign) attrs.class += " col-align-".concat(vAlign);
  if (style !== '') attrs.style = style;
  return attrs;
};

var columnNodes = {
  columnSet: {
    group: 'block',
    content: 'column{2,}',
    parseDOM: [{
      tag: 'div.row'
    }],
    toDOM: function toDOM(node) {
      return ['div', {
        class: 'row'
      }, 0];
    }
  },
  column: {
    attrs: {
      breakpoint: {
        default: 'sm'
      },
      width: {
        default: 1
      },
      borderWidth: {
        default: 0
      },
      alignment: {
        default: null
      },
      vAlign: {
        default: null
      }
    },
    content: 'block+',
    isolating: true,
    selectable: false,
    parseDOM: [{
      tag: 'div',
      getAttrs: getColumnAttrs
    }],
    toDOM: function toDOM(node) {
      return ['div', setColumnAttrs(node.attrs), 0];
    }
  }
};

var endpointNodes = {
  nodeEbooksOnly: {
    group: 'block',
    content: 'block+',
    parseDOM: [{
      tag: 'div.ebooksOnly'
    }],
    toDOM: function toDOM() {
      return ['div', {
        class: 'ebooksOnly'
      }, 0];
    }
  },
  nodeHomeworkOnly: {
    group: 'block',
    content: 'block+',
    parseDOM: [{
      tag: 'div.homeworkOnly'
    }],
    toDOM: function toDOM() {
      return ['div', {
        class: 'homeworkOnly'
      }, 0];
    }
  }
};

var mathNotesNodes = {
  mathNotes: {
    group: 'block',
    content: 'anchor? block+',
    toDOM: function toDOM() {
      return ['div', {
        class: 'sidebar'
      }, 0];
    },
    parseDOM: [{
      tag: 'div.sidebar'
    }]
  }
};

function getAttrs$2(dom) {
  return {
    elementType: dom.getAttribute('element-type') || dom.getAttribute('elementType'),
    problemId: dom.getAttribute('problem-id') || dom.getAttribute('problemId'),
    title: dom.getAttribute('problem-title') || dom.getAttribute('title')
  };
}

function setAttrs$2(attrs) {
  return {
    class: 'problemReference',
    'element-type': attrs.elementType,
    'problem-id': attrs.problemId,
    'problem-title': attrs.title
  };
}

var problemNodes = {
  cpmProblem: {
    attrs: {
      elementType: {
        default: 'problem'
      },
      problemId: {
        default: null
      },
      title: {
        default: null
      }
    },
    group: 'block',
    draggable: true,
    toDOM: function toDOM(node) {
      return ['div', setAttrs$2(node.attrs)];
    },
    parseDOM: [{
      tag: 'div.problemReference',
      getAttrs: getAttrs$2,
      priority: 60
    }, {
      tag: 'div.answerReference',
      getAttrs: getAttrs$2,
      priority: 60
    }]
  }
};

var getAttrs$3 = function getAttrs(containerType) {
  return function (dom) {
    return {
      containerType: containerType || dom.getAttribute('container-type'),
      containerId: dom.getAttribute('problem-id') || dom.getAttribute('problemId') || dom.getAttribute('container-id'),
      elementType: dom.getAttribute('element-type') || dom.getAttribute('elementType')
    };
  };
};

var setAttrs$3 = function setAttrs(_ref) {
  var containerType = _ref.containerType,
      containerId = _ref.containerId,
      elementType = _ref.elementType;
  return {
    class: 'contentContainerReference',
    'container-type': containerType,
    'container-id': containerId,
    'element-type': elementType
  };
};

var containerNodes = {
  contentContainerReference: {
    attrs: {
      containerType: {},
      containerId: {},
      elementType: {}
    },
    group: 'block',
    draggable: true,
    toDOM: function toDOM(node) {
      return ['div', setAttrs$3(node.attrs)];
    },
    parseDOM: [{
      tag: 'div.problemReference',
      getAttrs: getAttrs$3('lessonContentContainer'),
      priority: 61
    }, {
      tag: 'div.answerReference',
      getAttrs: getAttrs$3('lessonContentContainer'),
      priority: 61
    }, {
      tag: 'div.contentContainerReference',
      getAttrs: getAttrs$3(),
      priority: 61
    }]
  }
};

function getHintAttrs(dom) {
  var attrs = {
    id: dom.getAttribute('hint-id')
  };
  var color = /color-(\w+)/.exec(dom.getAttribute('class'));
  if (color) attrs.color = color[1];
  return attrs;
}

function setHintAttrs(attrs) {
  var id = attrs.id,
      color = attrs.color;
  var className = 'homeworkHint homeworkOnly';
  if (color) className += " color-".concat(color);
  return {
    class: className,
    'hint-id': id
  };
}

function getTargetAttrs(dom) {
  return {
    hintID: dom.getAttribute('hint-id'),
    offsetLeft: parseInt(dom.style.marginLeft, 10) || 0,
    offsetTop: parseInt(dom.style.marginTop, 10) || 0
  };
}

function setTargetAttrs(_ref) {
  var hintID = _ref.hintID,
      offsetLeft = _ref.offsetLeft,
      offsetTop = _ref.offsetTop;
  var attrs = {
    class: 'homeworkContainer homeworkOnly',
    'hint-id': hintID
  };
  var style = '';
  if (offsetLeft) style += "margin-left:".concat(offsetLeft, "px;");
  if (offsetTop) style += "margin-top:".concat(offsetTop, "px;");
  if (style !== '') attrs.style = style;
  return attrs;
}

var homeworkHintNodes = {
  homeworkHint: {
    attrs: {
      id: {},
      color: {
        default: null
      }
    },
    marks: '',
    group: 'block',
    content: 'text*',
    draggable: true,
    toDOM: function toDOM(node) {
      return ['label', setHintAttrs(node.attrs), ['input', {
        type: 'checkbox'
      }], ['span', {}, 0]];
    },
    parseDOM: [{
      tag: 'label.homeworkHint',
      getAttrs: getHintAttrs,
      priority: 60
    }]
  },
  homeworkHintTarget: {
    attrs: {
      hintID: {},
      offsetLeft: {
        default: 0
      },
      offsetTop: {
        default: 0
      }
    },
    marks: '',
    group: 'block',
    content: 'block+',
    draggable: true,
    toDOM: function toDOM(node) {
      return ['div', setTargetAttrs(node.attrs), 0];
    },
    parseDOM: [{
      tag: 'div.homeworkContainer',
      getAttrs: getTargetAttrs,
      priority: 60
    }]
  },
  homeworkSequenceContainer: {
    group: 'block',
    content: 'block+',
    isolating: true,
    parseDOM: [{
      tag: 'div.sequence-container',
      priority: 60
    }],
    toDOM: function toDOM(node) {
      return ['div', {
        class: 'sequence-container homeworkOnly'
      }, 0];
    }
  }
};

var homeworkLinkNodes = {
  homeworkLink: {
    inline: true,
    attrs: {},
    marks: '',
    group: 'inline',
    draggable: true,
    leaf: true,
    parseDOM: [{
      tag: 'a[href]',
      getAttrs: function getAttrs(dom) {
        var href = dom.getAttribute('href');

        if (href) {
          if (href.indexOf('http://homework.cpm.org') !== -1 || href.indexOf('https://homework.cpm.org') !== -1) {
            return {
              href: href
            };
          }
        }

        return false;
      },
      priority: 60
    }, {
      tag: 'a.homework-link',
      priority: 60
    }],
    toDOM: function toDOM(node) {
      return ['a', {
        href: '#',
        class: 'homework-link ebooksOnly'
      }, "Homework Help \u270E"];
    }
  }
};

var offsetNodes = {
  offset: {
    attrs: {
      offsetLeft: {
        default: 0
      },
      offsetTop: {
        default: 0
      }
    },
    marks: '',
    group: 'block',
    content: 'block+',
    draggable: true,
    toDOM: function toDOM(_ref) {
      var _ref$attrs = _ref.attrs,
          offsetLeft = _ref$attrs.offsetLeft,
          offsetTop = _ref$attrs.offsetTop;
      return ['div', {
        style: "margin-left: ".concat(offsetLeft, "px; margin-top: ").concat(offsetTop, "px;")
      }, 0];
    }
  }
};

function getAttrs$4(dom) {
  var attrs = {
    bookId: dom.getAttribute('data-book-id'),
    src: dom.getAttribute('data-src'),
    type: dom.getAttribute('data-type') || 'graph',
    state: JSON.parse(dom.getAttribute('data-state')),
    degreeMode: dom.getAttribute('data-degree-mode') === 'true',
    fullscreen: dom.getAttribute('data-fullscreen')
  };

  if (dom.style.width) {
    attrs.width = parseInt(dom.style.width, 10);
  }

  if (dom.style.height) {
    attrs.height = parseInt(dom.style.height, 10);
  }

  return attrs;
}

function setAttrs$4(attrs) {
  var domAttrs = {
    class: 'desmos-calculator',
    'data-src': attrs.src,
    'data-type': attrs.type,
    'data-state': JSON.stringify(attrs.state),
    'data-degree-mode': attrs.degreeMode ? 'true' : 'false',
    'data-fullscreen': attrs.fullscreen,
    style: ''
  };

  if (attrs.bookId) {
    domAttrs.class += ' bookSpecificContent';
    domAttrs['data-book-id'] = attrs.bookId;
  }

  if (attrs.width) {
    domAttrs.style += "width:".concat(attrs.width, "px; ");
  }

  if (attrs.height) {
    domAttrs.style += "height:".concat(attrs.height, "px; ");
  }

  return domAttrs;
}

var desmosNodes = {
  desmos: {
    group: 'block',
    draggable: true,
    attrs: {
      bookId: {
        default: null
      },
      src: {
        default: null
      },
      type: {
        default: 'graph'
      },
      state: {
        default: null
      },
      degreeMode: {
        default: null
      },
      fullscreen: {
        default: false
      },
      width: {
        default: 300
      },
      height: {
        default: 300
      }
    },
    toDOM: function toDOM(node) {
      return ['div', setAttrs$4(node.attrs)];
    },
    parseDOM: [{
      tag: 'div.desmos-calculator',
      getAttrs: getAttrs$4
    }]
  }
};

function getAttrs$5(dom) {
  var allow = dom.getAttribute('allow');
  var attrs = {
    src: dom.getAttribute('src'),
    title: dom.getAttribute('title'),
    fullscreen: allow && allow.includes('fullscreen') || !!dom.getAttribute('allowfullscreen')
  };

  if (dom.style.width !== '100%') {
    attrs.width = parseInt(dom.style.width, 10);
  }

  if (dom.style.height !== '300px') {
    attrs.height = parseInt(dom.style.height, 10);
  }

  return attrs;
}

function setAttrs$5(attrs) {
  var domAttrs = {
    'src': attrs.src,
    'title': attrs.title,
    style: ''
  };

  if (attrs.width > 0) {
    domAttrs.style += "width:".concat(attrs.width, "px; ");
  } else {
    domAttrs.style += 'width:100%; ';
  }

  if (attrs.height > 0) {
    domAttrs.style += "height:".concat(attrs.height, "px; ");
  } else {
    domAttrs.style += "height:".concat(300, "px; ");
  }

  if (attrs.fullscreen) {
    domAttrs.allow = "fullscreen";
    domAttrs.allowfullscreen = true;
  }

  return domAttrs;
}

var embedNodes = {
  embed: {
    group: 'inline',
    inline: true,
    attrs: {
      src: {
        default: null
      },
      title: {
        default: null
      },
      width: {
        default: null
      },
      height: {
        default: null
      },
      fullscreen: {
        default: true
      }
    },
    toDOM: function toDOM(node) {
      return ['iframe', setAttrs$5(node.attrs)];
    },
    parseDOM: [{
      tag: 'iframe',
      getAttrs: getAttrs$5
    }]
  }
};

function getAttrs$6(dom) {
  var attrs = {
    'media-id': dom.getAttribute('media-id'),
    'legacy-src': dom.getAttribute('legacy-src'),
    align: dom.getAttribute('align'),
    width: dom.getAttribute('width'),
    height: dom.getAttribute('height')
  };

  if (dom.style.width) {
    attrs.width = parseInt(dom.style.width, 10);
  }

  if (dom.style.height) {
    attrs.height = parseInt(dom.style.height, 10);
  }

  if (dom.style.borderWidth) {
    attrs.border = parseInt(dom.style.borderWidth, 10);
  }

  if (dom.style.border) {
    attrs.border = parseInt(dom.style.border, 10);
  }

  if (dom.style.marginLeft) {
    attrs.horizontalPadding = parseInt(dom.style.marginLeft, 10);
  }

  if (dom.style.marginTop) {
    attrs.verticalPadding = parseInt(dom.style.marginTop, 10);
  }

  if (dom.style.cssFloat) {
    attrs.align = dom.style.cssFloat;
  }

  if (dom.style.verticalAlign) {
    attrs.vAlign = dom.style.verticalAlign;
  }

  var color = /color-(\w+)/.exec(dom.getAttribute('class'));
  if (color) attrs.color = color[1];
  return attrs;
}

function setAttrs$6(attrs) {
  var domAttrs = {
    'media-id': attrs['media-id'],
    'legacy-src': attrs['legacy-src']
  };
  var style = '';

  if (attrs.border) {
    style += "border:".concat(attrs.border, "px solid black; ");
  }

  if (attrs.width) {
    style += "width:".concat(attrs.width, "px; ");
  }

  if (attrs.height) {
    style += "height:".concat(attrs.height, "px; ");
  }

  if (attrs.align) {
    style += "float:".concat(attrs.align, "; ");
  }

  if (attrs.vAlign) {
    style += "vertical-align:".concat(attrs.vAlign, "; ");
  }

  if (attrs.horizontalPadding || attrs.verticalPadding) {
    style += "margin:".concat(attrs.verticalPadding || 0, "px ").concat(attrs.horizontalPadding || 0, "px; ");
  }

  if (style) domAttrs.style = style;
  if (attrs.color) domAttrs.class = "color-".concat(attrs.color);
  return domAttrs;
}

var mediaNodes = {
  media: {
    inline: true,
    attrs: {
      'media-id': {},
      'legacy-src': {
        default: null
      },
      align: {
        default: null
      },
      vAlign: {
        default: null
      },
      border: {
        default: null
      },
      width: {
        default: null
      },
      height: {
        default: null
      },
      horizontalPadding: {
        default: null
      },
      verticalPadding: {
        default: null
      },
      color: {
        default: null
      }
    },
    marks: '',
    group: 'inline',
    draggable: true,
    parseDOM: [{
      tag: 'c3po-media',
      getAttrs: getAttrs$6
    }],
    toDOM: function toDOM(node) {
      return ['c3po-media', setAttrs$6(node.attrs)];
    }
  }
};

var toDOM = function toDOM(node) {
  var _node$attrs = node.attrs,
      number = _node$attrs.number,
      title = _node$attrs.title,
      subtitle = _node$attrs.subtitle;
  var outputSpec = ['header', {
    class: 'lessonTitle'
  }];

  if (node.attrs['media-id']) {
    var _ref;

    // Title image (media)
    var _node$attrs$mediaOff = node.attrs['media-offset'],
        left = _node$attrs$mediaOff.left,
        top = _node$attrs$mediaOff.top;
    var mediaStyle = "width:".concat(node.attrs['media-scale'], ";");
    if (left !== 0) mediaStyle += "margin-right:".concat(-left, "px;");
    if (top !== 0) mediaStyle += "margin-top:".concat(top, "px;");
    outputSpec.push(['c3po-media', (_ref = {}, _defineProperty(_ref, 'media-id', node.attrs['media-id']), _defineProperty(_ref, "style", mediaStyle), _ref)]);
  } // Title


  outputSpec.push(['h1', {}, ['span', {
    class: 'lessonNumber'
  }, number], title]); // Subtitle

  outputSpec.push(['p', {}, subtitle]);
  return outputSpec;
};

var parseDOM = [{
  tag: 'header.lessonTitle',
  getAttrs: function getAttrs(dom) {
    var attrs = {};
    var media = dom.getElementsByTagName('c3po-media')[0];

    if (media) {
      attrs['media-id'] = media.getAttribute('media-id');
      attrs['media-scale'] = media.style.width;
    }

    var h1 = dom.getElementsByTagName('h1')[0];

    if (h1) {
      var titleText = Array.from(h1.childNodes).find(function (n) {
        return n.nodeName === '#text';
      });
      if (titleText) attrs.title = titleText.nodeValue;
      var number = h1.getElementsByClassName('lessonNumber')[0];
      if (number) attrs.number = number.textContent;
    }

    var p = dom.getElementsByTagName('p')[0];
    if (p) attrs.subtitle = p.textContent;
    return attrs;
  }
}];
var lessonTitleNodes = {
  lessonTitle: {
    attrs: {
      number: {
        default: ''
      },
      title: {
        default: ''
      },
      subtitle: {
        default: ''
      },
      'media-id': {
        default: ''
      },
      'media-scale': {
        default: ''
      },
      'media-offset': {
        default: {
          left: 0,
          top: 0
        }
      }
    },
    group: 'block',
    draggable: true,
    toDOM: toDOM,
    parseDOM: parseDOM
  }
};

var importerMetadataNodes = {
  importerMetadata: {
    attrs: {
      contentType: {}
    },
    group: 'block',
    content: 'anchor? block+',
    toDOM: function toDOM(node) {
      return ['div', {
        class: 'importer-metadata',
        'data-content-type': node.attrs.contentType
      }, 0];
    },
    parseDOM: [{
      tag: 'div.importer-metadata',
      getAttrs: function getAttrs(dom) {
        return {
          contentType: dom.getAttribute('data-content-type')
        };
      }
    }]
  }
};

var nodes$1 = _objectSpread({}, baseNodes, anchorNodes, assessmentNodes, listNodes, tableNodes, columnNodes, endpointNodes, mathNotesNodes, problemNodes, containerNodes, homeworkHintNodes, homeworkLinkNodes, offsetNodes, desmosNodes, embedNodes, mediaNodes, lessonTitleNodes, importerMetadataNodes);

var linkMarks = {
  link: {
    attrs: {
      href: {},
      title: {
        default: null
      },
      target: {
        default: null
      }
    },
    excludes: 'link glossaryLink',
    parseDOM: [{
      tag: "a[href]",
      getAttrs: function getAttrs(dom) {
        return {
          href: dom.getAttribute("href"),
          title: dom.getAttribute("title"),
          target: dom.getAttribute("target")
        };
      }
    }],
    toDOM: function toDOM(node) {
      var domAttrs = Object.assign({}, node.attrs);

      if (node.attrs.target === '_blank') {
        domAttrs.rel = "noopener";
      }

      return ["a", domAttrs];
    }
  }
};

var textDecorationMarks = {
  subscript: {
    excludes: 'superscript',
    parseDOM: [{
      tag: 'sub'
    }, {
      style: 'vertical-align=sub'
    }],
    toDOM: function toDOM() {
      return ['sub'];
    }
  },
  superscript: {
    excludes: 'subscript',
    parseDOM: [{
      tag: 'sup'
    }, {
      style: 'vertical-align=super'
    }],
    toDOM: function toDOM() {
      return ['sup'];
    }
  },
  strikethrough: {
    parseDOM: [{
      tag: 'strike'
    }, {
      style: 'text-decoration:line-through'
    }, {
      style: 'text-decoration-line:line-through'
    }],
    toDOM: function toDOM() {
      return ['span', {
        style: 'text-decoration-line:line-through'
      }];
    }
  },
  underline: {
    parseDOM: [{
      tag: 'u'
    }, {
      style: 'text-decoration:underline'
    }],
    toDOM: function toDOM() {
      return ['span', {
        style: 'text-decoration:underline'
      }];
    }
  },
  box: {
    parseDOM: [{
      tag: 'span.inline-box'
    }],
    toDOM: function toDOM() {
      return ['span', {
        class: 'inline-box'
      }, 0];
    }
  },
  highlight: {
    attrs: {
      color: {}
    },
    parseDOM: [{
      tag: 'span',
      getAttrs: function getAttrs(dom) {
        var color = /color-(\w+)/.exec(dom.getAttribute('class'));
        if (color) return {
          color: color[1]
        };
        return false;
      }
    }],
    toDOM: function toDOM(mark) {
      return ['span', {
        class: "color-".concat(mark.attrs.color)
      }];
    }
  },
  font: {
    attrs: {
      fontStyle: {}
    },
    parseDOM: [{
      style: 'font-family',
      getAttrs: function getAttrs(fontStyle) {
        return {
          fontStyle: fontStyle
        };
      }
    }],
    toDOM: function toDOM(mark) {
      return ['span', {
        style: "font-family:".concat(mark.attrs.fontStyle)
      }];
    }
  }
};

var endpointMarks = {
  markEbooksOnly: {
    excludes: 'markHomeworkOnly',
    parseDOM: [{
      tag: 'span.ebooksOnly'
    }],
    toDOM: function toDOM() {
      return ['span', {
        class: 'ebooksOnly'
      }];
    }
  },
  markHomeworkOnly: {
    excludes: 'markEbooksOnly',
    parseDOM: [{
      tag: 'span.homeworkOnly'
    }],
    toDOM: function toDOM() {
      return ['span', {
        class: 'homeworkOnly'
      }];
    }
  },
  markBookSpecific: {
    attrs: {
      bookId: {}
    },
    parseDOM: [{
      tag: 'span.bookSpecificContent',
      getAttrs: function getAttrs(dom) {
        return {
          bookId: dom.getAttribute('data-book-id')
        };
      }
    }],
    toDOM: function toDOM(_ref) {
      var bookId = _ref.attrs.bookId;
      return ['span', {
        class: 'bookSpecificContent',
        'data-book-id': bookId
      }];
    }
  }
};

var accessibilityMarks = {
  markScreenReaderOnly: {
    parseDOM: [{
      tag: 'span.screenReaderOnly'
    }],
    toDOM: function toDOM() {
      return ['span', {
        class: 'screenReaderOnly'
      }];
    }
  }
};

var glossaryMarks = {
  glossaryLink: {
    attrs: {
      id: {}
    },
    inclusive: false,
    excludes: 'link glossaryLink',
    parseDOM: [{
      tag: 'span.glossary-link',
      getAttrs: function getAttrs(dom) {
        return {
          id: dom.getAttribute('data-glossary-item-id')
        };
      }
    }],
    toDOM: function toDOM(_ref) {
      var id = _ref.attrs.id;
      return ['span', {
        class: "glossary-link",
        'data-glossary-item-id': id
      }];
    }
  }
};

var marks$1 = _objectSpread({}, marks, linkMarks, textDecorationMarks, endpointMarks, accessibilityMarks, glossaryMarks);

var index$2 = {
  nodes: nodes$1,
  marks: marks$1
};

module.exports = index$2;
